const bodyScrollLockOptions = {
  reserveScrollBarGap: true,
  allowTouchMove: (el) => {
    return !!el.closest?.('[data-scrollable]');
  },
};

// Define a global function to load a script
window.loadScript = function (url) {
  // Check if the script already exists
  var existingScript = document.querySelector(`script[src="${url}"]`);

  if (existingScript) {
    return;
  }

  // Create a new script element
  var script = document.createElement('script');
  script.src = url;
  document.body.appendChild(script);
};

// Lazily inject videojs.css + video.min.js when a video player actually needs them
window.ensureVideoAssets = function () {
  var stylesheetUrl = window.theme && window.theme.videoStylesheet;
  if (
    stylesheetUrl &&
    !document.querySelector('link[data-videojs-css], link[href*="videojs.css"]')
  ) {
    var link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = stylesheetUrl;
    link.setAttribute("data-videojs-css", "");
    document.head.appendChild(link);
  }

  if (typeof videojs === "undefined" && window.theme && window.theme.videoScript) {
    loadScript(window.theme.videoScript);
  }
};

var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

/**
 * DOM event delegator
 *
 * The delegator will listen
 * for events that bubble up
 * to the root node.
 *
 * @constructor
 * @param {Node|string} [root] The root node or a selector string matching the root node
 */
function Delegate(root) {
  /**
   * Maintain a map of listener
   * lists, keyed by event name.
   *
   * @type Object
   */
  this.listenerMap = [{}, {}];
  if (root) {
    this.root(root);
  }

  /** @type function() */
  this.handle = Delegate.prototype.handle.bind(this);

  // Cache of event listeners removed during an event cycle
  this._removedListeners = [];
}

/**
 * Start listening for events
 * on the provided DOM element
 *
 * @param  {Node|string} [root] The root node or a selector string matching the root node
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.root = function (root) {
  const listenerMap = this.listenerMap;
  let eventType;

  // Remove master event listeners
  if (this.rootElement) {
    for (eventType in listenerMap[1]) {
      if (listenerMap[1].hasOwnProperty(eventType)) {
        this.rootElement.removeEventListener(eventType, this.handle, true);
      }
    }
    for (eventType in listenerMap[0]) {
      if (listenerMap[0].hasOwnProperty(eventType)) {
        this.rootElement.removeEventListener(eventType, this.handle, false);
      }
    }
  }

  // If no root or root is not
  // a dom node, then remove internal
  // root reference and exit here
  if (!root || !root.addEventListener) {
    if (this.rootElement) {
      delete this.rootElement;
    }
    return this;
  }

  /**
   * The root node at which
   * listeners are attached.
   *
   * @type Node
   */
  this.rootElement = root;

  // Set up master event listeners
  for (eventType in listenerMap[1]) {
    if (listenerMap[1].hasOwnProperty(eventType)) {
      // Add the 'passive' option for scroll events
      const isScrollEvent = ["wheel", "mousewheel"].indexOf(eventType) !== -1;
      this.rootElement.addEventListener(eventType, this.handle, { capture: true, passive: isScrollEvent });
    }
  }
  for (eventType in listenerMap[0]) {
    if (listenerMap[0].hasOwnProperty(eventType)) {
      // Add the 'passive' option for scroll events
      const isScrollEvent = ["wheel", "mousewheel"].indexOf(eventType) !== -1;
      this.rootElement.addEventListener(eventType, this.handle, { capture: false, passive: isScrollEvent });
    }
  }

  return this;
};

/**
 * @param {string} eventType
 * @returns boolean
 */
Delegate.prototype.captureForType = function (eventType) {
  return (
    ["blur", "error", "focus", "load", "resize", "scroll"].indexOf(
      eventType
    ) !== -1
  );
};

/**
 * Attach a handler to one
 * event for all elements
 * that match the selector,
 * now or in the future
 *
 * The handler function receives
 * three arguments: the DOM event
 * object, the node that matched
 * the selector while the event
 * was bubbling and a reference
 * to itself. Within the handler,
 * 'this' is equal to the second
 * argument.
 *
 * The node that actually received
 * the event can be accessed via
 * 'event.target'.
 *
 * @param {string} eventType Listen for these events
 * @param {string|undefined} selector Only handle events on elements matching this selector, if undefined match root element
 * @param {function()} handler Handler function - event data passed here will be in event.data
 * @param {boolean} [useCapture] see 'useCapture' in <https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener>
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.on = function (eventType, selector, handler, useCapture) {
  let root;
  let listenerMap;
  let matcher;
  let matcherParam;

  if (!eventType) {
    throw new TypeError("Invalid event type: " + eventType);
  }

  // handler can be passed as
  // the second or third argument
  if (typeof selector === "function") {
    useCapture = handler;
    handler = selector;
    selector = null;
  }

  // Fallback to sensible defaults
  // if useCapture not set
  if (useCapture === undefined) {
    useCapture = this.captureForType(eventType);
  }

  if (typeof handler !== "function") {
    throw new TypeError("Handler must be a type of Function");
  }

  root = this.rootElement;
  listenerMap = this.listenerMap[useCapture ? 1 : 0];
  const isScrollEvent = ["wheel", "mousewheel", "touchstart", "touchmove"].indexOf(eventType) !== -1;

  // Add master handler for type if not created yet
  if (!listenerMap[eventType]) {
    if (root) {
      root.addEventListener(eventType, this.handle, { capture: useCapture, passive: isScrollEvent });
    }
    listenerMap[eventType] = [];
  }

  if (!selector) {
    matcherParam = null;

    // COMPLEX - matchesRoot needs to have access to
    // this.rootElement, so bind the function to this.
    matcher = matchesRoot.bind(this);

    // Compile a matcher for the given selector
  } else if (/^[a-z]+$/i.test(selector)) {
    matcherParam = selector;
    matcher = matchesTag;
  } else if (/^#[a-z0-9\-_]+$/i.test(selector)) {
    matcherParam = selector.slice(1);
    matcher = matchesId;
  } else {
    matcherParam = selector;
    matcher = Element.prototype.matches;
  }

  // Add to the list of listeners
  listenerMap[eventType].push({
    selector: selector,
    handler: handler,
    matcher: matcher,
    matcherParam: matcherParam,
  });

  return this;
};

/**
 * Remove an event handler
 * for elements that match
 * the selector, forever
 *
 * @param {string} [eventType] Remove handlers for events matching this type, considering the other parameters
 * @param {string} [selector] If this parameter is omitted, only handlers which match the other two will be removed
 * @param {function()} [handler] If this parameter is omitted, only handlers which match the previous two will be removed
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.off = function (eventType, selector, handler, useCapture) {
  let i;
  let listener;
  let listenerMap;
  let listenerList;
  let singleEventType;

  // Handler can be passed as
  // the second or third argument
  if (typeof selector === "function") {
    useCapture = handler;
    handler = selector;
    selector = null;
  }

  // If useCapture not set, remove
  // all event listeners
  if (useCapture === undefined) {
    this.off(eventType, selector, handler, true);
    this.off(eventType, selector, handler, false);
    return this;
  }

  listenerMap = this.listenerMap[useCapture ? 1 : 0];
  if (!eventType) {
    for (singleEventType in listenerMap) {
      if (listenerMap.hasOwnProperty(singleEventType)) {
        this.off(singleEventType, selector, handler);
      }
    }

    return this;
  }

  listenerList = listenerMap[eventType];
  if (!listenerList || !listenerList.length) {
    return this;
  }

  // Remove only parameter matches
  // if specified
  for (i = listenerList.length - 1; i >= 0; i--) {
    listener = listenerList[i];

    if (
      (!selector || selector === listener.selector) &&
      (!handler || handler === listener.handler)
    ) {
      this._removedListeners.push(listener);
      listenerList.splice(i, 1);
    }
  }

  // All listeners removed
  if (!listenerList.length) {
    delete listenerMap[eventType];

    // Remove the main handler
    if (this.rootElement) {
      this.rootElement.removeEventListener(eventType, this.handle, useCapture);
    }
  }

  return this;
};

/**
 * Handle an arbitrary event.
 *
 * @param {Event} event
 */
Delegate.prototype.handle = function (event) {
  let i;
  let l;
  const type = event.type;
  let root;
  let phase;
  let listener;
  let returned;
  let listenerList = [];
  let target;
  const eventIgnore = "ftLabsDelegateIgnore";

  if (event[eventIgnore] === true) {
    return;
  }

  target = event.target;

  // Hardcode value of Node.TEXT_NODE
  // as not defined in IE8
  if (target.nodeType === 3) {
    target = target.parentNode;
  }

  // Handle SVG <use> elements in IE
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }

  root = this.rootElement;

  phase = event.eventPhase || (event.target !== event.currentTarget ? 3 : 2);

  // eslint-disable-next-line default-case
  switch (phase) {
    case 1: //Event.CAPTURING_PHASE:
      listenerList = this.listenerMap[1][type];
      break;
    case 2: //Event.AT_TARGET:
      if (this.listenerMap[0] && this.listenerMap[0][type]) {
        listenerList = listenerList.concat(this.listenerMap[0][type]);
      }
      if (this.listenerMap[1] && this.listenerMap[1][type]) {
        listenerList = listenerList.concat(this.listenerMap[1][type]);
      }
      break;
    case 3: //Event.BUBBLING_PHASE:
      listenerList = this.listenerMap[0][type];
      break;
  }

  let toFire = [];

  // Need to continuously check
  // that the specific list is
  // still populated in case one
  // of the callbacks actually
  // causes the list to be destroyed.
  l = listenerList.length;
  while (target && l) {
    for (i = 0; i < l; i++) {
      listener = listenerList[i];

      // Bail from this loop if
      // the length changed and
      // no more listeners are
      // defined between i and l.
      if (!listener) {
        break;
      }

      if (
        target.tagName &&
        ["button", "input", "select", "textarea"].indexOf(
          target.tagName.toLowerCase()
        ) > -1 &&
        target.hasAttribute("disabled")
      ) {
        // Remove things that have previously fired
        toFire = [];
      }
      // Check for match and fire
      // the event if there's one
      //
      // TODO:MCG:20120117: Need a way
      // to check if event#stopImmediatePropagation
      // was called. If so, break both loops.
      else if (listener.matcher.call(target, listener.matcherParam, target)) {
        toFire.push([event, target, listener]);
      }
    }

    // TODO:MCG:20120117: Need a way to
    // check if event#stopPropagation
    // was called. If so, break looping
    // through the DOM. Stop if the
    // delegation root has been reached
    if (target === root) {
      break;
    }

    l = listenerList.length;

    // Fall back to parentNode since SVG children have no parentElement in IE
    target = target.parentElement || target.parentNode;

    // Do not traverse up to document root when using parentNode, though
    if (target instanceof HTMLDocument) {
      break;
    }
  }

  let ret;

  for (i = 0; i < toFire.length; i++) {
    // Has it been removed during while the event function was fired
    if (this._removedListeners.indexOf(toFire[i][2]) > -1) {
      continue;
    }
    returned = this.fire.apply(this, toFire[i]);

    // Stop propagation to subsequent
    // callbacks if the callback returned
    // false
    if (returned === false) {
      toFire[i][0][eventIgnore] = true;
      toFire[i][0].preventDefault();
      ret = false;
      break;
    }
  }

  return ret;
};

/**
 * Fire a listener on a target.
 *
 * @param {Event} event
 * @param {Node} target
 * @param {Object} listener
 * @returns {boolean}
 */
Delegate.prototype.fire = function (event, target, listener) {
  return listener.handler.call(target, event, target);
};

/**
 * Check whether an element
 * matches a tag selector.
 *
 * Tags are NOT case-sensitive,
 * except in XML (and XML-based
 * languages such as XHTML).
 *
 * @param {string} tagName The tag name to test against
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesTag(tagName, element) {
  return tagName.toLowerCase() === element.tagName.toLowerCase();
}

/**
 * Check whether an element
 * matches the root.
 *
 * @param {?String} selector In this case this is always passed through as null and not used
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesRoot(selector, element) {
  if (this.rootElement === window) {
    return (
      // Match the outer document (dispatched from document)
      element === document ||
      // The <html> element (dispatched from document.body or document.documentElement)
      element === document.documentElement ||
      // Or the window itself (dispatched from window)
      element === window
    );
  }
  return this.rootElement === element;
}

/**
 * Check whether the ID of
 * the element in 'this'
 * matches the given ID.
 *
 * IDs are case-sensitive.
 *
 * @param {string} id The ID to test against
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesId(id, element) {
  return id === element.id;
}

/**
 * Short hand for off()
 * and root(), ie both
 * with no parameters
 *
 * @return void
 */
Delegate.prototype.destroy = function () {
  this.off();
  this.root();
};

class Toast {
  static container = null;
  static toasts = [];

  static init() {
    if (!Toast.container) {
      Toast.container = document.getElementById('toast-container');
    }
  }

  static show({ type = 'info', title, message, open_cart_button, duration = window.theme.toast_delay || 3000 }) {
    const cartDrawerEl = document.getElementById('cart-drawer');
    if (cartDrawerEl && cartDrawerEl.getAttribute('aria-expanded') === 'true') {
      return null;
    }

    Toast.init();

    const toast = document.createElement('div');
    toast.className = `toast toast--${type}`;

    toast.innerHTML = `
      <div class="toast__wrapper">
        <div class="toast__content">
          ${title ? `<div class="toast__title u-p2">${title}</div>` : ''}
          ${message ? `<div class="toast__message u-p3">${message}</div>` : ''}
        </div>
        ${open_cart_button ? `
          <button
            class="Button Button--Tertiary u-pb1"
            data-action="toggle-drawer"
            data-toggle-id="cart-drawer"
            type="button"
            tabindex="0"
            aria-label="${open_cart_button}"
            style="--adjustment_m: 0px; --adjustment_d: 0px;"
          >
            <div class="ButtonTextContainer">
              <span class="ButtonText button-top-txt">
                <span class="button-txt u-pb1">${open_cart_button}</span>
              </span>
              <span class="ButtonText button-bottom-txt">
                <span class="button-txt u-pb1">${open_cart_button}</span>
              </span>
            </div>
          </button>
        ` : ''}
      </div>
      
      <button class="toast__close" aria-label="${window.a11yStrings?.close || "Close"}">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4.0625 3.98169C4.34951 3.69476 4.79807 3.66022 5.12402 3.88892L5.1875 3.93872L5.19629 3.94556V3.94653L10.04 8.79614L14.8838 3.95337L14.8926 3.94458L14.9561 3.89575C15.2821 3.66682 15.7315 3.70144 16.0186 3.98853C16.3245 4.29468 16.3429 4.78469 16.0615 5.11353L16.0537 5.12231L11.209 9.96606L16.0537 14.8098L16.0615 14.8186L16.1113 14.8821C16.3401 15.2081 16.3055 15.6575 16.0186 15.9446C15.7123 16.2508 15.2215 16.2692 14.8926 15.9875L14.8838 15.9797L10.04 11.135L5.18945 15.9797L5.18848 15.9788C4.98564 16.2091 4.67306 16.3103 4.37402 16.2385C4.07126 16.1657 3.83463 15.929 3.76172 15.6262C3.68887 15.3234 3.79174 15.0046 4.02832 14.802L8.87012 9.96606L4.02637 5.11548L4.01855 5.10767L4.13281 5.01001L4.01855 5.10669C3.73727 4.77777 3.75643 4.28776 4.0625 3.98169Z" fill="#1B1B1B" stroke="#1B1B1B" stroke-width="0.3"/>
        </svg>
      </button>
    `;

    Toast.container.appendChild(toast);
    Toast.toasts.push(toast);

    const closeButton = toast.querySelector('.toast__close');
    closeButton.addEventListener('click', () => Toast.hide(toast));

    // Add event listener for "View cart" button to hide toast when clicked
    const viewCartButton = toast.querySelector('[data-action="toggle-drawer"]');
    if (viewCartButton) {
      viewCartButton.addEventListener('click', () => Toast.hide(toast));
    }

    setTimeout(() => {
      toast.classList.add('toast--show');
    }, 10);

    if (duration > 0) {
      setTimeout(() => {
        Toast.hide(toast);
      }, duration);
    }

    return toast;
  }

  static hide(toast) {
    toast.classList.remove('toast--show');
    toast.classList.add('toast--hide');

    setTimeout(() => {
      if (toast.parentElement) {
        toast.remove();
        const index = Toast.toasts.indexOf(toast);
        if (index > -1) {
          Toast.toasts.splice(index, 1);
        }
      }
    }, 300);
  }

  static success(title, message, open_cart_button, duration = window.theme.toast_delay || 3000) {
    // Only show success toasts if toast popup is enabled
    if (window.theme.toast_enabled === false) {
      return;
    }
    return Toast.show({ type: 'success', title, message, open_cart_button, duration });
  }

  static error(title, message, duration = window.theme.toast_delay || 3000) {
    return Toast.show({ type: 'error', title, message, duration });
  }

  static warning(title, message, duration = window.theme.toast_delay || 3000) {
    return Toast.show({ type: 'warning', title, message, duration });
  }

  static info(title, message, duration = window.theme.toast_delay || 3000) {
    return Toast.show({ type: 'info', title, message, duration });
  }
}

// Make Toast globally accessible
window.Toast = Toast;
class IOSScrollLock {
  static _preventScroll = null;
  static _preventGesture = null;
  static _touchStart = null;
  static _lockCount = 0;

  static lock() {
    if (this._lockCount === 0) {
      // Store initial touch position
      this._touchStart = (e) => {
        const scrollable = e.target.closest('[data-scrollable]');
        const drawerWrapper = e.target.closest('.Drawer--wrapper');
        const element = scrollable || drawerWrapper;

        if (element && e.touches && e.touches.length > 0) {
          element._startY = e.touches[0].clientY;
          element._startScrollTop = element.scrollTop;
        }
      };

      this._preventScroll = (e) => {
        const drawerWrapper = e.target.closest('.Drawer--wrapper');
        const scrollable = e.target.closest('[data-scrollable]');

        if (drawerWrapper || scrollable) {
          const element = scrollable || drawerWrapper;
          const scrollTop = element.scrollTop;
          const scrollHeight = element.scrollHeight;
          const clientHeight = element.clientHeight;
          const canScroll = scrollHeight > clientHeight;

          // If element can't scroll at all, prevent the event
          if (!canScroll) {
            e.preventDefault();
            return;
          }

          // Check if at scroll boundaries to prevent rubber-banding
          if (element._startY !== undefined && e.touches && e.touches.length > 0) {
            const currentY = e.touches[0].clientY;
            const deltaY = currentY - element._startY;
            const isAtTop = scrollTop <= 0;
            const isAtBottom = scrollTop + clientHeight >= scrollHeight - 1;

            // Prevent scroll if:
            // - At top and trying to scroll down (pull down)
            // - At bottom and trying to scroll up (pull up)
            if ((isAtTop && deltaY > 0) || (isAtBottom && deltaY < 0)) {
              e.preventDefault();
              return;
            }
          }

          return;
        }

        e.preventDefault();
      };

      document.addEventListener('touchstart', this._touchStart, { passive: true });
      document.addEventListener('touchmove', this._preventScroll, { passive: false, capture: true });

      this._preventGesture = (e) => e.preventDefault();
      document.addEventListener('gesturestart', this._preventGesture);
    }
    this._lockCount++;
  }

  static unlock() {
    if (this._lockCount < 0) return;
    this._lockCount--;

    if (this._lockCount === 0) {
      if (this._touchStart) {
        document.removeEventListener('touchstart', this._touchStart, { passive: true });
        this._touchStart = null;
      }

      if (this._preventScroll) {
        document.removeEventListener('touchmove', this._preventScroll, { passive: false, capture: true });
        this._preventScroll = null;
      }

      if (this._preventGesture) {
        document.removeEventListener('gesturestart', this._preventGesture);
        this._preventGesture = null;
      }
    }
  }
}

class GlobalScrollListener {
  constructor() {
    this.callbacks = new Map();
    this.listenerIdCounter = 0;
    this.isListening = false;
    this.boundRunCallbacks = this.runCallbacks.bind(this);
  }

  addScrollListener(classInstance, func) {
    const id = ++this.listenerIdCounter;
    const keyBase = `${classInstance.constructor.name}_${func.name}_${id}`;
    const key = keyBase.replace(/ /g, '_'); // Replace spaces with underscores
    const boundFunction = func.bind(classInstance);

    this.callbacks.set(key, boundFunction);

    if (!this.isListening) {
      window.addEventListener("scroll", this.boundRunCallbacks, { passive: true });
      this.isListening = true;
    }

    return {
      removeScrollListener: () => this.removeScrollListenerFunction(key)
    };
  }

  removeScrollListenerFunction(key) {
    if (this.callbacks.has(key)) {
      this.callbacks.delete(key);
    }

    if (this.callbacks.size === 0 && this.isListening) {
      window.removeEventListener("scroll", this.boundRunCallbacks);
      this.isListening = false;
    }
  }

  runCallbacks() {
    this.callbacks.forEach(callback => callback());
  }
}

const scrollListener = new GlobalScrollListener();

class Responsive {
  constructor(enableGeneralBreakpointChange, trackWindowHeight) {
    this.settings();

    this.trackWindowHeight = trackWindowHeight;
    this.generalBreakpointChange = enableGeneralBreakpointChange;
    this.currentBreakpoint = this.getCurrentBreakpoint();
    this.breakpointListeners = new Map(); // Stores listeners with their status
    this.resizeCallbacks = new Map();
    this.listenerIdCounter = 0;

    this.setWindowHeight();
    this.initResizeListener();
  }

  initResizeListener() {
    this.boundHandleResize = this.handleResize.bind(this);
    window.addEventListener("resize", this.boundHandleResize);
  }

  settings() {
    this.matchBreakpoints = {
      phone: "(max-width: 640px)",
      tablet: "(min-width: 641px) and (max-width: 1024px)",
      tablet_and_up: "(min-width: 768px)",
      pocket: "(max-width: 1024px)",
      lap_and_up: "(min-width: 1025px)",
      desktop: "(min-width: 1280px)",
      desktop_wide: "(min-width: 1440px)",
    };

    this.currentBreakpoints = {
      phone: "(max-width: 640px)",
      pocket: "(max-width: 1024px)",
      tablet: "(min-width: 641px) and (max-width: 1024px)",
      desktop: "(min-width: 1025px)",
    };
  }

  handleResize() {
    const newBreakpoint = this.getCurrentBreakpoint();

    if (this.generalBreakpointChange) {
      // Check for general breakpoint change
      if (this.currentBreakpoint !== newBreakpoint) {
        document.dispatchEvent(
          new CustomEvent("breakpoint:changed", {
            detail: {
              previousBreakpoint: this.currentBreakpoint,
              currentBreakpoint: newBreakpoint,
            },
          })
        );
      }
    }

    // Additional check for specific breakpoint
    this.breakpointListeners.forEach((value, key) => {
      const isCurrentlyInBreakpoint = this.matchesBreakpoint(key);
      if (value !== isCurrentlyInBreakpoint) {
        this.breakpointListeners.set(key, isCurrentlyInBreakpoint);
        document.body.dispatchEvent(
          new CustomEvent(`breakpoint:${key}`, {
            detail: {
              matches: isCurrentlyInBreakpoint,
            },
          })
        );
      }
    });

    this.currentBreakpoint = newBreakpoint;

    this.setWindowHeight();

    // Run additional registered resize callbacks
    this.runCallbacks();
  }

  setWindowHeight() {
    if (this.trackWindowHeight) {
      document.documentElement.style.setProperty(
        "--window-height",
        `${window.innerHeight}px`
      );
    }
  }

  matchesBreakpoint(breakpoint) {
    const query = this.matchBreakpoints[breakpoint];
    return window.matchMedia(`screen and ${query}`).matches;
  }

  getCurrentBreakpoint() {
    for (const [key, query] of Object.entries(this.currentBreakpoints)) {
      if (window.matchMedia(`screen and ${query}`).matches) {
        return key;
      }
    }
  }

  addBreakpointListener(breakpoint) {
    if (!this.matchBreakpoints[breakpoint]) {
      console.error("Breakpoint does not exist:", breakpoint);
      return;
    }

    if (this.breakpointListeners.has(breakpoint)) {
      console.warn("Listener already exists for breakpoint:", breakpoint);
      return;
    }

    const isInBreakpoint = this.matchesBreakpoint(breakpoint);
    this.breakpointListeners.set(breakpoint, isInBreakpoint);
  }

  addResizeListener(classInstance, func) {
    const id = ++this.listenerIdCounter;
    const keyBase = `${classInstance.constructor.name}_${func.name}_${id}`;
    const key = keyBase.replace(/ /g, "_"); // Replace spaces with underscores
    const boundFunction = func.bind(classInstance);

    this.resizeCallbacks.set(key, boundFunction);

    return {
      removeResizeListener: () => this.removeResizeListenerFunction(key),
    };
  }

  removeResizeListenerFunction(key) {
    if (this.resizeCallbacks.has(key)) {
      this.resizeCallbacks.delete(key);
    }
  }

  runCallbacks() {
    this.resizeCallbacks.forEach((callback) => callback());
  }
}

const responsive = new Responsive(false, true);

class Popup {
  constructor() {
    this.delegateBody = new Delegate(document.body);
    this.activePopups = [];
    this.onPopupOpen = null;
    this.onPopupClose = null;
    this._openDelayTimeout = null;
    this._docOutsideDropdownHandler = null;
    this._dropdownRepositionHandler = null;

    this.bindEvents();
  }

  _shouldPreserveDrawerForPopup(drawerInstance, popupElement) {
    if (!drawerInstance || !drawerInstance.element || !popupElement) return false;

    const isMobile = window.innerWidth <= 1024;
    if (!isMobile) return false;

    // When opening localization selector from mobile menu,
    // keep the mobile menu (and its subdrawers) open.
    if (popupElement.id === "modal-country") {
      return !!drawerInstance.element.closest("main-menu-dropdown");
    }

    return false;
  }

  bindEvents() {
    this.delegateBody.on("click", '[data-action="toggle-popup"]', this.handleOpenOptions.bind(this));
    this.delegateBody.on("drawer:close-other", this.handleDrawerCloseOther.bind(this));
    this.delegateBody.on("menu:open", this.handleDrawerCloseOther.bind(this));
    this.delegateBody.on("edit-img:open-popup", this.handleOpenOptions.bind(this));
    this.delegateBody.on("keydown", this.handleEscape.bind(this));
  }

  _isDropdown(popupElement) {
    return popupElement?.getAttribute("data-popup-mode") === "dropdown";
  }

  _overlayDisabled(popupElement) {
    return popupElement?.getAttribute("data-overlay") === "none";
  }

  _getOverlayElement(popupElement) {
    const overlayClass = popupElement?.getAttribute("data-overlay");
    if (!overlayClass || overlayClass === "none") return null;
    return document.querySelector(`.${overlayClass}`);
  }

  _getOpenerButton(popupElement, openerButton = null) {
    if (openerButton) return openerButton;
    const id = popupElement?.id;
    if (!id) return null;
    return document.querySelector(`[data-action="toggle-popup"][aria-controls="${CSS.escape(id)}"]`);
  }

  _positionDropdown(popupElement, openerButton) {
    if (!popupElement || !openerButton) return;

    const gap = parseInt(popupElement.getAttribute("data-popup-offset") || "8", 10);
    const btnRect = openerButton.getBoundingClientRect();

    popupElement.style.position = "fixed";
    popupElement.style.zIndex = "9999";
    popupElement.style.left = `${btnRect.left}px`;
    popupElement.style.top = `${btnRect.bottom + gap}px`;

    requestAnimationFrame(() => {
      const pr = popupElement.getBoundingClientRect();
      const maxW = window.innerWidth - 32;
      if (pr.width > maxW) popupElement.style.maxWidth = `${maxW}px`;

      const overflowR = pr.right - (window.innerWidth - 16);
      if (overflowR > 0) {
        popupElement.style.left = `${Math.max(16, btnRect.left - overflowR)}px`;
      }

      const pr2 = popupElement.getBoundingClientRect();
      const overflowB = pr2.bottom - (window.innerHeight - 16);
      if (overflowB > 0) {
        const aboveTop = btnRect.top - gap - pr2.height;
        if (aboveTop >= 16) popupElement.style.top = `${aboveTop}px`;
      }
    });
  }

  _bindDropdownOutsideClose() {
    if (this._docOutsideDropdownHandler) return;

    this._docOutsideDropdownHandler = (e) => {
      const topPopup = this.activePopups[this.activePopups.length - 1];
      if (!topPopup || !this._isDropdown(topPopup)) return;

      const opener = topPopup._openerButton || this._getOpenerButton(topPopup);
      if (topPopup.contains(e.target) || (opener && opener.contains(e.target))) return;

      this.closePopup(topPopup);
    };

    document.addEventListener("click", this._docOutsideDropdownHandler, true);

    this._dropdownRepositionHandler = () => {
      const topPopup = this.activePopups[this.activePopups.length - 1];
      if (!topPopup || !this._isDropdown(topPopup)) return;
      const opener = topPopup._openerButton || this._getOpenerButton(topPopup);
      this._positionDropdown(topPopup, opener);
    };

    window.addEventListener("resize", this._dropdownRepositionHandler);
    window.addEventListener("scroll", this._dropdownRepositionHandler, true);
  }

  _unbindDropdownOutsideCloseIfNone() {
    const anyDropdownOpen = this.activePopups.some((p) => this._isDropdown(p));
    if (anyDropdownOpen) return;

    if (this._docOutsideDropdownHandler) {
      document.removeEventListener("click", this._docOutsideDropdownHandler, true);
      this._docOutsideDropdownHandler = null;
    }

    if (this._dropdownRepositionHandler) {
      window.removeEventListener("resize", this._dropdownRepositionHandler);
      window.removeEventListener("scroll", this._dropdownRepositionHandler, true);
      this._dropdownRepositionHandler = null;
    }
  }

  handleOpenOptions(event) {
    event.stopImmediatePropagation();
    event.preventDefault();

    const toggleBtn = event?.target?.closest?.('[data-action="toggle-popup"]');
    if (isRepeatActivation(toggleBtn, event)) return;

    dynamicVars.syncHeight();

    const toggleButton = event.target.closest('[data-action="toggle-popup"]');
    if (toggleButton) {
      this.togglePopup(toggleButton, event);
      return;
    }

    // overlay click close for non-dropdowns that have overlay
    if (this.activePopups.length) {
      const topPopup = this.activePopups[this.activePopups.length - 1];
      if (this._isDropdown(topPopup) || this._overlayDisabled(topPopup)) return;

      const overlay = this._getOverlayElement(topPopup);
      if (overlay && overlay.contains(event.target)) {
        this.closePopup(topPopup);
      }
    }
  }

  handleEscape(event) {
    if (event.key === "Escape" && this.activePopups.length) {
      event.preventDefault();
      event.stopPropagation();

      const topPopup = this.activePopups[this.activePopups.length - 1];
      const opener = topPopup._openerButton || this._getOpenerButton(topPopup);
      if (opener) opener.click();
      else this.closePopup(topPopup);
    }
  }

  togglePopup(button) {
    const popupId = button.getAttribute("aria-controls");
    if (!popupId) return;

    const popupElement = document.getElementById(popupId);
    if (!popupElement) return;

    const isChild = button.getAttribute("data-child-popup") === "true";

    if (popupElement.getAttribute("aria-hidden") === "false") {
      this.closePopup(popupElement);
    } else {
      this.openPopup(popupElement, isChild, false, button);
    }
  }

  openPopup(popupElement, isChild = false, _skipDelay = false, openerButton = null) {
    const isModalCountry = popupElement.id === "modal-country";
    const isMobile = window.innerWidth <= 1024;
    const isDropdown = this._isDropdown(popupElement);

    const hasNonPreservedDrawerOpen = !!(
      window.Drawer &&
      Drawer.instances &&
      Array.from(Drawer.instances).some((d) => d?.isOpen && !this._shouldPreserveDrawerForPopup(d, popupElement))
    );

    // Unified delay if any other popup/drawer is open
    // (but allow modal-country to open while the mobile menu drawer is open on mobile)
    if (!_skipDelay && (this.activePopups.length > 0 || hasNonPreservedDrawerOpen)) {
      if (this._openDelayTimeout) clearTimeout(this._openDelayTimeout);

      this._closeAllOpenPopupsAndDrawers(isModalCountry, isMobile, openerButton, popupElement);

      this._openDelayTimeout = setTimeout(() => {
        this._openDelayTimeout = null;
        this.openPopup(popupElement, isChild, true, openerButton);
      }, 1000);

      return;
    }

    // Show overlay for NON-dropdown popups (uses data-overlay attribute)
    if (!isDropdown && !this._overlayDisabled(popupElement)) {
      const overlay = this._getOverlayElement(popupElement);
      if (overlay) {
        // Clear any pending close handlers from previous popup
        if (overlay._pendingCloseHandler) {
          overlay.removeEventListener("transitionend", overlay._pendingCloseHandler);
          overlay._pendingCloseHandler = null;
        }
        if (overlay._pendingCloseTimeout) {
          clearTimeout(overlay._pendingCloseTimeout);
          overlay._pendingCloseTimeout = null;
        }

        overlay.style.display = "block";
        requestAnimationFrame(() => overlay.classList.add("is-visible"));
      }
    }

    // Close drawers
    this._closeOpenDrawers(isModalCountry, isMobile, openerButton, popupElement);

    popupElement._isChild = isChild;

    if (!isChild) {
      while (this.activePopups.length) {
        this._closePopup(this.activePopups.pop());
      }
    }

    popupElement._openerButton = this._getOpenerButton(popupElement, openerButton);

    // Tag the popup when opened from the PDP region-selector button so styles
    // can target that specific entry point.
    if (popupElement._openerButton?.classList.contains("pm__button-region--selector")) {
      popupElement.classList.add("pdp__region-selector");
    }

    // Tag the popup when opened from the localization selector button so styles
    // can target that specific entry point.
    if (popupElement._openerButton?.classList.contains("localization-sel__btn")) {
      // Cancel a pending removal from a prior close so a fast reopen keeps the class.
      clearTimeout(popupElement._mmClassTimeout);
      popupElement.classList.add("mobile-menu__modal-country");
    }

    // ---- OPEN ----
    // Clear any pending close handlers from previous close
    if (popupElement._pendingCloseHandler) {
      popupElement.removeEventListener("transitionend", popupElement._pendingCloseHandler);
      popupElement._pendingCloseHandler = null;
    }
    if (popupElement._pendingCloseTimeout) {
      clearTimeout(popupElement._pendingCloseTimeout);
      popupElement._pendingCloseTimeout = null;
    }

    popupElement.style.display = "";
    popupElement.setAttribute("aria-hidden", "true");
    popupElement.setAttribute("aria-expanded", "false");
    popupElement.setAttribute("inert", "");

    popupElement.getBoundingClientRect(); // force reflow

    // if dropdown, position BEFORE opening to avoid jumping
    if (isDropdown) {
      this._positionDropdown(popupElement, popupElement._openerButton);
      this._bindDropdownOutsideClose();
    }

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        popupElement.removeAttribute("inert");
        popupElement.setAttribute("aria-hidden", "false");
        popupElement.setAttribute("aria-expanded", "true");

        if (typeof this.onPopupOpen === "function") this.onPopupOpen(popupElement);

        // scroll lock + focus trap ONLY for non-dropdown
        if (!isDropdown) {
          const focus = popupElement.querySelector("[data-scrollable]");

          if (focus) {
            popupElement._scrollableElement = focus;
            bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
            IOSScrollLock.lock();
          } else if (isModalCountry) {
            popupElement._scrollableElement = null;
            bodyScrollLock.disableBodyScroll(popupElement, bodyScrollLockOptions);
            IOSScrollLock.lock();
          }
          // The popup fades in over 0.25s and is `visibility: hidden` until then.
          // focus() is a no-op on a hidden element, so trapping focus in this frame
          // silently does nothing and focus is left behind on the page (WCAG 2.4.3).
          // Wait for the animation first, the same way Drawer does.
          setTimeout(() => {
            // guard against the popup being closed again before the timer fires
            // (aria-hidden is not reset on close for #modal-country, so check the stack)
            if (this.activePopups.includes(popupElement)) {
              trapFocus(popupElement);
            }
          }, 300);
        }
      });
    });

    // overlay click to close (only non-dropdown + overlay enabled)
    if (!isDropdown && !this._overlayDisabled(popupElement)) {
      const overlay = this._getOverlayElement(popupElement);
      if (overlay) {
        requestAnimationFrame(() => overlay.classList.add("is-visible"));
        const handleOverlayClick = (e) => {
          e.preventDefault();
          this.closePopup(popupElement);
        };
        popupElement._overlayClickHandler = handleOverlayClick;
        overlay.addEventListener("click", handleOverlayClick);
      }
    }

    this.activePopups.push(popupElement);
  }

  _closeAllOpenPopupsAndDrawers(isModalCountry, isMobile, openerButton, popupElement = null) {
    if (window.Drawer && Drawer.instances) {
      Array.from(Drawer.instances).forEach((d) => {
        if (!d || !d.isOpen) return;

        // Preserve mobile menu drawers when opening modal-country on mobile.
        if (popupElement && this._shouldPreserveDrawerForPopup(d, popupElement)) return;

        d.closeDrawer();
      });
    } else if (window.Drawer && typeof Drawer.closeAll === "function") {
      // Drawer.closeAll() can't selectively preserve; fall back to per-instance close
      // when we must preserve mobile menu drawers.
      if (popupElement && isModalCountry && isMobile && window.Drawer && Drawer.instances) {
        Array.from(Drawer.instances).forEach((d) => {
          if (!d || !d.isOpen) return;
          if (this._shouldPreserveDrawerForPopup(d, popupElement)) return;
          d.closeDrawer();
        });
      } else {
        Drawer.closeAll();
      }
    }

    if (window.globalPopup && typeof window.globalPopup.closeAllPopups === "function") {
      window.globalPopup.closeAllPopups();
    } else {
      this.closeAllPopups();
    }
  }

  _closeOpenDrawers(isModalCountry, isMobile, openerButton, popupElement = null) {
    if (isModalCountry && isMobile) {
      // Close any open drawers EXCEPT the mobile menu drawers.
      if (window.Drawer && Drawer.instances) {
        Array.from(Drawer.instances).forEach((d) => {
          if (!d || !d.isOpen) return;
          if (popupElement && this._shouldPreserveDrawerForPopup(d, popupElement)) return;
          d.closeDrawer();
        });
      }
      return;
    }

    if (window.Drawer && Drawer.instances) {
      Array.from(Drawer.instances).forEach((d) => {
        if (!d || !d.isOpen) return;
        d.closeDrawer();
      });
    } else if (window.Drawer && typeof window.Drawer.closeAll === "function") {
      window.Drawer.closeAll();
    } else if (window.Drawer && typeof Drawer.closeAll === "function") {
      Drawer.closeAll();
    }
  }

  closePopup(popupElement) {
    const index = this.activePopups.indexOf(popupElement);
    if (index !== -1) {
      const closedScrollEl = popupElement._scrollableElement;
      this._closePopup(popupElement);
      this.activePopups.splice(index, 1);

      this._unbindDropdownOutsideCloseIfNone();

      if (this.activePopups.length > 0) {
        const topPopup = this.activePopups[this.activePopups.length - 1];
        if (topPopup._scrollableElement) {
          bodyScrollLock.disableBodyScroll(topPopup._scrollableElement, bodyScrollLockOptions);
        }
      } else {
        if (closedScrollEl) bodyScrollLock.enableBodyScroll(closedScrollEl);
      }
    }
  }

  _closePopup(popupElement) {
    const isDropdown = this._isDropdown(popupElement);

    if (popupElement.id !== "modal-country") popupElement.setAttribute("aria-hidden", "true");

    // Hide overlay for NON-dropdown popups (uses data-overlay attribute)
    if (!isDropdown && !this._overlayDisabled(popupElement)) {
      const overlay = this._getOverlayElement(popupElement);
      if (overlay) {
        // Remove click handler
        if (popupElement._overlayClickHandler) {
          overlay.removeEventListener("click", popupElement._overlayClickHandler);
          delete popupElement._overlayClickHandler;
        }

        // Only hide overlay if no other drawers are open
        const anyDrawerOpen =
          window.Drawer &&
          Drawer.instances &&
          Array.from(Drawer.instances).some((d) => d?.isOpen && d.element?.id !== 'mobile-menu-drawer');

        if (!anyDrawerOpen) {
          overlay.classList.remove("is-visible");

          const h = () => {
            overlay.style.display = "none";
            overlay.removeEventListener("transitionend", h);
            overlay._pendingCloseHandler = null;
            if (overlay._pendingCloseTimeout) {
              clearTimeout(overlay._pendingCloseTimeout);
              overlay._pendingCloseTimeout = null;
            }
          };

          overlay._pendingCloseHandler = h;
          overlay.addEventListener("transitionend", h);

          overlay._pendingCloseTimeout = setTimeout(() => {
            overlay.style.display = "none";
            overlay.removeEventListener("transitionend", h);
            overlay._pendingCloseHandler = null;
            overlay._pendingCloseTimeout = null;
          }, 850);
        }
      }
    }

    IOSScrollLock.unlock();

    if (!isDropdown) {
      // Return focus to the control that opened the popup (WCAG 2.4.3). Passing the
      // popup itself would focus an element that is about to be hidden, dropping
      // focus to <body> and sending keyboard users back to the top of the page.
      //
      // Only do this when focus is actually inside the popup. _openerButton is resolved
      // from aria-controls, so it is non-null even when nothing was ever clicked — and a
      // popup that closes during page setup would otherwise throw focus onto its trigger
      // in mid-page, leaving Tab to continue from there instead of the top of the page.
      const focusIsInside = popupElement.contains(document.activeElement);
      const opener = popupElement._openerButton;
      const returnTarget =
        focusIsInside && opener?.isConnected && opener.offsetParent !== null
          ? opener
          : null;
      removeTrapFocus(returnTarget);
    }

    popupElement.setAttribute("aria-expanded", "false");

    const transitionEndHandler = (event) => {
      if (event.target !== popupElement) return;
      popupElement.removeEventListener("transitionend", transitionEndHandler);
      popupElement._pendingCloseHandler = null;
      popupElement.setAttribute("inert", "");
      popupElement.style.display = "none";
      popupElement.classList.remove("pdp__region-selector");
      clearTimeout(popupElement._mmClassTimeout);
      popupElement._mmClassTimeout = setTimeout(() =>
        popupElement.classList.remove("mobile-menu__modal-country")
          , 810);
      if (typeof this.onPopupClose === "function") this.onPopupClose(popupElement);
    };

    popupElement._pendingCloseHandler = transitionEndHandler;
    popupElement.addEventListener("transitionend", transitionEndHandler);

    popupElement._pendingCloseTimeout = setTimeout(() => {
      popupElement.removeEventListener("transitionend", transitionEndHandler);
      popupElement._pendingCloseHandler = null;
      popupElement._pendingCloseTimeout = null;
      popupElement.setAttribute("inert", "");
      popupElement.setAttribute("aria-hidden", "true");
      popupElement.style.display = "none";
      popupElement.classList.remove("pdp__region-selector");
      popupElement.classList.remove("mobile-menu__modal-country");
      if (typeof this.onPopupClose === "function") this.onPopupClose(popupElement);
    }, 900);
  }

  handleDrawerCloseOther(event) {
    event.preventDefault();
    this.closeAllPopups();
  }

  closeAllPopups() {
    while (this.activePopups.length) {
      this._closePopup(this.activePopups.pop());
    }
    this._unbindDropdownOutsideCloseIfNone();
  }
}

window.globalPopup = new Popup();

class dynamicVariables {
  constructor() {
    document.documentElement.style.setProperty(
      "--viewport_width",
      `${document.documentElement.clientWidth}px`
    );

    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`
    );

    responsive.addResizeListener(this, this.sync.bind(this));
  }

  sync() {
    this.syncWidth();
    this.syncHeight();
  }

  syncWidth() {
    document.documentElement.style.setProperty(
      "--viewport_width",
      `${document.documentElement.clientWidth}px`
    );

  }

  syncHeight() {
    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`
    );
  }
}

const dynamicVars = new dynamicVariables();


class RevolutionSelectbox {
  constructor(element, popover, additionalOverlay) {
    this.element = element;
    this.popover = popover;
    this.changeOverlay = additionalOverlay;
    this.domDelegate = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.dropdown = this.element.querySelector(".RevolutionSelectbox");
    this.isOpen = false;

    this.mainDropdown = this.element.querySelector(".RevolutionSelectbox--Content");
    this.mainDropdownContent = this.element.querySelector(
      ".RevolutionSelectbox--InnerContent"
    );
    this.mainButton = this.element.querySelector(".RevolutionSelectbox--Button");

    this.connectedSelect = this.element.getAttribute("data-select");
    this.selectbox = this.element.querySelector("[name=" + this.connectedSelect + "]");
    if (this.selectbox == null) {
      this.selectbox = this.element.querySelector("[name2=" + this.connectedSelect + "]");
    }

    // 🔹 If this instance doesn't actually have proper dropdown markup,
    // don't try to wire it up – just stop here.
    if (!this.mainDropdown || !this.mainButton) {
      return;
    }

    if (this.popover === true) {
      this.mainDropdown.classList.remove("RevolutionSelectbox--animation");
      this.mainDropdown.classList.add("PopoverContent");

      if (this.changeOverlay) {
        this.pageOverlayElement = document.querySelector(".localizationOverlay");
      } else {
        this.pageOverlayElement = document.querySelector(".pageOverlay");
      }
    }

    this.bindEvents();
    this.initSelectbox();
  }
  bindEvents() {
    this.onClickOutsideListener = this.onClickOutside.bind(this);
    this.domDelegate.on(
      "click",
      "[data-action=toggle-selectbox]",
      this.toggleDropdown.bind(this)
    );

    this.domDelegate.on(
      "click",
      "[data-action=selectbox-submit]",
      this.selectboxSubmit.bind(this)
    );
    this.domDelegate.on(
      "keypress",
      "[data-action=selectbox-submit]",
      this.selectboxSubmit.bind(this)
    );

    this.domDelegate.on(
      "click",
      "[data-action=selectbox-change]",
      this.selectboxChange.bind(this)
    );

    // The options are <div tabindex="0">, and unlike a <button> a div does not fire a
    // click when Enter or Space is pressed. Without this the list can be focused and
    // navigated but never chosen from, which blocks keyboard users from completing the
    // contact form (WCAG 2.1.1 Keyboard).
    this.domDelegate.on(
      "keydown",
      "[data-action=selectbox-change]",
      this.selectboxKeydown.bind(this)
    );

    this.delegateBody.on("menu:open", this.onClickOutside.bind(this));
    this.domDelegate.on("click", "body", this.onClickOutside.bind(this));

    // Escape closes only the open list; without this it reached the popup's own Escape
    // handler and closed the whole market selector.
    this.element.addEventListener("keydown", (event) => {
      if (event.key !== "Escape" || !this.isOpen) return;
      event.preventDefault();
      event.stopPropagation();
      this.closeDropdown(this.mainButton);
    });
  }

  selectboxKeydown(event) {
    if (event.key !== "Enter" && event.key !== " ") return;
    event.preventDefault();
    // Dispatch a real click rather than calling selectboxChange directly. Other
    // components listen for clicks on these items too — the market selector records the
    // chosen market in its own click handler — and calling selectboxChange alone updated
    // the label but skipped them, so Confirm then submitted the previous market.
    const item = event.target.closest("[data-action=selectbox-change]");
    if (item) item.click();
  }

  selectboxChange(event) {
    var value = event.target.getAttribute("data-value");
    var selectboxID = event.target.getAttribute("data-selectboxid");
    var innerContent = event.target.innerHTML;
    var selEl = this.element.querySelector("#" + selectboxID);
    if (selEl.nodeName == "SELECT") {
      selEl.value = value;
      selEl.dispatchEvent(new Event("change"));
    } else if (selectboxID == 'country-selector__country-code') {
      this.element.dispatchEvent(
        new CustomEvent('change:countrySelector', {
          bubbles: true,
          detail: {
            country: event.target?.getAttribute('data-value'),
            languages: event.target?.getAttribute('data-languages'),
          },
        })
      );
    } else {
      selEl
        .querySelector('[value="' + value + '"]')
        .setAttribute("checked", "true");
    }

    if (selectboxID == 'country-selector__country-code') {

      const flagWrapper = this.mainButton.querySelector(".country-flag--wrapper");

      if (flagWrapper) {
        flagWrapper.innerHTML = innerContent;
        initMarketFlagImages(flagWrapper);
      }
    }
    else {
      this.mainButton.querySelector(".RevolutionSelectbox--Title").innerHTML =
        innerContent;
    }

    if (this.element.classList.contains('dropdownSelector')) {
      this.element.querySelector('.RevolutionSelectbox--Item[disabled="true"]').removeAttribute('disabled');
      event.target.setAttribute('disabled', 'true');
    }

    this.closeDropdown(this.element);
  }

  onClickOutside(event) {
    const withinBoundaries = event.composedPath().includes(this.element);
    if (
      !withinBoundaries ||
      event.target.classList.contains("FiltersDesktopWrapper")
    ) {
      this.closeDropdown(this.element);
    }
  }

  selectboxSubmit(event) {
    if (event.key != "Enter" && event.key !== undefined) {
      return;
    }
    var value = event.target.getAttribute("data-value");
    var dataName = event.target.getAttribute("data-name");
    this.selectbox.value = value;
    this.closeDropdown(this.element);
    this.mainButton.querySelector(".RevolutionSelectbox--Title").innerHTML =
      dataName;
    this.selectbox.parentElement.submit();
  }

  initSelectbox() {
    if (!this.element) return;
    const select = this.element.querySelector("select");
    if (!select) return;
    const selectedItem = this.mainDropdown.querySelector('[selected="selected"]'),
      titleElement = this.element.querySelector(".RevolutionSelectbox--Title");
    if (selectedItem) {
      titleElement.innerHTML = selectedItem.getAttribute("data-name");
    }

    // NOTE: this used to call trapFocus(this.element) here. initSelectbox runs from the
    // constructor, i.e. on page load, so that armed a focus trap around this selectbox
    // before the user had done anything — Tab was then confined to it and the header
    // menu became unreachable. It went unnoticed only because the old trapFocus was
    // inert until focus happened to land on the container's first or last element.
    this.element.style.display = "block";
  }

  toggleDropdown(event, target) {
    event.preventDefault();

    if (this.isOpen) {
      this.closeDropdown(target);
    } else {
      this.openDropdown(target);
    }
  }

  openDropdown(target) {
    // Dispatch "close:search" and "menu:close" events on the element.
    this.element.dispatchEvent(new CustomEvent('close:search', { bubbles: true }));
    this.element.dispatchEvent(new CustomEvent('menu:close', { bubbles: true }));

    // Find all siblings with class ".RevolutionSelectbox".
    const siblings = Array.from(target.parentElement.parentElement.children)
      .filter((item) => item.classList.contains('RevolutionSelectbox'));

    // Hide the dropdown content for all siblings.
    siblings.forEach((item) => {
      item.querySelector('.RevolutionSelectbox--Button').setAttribute('aria-expanded', false);
      item.querySelector('.RevolutionSelectbox--Content').setAttribute('aria-hidden', true);
      item.querySelector('.RevolutionSelectbox--Content').style.display = 'none';
    });

    // If the dropdown is a popover, show the page overlay and disable body scrolling.
    if (this.popover) {
      // Clean up any pending close operations from any component
      if (this.pageOverlayElement._pendingCloseHandler) {
        this.pageOverlayElement.removeEventListener('transitionend', this.pageOverlayElement._pendingCloseHandler);
        this.pageOverlayElement._pendingCloseHandler = null;
      }
      if (this.pageOverlayElement._pendingCloseTimeout) {
        clearTimeout(this.pageOverlayElement._pendingCloseTimeout);
        this.pageOverlayElement._pendingCloseTimeout = null;
      }

      this.pageOverlayElement.addEventListener('click', this.onClickOutsideListener);
      this.pageOverlayElement.style.display = "block";
      // Wait for display:block to render before adding is-visible for smooth transition
      requestAnimationFrame(() => {
        this.pageOverlayElement.classList.add('is-visible');
      });

      const focus = this.element.querySelector('[data-scrollable]');
      bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
      document.body.classList.add('scrollLock');
      if (document.querySelector('#Drawer').getAttribute('aria-expanded') === 'true') {
        document.querySelector('.Drawer--Wrapper').style.overflow = 'visible';
      }
    }

    // Show the dropdown content for the target element and set its state to "expanded".
    const contentElement = target.parentElement.querySelector('.RevolutionSelectbox--Content');
    target.setAttribute('aria-expanded', 'true');
    contentElement.style.display = 'block';
    contentElement.style.height = `${contentElement.offsetHeight}px`;

    // Move focus into the panel now that it is rendered. Until now focus stayed on the
    // toggle, so a keyboard user opened the list and was left outside it. A popover is
    // modal, so it gets the full trap; a plain dropdown only gets the initial focus, and
    // Tab is free to leave it. The checked option is preferred — in a radio group that is
    // the one the browser puts in the tab order anyway.
    if (this.popover) {
      trapFocus(this.mainDropdown);
    } else {
      const checked = contentElement.querySelector("input:checked");
      const optionToFocus =
        (checked && isRendered(checked) && checked) ||
        getFocusableElements(contentElement).filter(isRendered)[0];
      if (optionToFocus) focusWithoutStealingRing(optionToFocus);
    }

    if (this.popover) {
      setTimeout(() => {
        contentElement.setAttribute('aria-hidden', 'false');
      }, 20);
    } else {
      contentElement.setAttribute('aria-hidden', 'false');
    }

    this.isOpen = true;
    window.addEventListener('click', this.onClickOutsideListener);
  }

  closeDropdown(target) {
    // Try to find the nearest .RevolutionSelectbox from the target
    let closestDropdown = target && target.closest
      ? target.closest(".RevolutionSelectbox")
      : null;

    // Fallback: look inside target for an expanded button
    if (!closestDropdown && target && target.querySelector) {
      const expandedButton = target.querySelector("[aria-expanded='true']");
      if (expandedButton) {
        closestDropdown =
          expandedButton.closest(".RevolutionSelectbox") ||
          expandedButton.parentElement;
      }
    }

    // If we still don't have a dropdown, nothing to close – bail out safely
    if (!closestDropdown) {
      this.isOpen = false;
      return;
    }

    const button = closestDropdown.querySelector(".RevolutionSelectbox--Button");
    const content = closestDropdown.querySelector(".RevolutionSelectbox--Content");

    // Extra safety: if markup is missing for some reason, just stop
    if (!button || !content) {
      this.isOpen = false;
      return;
    }

    button.setAttribute("aria-expanded", false);
    content.setAttribute("aria-hidden", true);

    // If focus is still inside the panel being closed, hand it back to the toggle
    // rather than letting it fall to <body> (WCAG 2.4.3).
    if (content.contains(document.activeElement)) {
      focusWithoutStealingRing(button);
    }

    setTimeout(() => {
      content.style.display = "none";
    }, 300);

    if (this.popover == true) {
      this.pageOverlayElement.classList.remove("is-visible");

      const transitionHandler = () => {
        if (this.pageOverlayElement._pendingCloseTimeout) {
          clearTimeout(this.pageOverlayElement._pendingCloseTimeout);
          this.pageOverlayElement._pendingCloseTimeout = null;
        }
        this.pageOverlayElement.style.display = "none";
        this.pageOverlayElement.removeEventListener("transitionend", transitionHandler);
        this.pageOverlayElement._pendingCloseHandler = null;
      };

      // Store handler on overlay element so other components can clean it up
      this.pageOverlayElement._pendingCloseHandler = transitionHandler;
      this.pageOverlayElement.addEventListener("transitionend", transitionHandler);

      // Fallback in case transitionend doesn't fire
      this.pageOverlayElement._pendingCloseTimeout = setTimeout(() => {
        if (this.pageOverlayElement._pendingCloseHandler) {
          this.pageOverlayElement.removeEventListener("transitionend", this.pageOverlayElement._pendingCloseHandler);
          this.pageOverlayElement._pendingCloseHandler = null;
        }
        this.pageOverlayElement.style.display = "none";
        this.pageOverlayElement._pendingCloseTimeout = null;
      }, 850);

      this.pageOverlayElement.removeEventListener(
        "click",
        this.onClickOutsideListener
      );

      const menuDrawer = document.querySelector("#Drawer");
      if (menuDrawer && menuDrawer.getAttribute("aria-expanded") == "true") {
        const drawerWrapper = document.querySelector(".Drawer--Wrapper");
        if (drawerWrapper) drawerWrapper.style.overflow = "auto";
      } else {
        bodyScrollLock.clearAllBodyScrollLocks();
        document.body.classList.remove("scrollLock");
      }
    }

    this.isOpen = false;
    // Only a popover list arms its own trap. Removing it unconditionally also tore down
    // the trap of the dialog this list sits in (the market selector), so Tab left it.
    if (this.popover) removeTrapFocus();
    window.removeEventListener("click", this.onClickOutsideListener);
  }

}
class FormValidator {
  constructor(formElement, options = {}) {
    this.form = formElement;
    this.options = {
      errorClass: 'field--error',
      fieldSelector: '.field',
      buttonSelector: null,
      validateOnBlur: true,
      validateOnInput: false,
      errorOutputSelector: null,
      showErrorsOnSubmitOnly: false,
      recaptcha: false,
      ...options
    };

    this.customValidators = new Map();
    this.hasSubmittedOnce = false;

    this._fvInputs = [];
    this._fvBtn = null;
    this._fvRecaptchaInterval = null;
    this._fvLastRecaptchaToken = '';

    this.init();
  }

  init() {
    this.setupEventListeners();
    this.setupButtonListener();
    this.setupRecaptchaWatcher();

    if (this.options.buttonSelector) {
      if (this.options.showErrorsOnSubmitOnly) {
        this.updateButtonState();
      } else {
        this.updateButtonState();
      }
    }
  }

  destroy() {
    this._fvInputs.forEach(({ el, onInput, onBlur, onChange }) => {
      el.removeEventListener('input', onInput);
      el.removeEventListener('blur', onBlur);
      el.removeEventListener('change', onChange);
    });
    this._fvInputs = [];

    if (this._fvBtn && this._fvBtn._fvClickHandler) {
      this._fvBtn.removeEventListener('click', this._fvBtn._fvClickHandler);
      delete this._fvBtn._fvClickHandler;
    }

    if (this._fvRecaptchaInterval) {
      clearInterval(this._fvRecaptchaInterval);
      this._fvRecaptchaInterval = null;
    }
  }

  isRecaptchaEnabled() {
    if (!this.options.recaptcha) return false;
    if (this.options.recaptcha === true) return true;
    if (typeof this.options.recaptcha === 'object') return !!this.options.recaptcha.enabled;
    return false;
  }

  getRecaptchaToken() {
    if (!this.form) return '';
    const el = this.form.querySelector('#g-recaptcha-response') || this.form.querySelector('[name="g-recaptcha-response"]');
    return (el?.value || '').trim();
  }

  isRecaptchaApproved() {
    if (!this.isRecaptchaEnabled()) return true;
    if (!this.form) return false;

    const hasWidget = !!this.form.querySelector('.g-recaptcha');
    if (!hasWidget) return true;

    return !!this.getRecaptchaToken();
  }

  setupRecaptchaWatcher() {
    if (!this.isRecaptchaEnabled()) return;
    if (!this.form) return;

    const hasWidget = !!this.form.querySelector('.g-recaptcha');
    if (!hasWidget) return;

    this._fvLastRecaptchaToken = this.getRecaptchaToken();

    this._fvRecaptchaInterval = setInterval(() => {
      if (!this.form) return;
      const t = this.getRecaptchaToken();
      if (t === this._fvLastRecaptchaToken) return;
      this._fvLastRecaptchaToken = t;
      this.updateButtonState();
    }, 250);
  }

  enableButton() {
    if (!this.options.buttonSelector) return;

    const button = document.querySelector(this.options.buttonSelector);
    if (!button) return;

    button.removeAttribute('disabled');
    button.classList.remove('disabled');
    button.setAttribute('aria-disabled', 'false');
  }

  setupButtonListener() {
    if (!this.options.buttonSelector) return;

    const button = document.querySelector(this.options.buttonSelector);
    if (!button) return;

    this._fvBtn = button;

    if (button.dataset.fvClickBound === '1') return;
    button.dataset.fvClickBound = '1';

    const handler = (e) => {
      this.markSubmitted();
      const isValid = this.showAllErrors();

      if (button.type === 'submit' && !isValid) {
        e.preventDefault();
        return;
      }

      if (button.type === 'submit' && !this.isRecaptchaApproved()) {
        e.preventDefault();
        return;
      }
    };

    button._fvClickHandler = handler;
    button.addEventListener('click', handler);
  }

  outputErrors(errors) {
    if (!this.options.errorOutputSelector) return;

    if (this.options.showErrorsOnSubmitOnly && !this.hasSubmittedOnce) {
      return;
    }

    const container = typeof this.options.errorOutputSelector === 'string'
      ? document.querySelector(this.options.errorOutputSelector)
      : this.options.errorOutputSelector;
    if (!container) return;

    container.innerHTML = '';
    if (errors.length > 0) {
      container.innerHTML = errors.join('<br>');
    }
  }

  setupEventListeners() {
    const inputs = this.form.querySelectorAll('input, textarea, select');

    inputs.forEach((input) => {
      const onInput = () => this.handleInputForErrorClearing(input);
      const onBlur = () => this.handleFieldBlur(input);
      const onChange = () => this.handleInputChange(input);

      input.addEventListener('input', onInput);
      if (this.options.validateOnBlur) input.addEventListener('blur', onBlur);
      input.addEventListener('change', onChange);

      this._fvInputs.push({ el: input, onInput, onBlur, onChange });
    });
  }

  handleInputChange(input) {
    if (this.options.showErrorsOnSubmitOnly && !this.hasSubmittedOnce) {
      this.updateButtonState();
      return;
    }

    if (!input.value.trim()) {
      this.clearFieldError(input);
    } else if (this.options.validateOnInput) {
      this.validateField(input, false);
    } else {
      this.handleInputForErrorClearing(input);
    }

    this.updateErrorOutput();

    if (this.options.buttonSelector) {
      this.updateButtonState();
    }
  }

  updateErrorOutput() {
    if (!this.options.errorOutputSelector) return;
    if (this.options.showErrorsOnSubmitOnly && !this.hasSubmittedOnce) return;

    const errors = this.getAllErrors();
    this.outputErrors(errors);
  }

  getAllErrors() {
    const errors = [];
    this.form.querySelectorAll('input, textarea, select').forEach((field) => {
      if (!field.value.trim()) return;

      if (!this.isFieldValid(field)) {
        if (this.customValidators.has(field.id)) {
          const { validatorFn } = this.customValidators.get(field.id);
          const result = validatorFn(field.value, field);
          if (typeof result === 'string') errors.push(result);
        } else if (field.validationMessage) {
          errors.push(field.validationMessage);
        } else {
          if (field.type === 'email' && field.value && !this.isValidEmail(field.value)) {
            errors.push(`Please enter a valid email address`);
          }
        }
      }
    });
    return errors;
  }

  handleInputForErrorClearing(input) {
    if (this.options.showErrorsOnSubmitOnly && !this.hasSubmittedOnce) return;

    const fieldContainer = input.closest(this.options.fieldSelector);
    if (!fieldContainer) return;

    if (!input.value.trim() || this.isFieldValid(input)) {
      fieldContainer.classList.remove(this.options.errorClass);
      this.updateErrorOutput();
    }

    if (this.options.buttonSelector) {
      this.updateButtonState();
    }
  }

  handleFieldBlur(input) {
    if (this.options.showErrorsOnSubmitOnly && !this.hasSubmittedOnce) return;

    if (input.value.trim()) {
      this.validateField(input, false);
    }

    this.updateErrorOutput();

    if (this.options.buttonSelector) {
      this.updateButtonState();
    }
  }

  clearFieldError(field) {
    const fieldContainer = field.closest(this.options.fieldSelector);
    if (fieldContainer && fieldContainer.classList.contains(this.options.errorClass)) {
      fieldContainer.classList.remove(this.options.errorClass);
    }
  }

  addValidator(fieldId, validatorFn, errorMessage) {
    this.customValidators.set(fieldId, { validatorFn, errorMessage });
  }

  validateField(field, silent = true) {
    const fieldContainer = field.closest(this.options.fieldSelector);
    if (!fieldContainer) return true;

    if (!field.value.trim()) {
      fieldContainer.classList.remove(this.options.errorClass);
      return this.isFieldValid(field);
    }

    const isValid = this.isFieldValid(field);
    const shouldShowErrors = !silent && (!this.options.showErrorsOnSubmitOnly || this.hasSubmittedOnce);

    if (shouldShowErrors) {
      if (isValid) fieldContainer.classList.remove(this.options.errorClass);
      else fieldContainer.classList.add(this.options.errorClass);
    } else if (isValid) {
      fieldContainer.classList.remove(this.options.errorClass);
    }

    return isValid;
  }

  markSubmitted() {
    this.hasSubmittedOnce = true;
    if (this.options.buttonSelector) {
      this.updateButtonState();
    }
  }

  isFieldValid(field) {
    if (field.hasAttribute('required') && !field.value.trim()) return false;

    if (field.type === 'email' && field.value && !this.isValidEmail(field.value)) return false;

    if (this.customValidators.has(field.id)) {
      const { validatorFn } = this.customValidators.get(field.id);
      const result = validatorFn(field.value, field);
      if (typeof result === 'string') return false;
      return !!result;
    }

    return true;
  }

  validateForm(silent = true) {
    const allFields = this.form.querySelectorAll('input, textarea, select');
    let isFormValid = true;

    allFields.forEach((field) => {
      const isFieldValid = this.validateField(field, silent);
      if (!isFieldValid) isFormValid = false;
    });

    if (!silent) this.updateErrorOutput();

    return isFormValid;
  }

  updateButtonState() {
    if (!this.options.buttonSelector) return;

    const button = document.querySelector(this.options.buttonSelector);
    if (!button) return;

    const recaptchaOk = this.isRecaptchaApproved();

    if (this.options.showErrorsOnSubmitOnly && !this.hasSubmittedOnce) {
      if (recaptchaOk) {
        button.removeAttribute('disabled');
        button.classList.remove('disabled');
        button.setAttribute('aria-disabled', 'false');
      } else {
        button.setAttribute('disabled', 'true');
        button.classList.add('disabled');
        button.setAttribute('aria-disabled', 'true');
      }
      return;
    }

    const isValid = this.validateForm(true);

    if (isValid && recaptchaOk) {
      button.removeAttribute('disabled');
      button.classList.remove('disabled');
      button.setAttribute('aria-disabled', 'false');
    } else {
      button.setAttribute('disabled', 'true');
      button.classList.add('disabled');
      button.setAttribute('aria-disabled', 'true');
    }
  }

  clearErrors() {
    const errorFields = this.form.querySelectorAll(`.${this.options.errorClass}`);
    errorFields.forEach((field) => field.classList.remove(this.options.errorClass));

    if (this.options.errorOutputSelector) {
      this.outputErrors([]);
    }
  }

  showAllErrors() {
    return this.validateForm(false);
  }

  getFormData() {
    const formData = new FormData(this.form);
    return Object.fromEntries(formData.entries());
  }

  isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  isValidFutureDate(dateString) {
    if (!dateString) return false;
    const selectedDate = new Date(dateString);
    const now = new Date();
    return selectedDate > now;
  }
}
class Form {
  constructor() { }

  serialize(form) {
    function stringKey(key, value) {
      var beginBracket = key.lastIndexOf("[");

      if (beginBracket === -1) {
        var _hash = {};
        _hash[key] = value;
        return _hash;
      }

      var newKey = key.substr(0, beginBracket);
      var newValue = {};

      newValue[key.substring(beginBracket + 1, key.length - 1)] = value;

      return stringKey(newKey, newValue);
    }

    var hash = {};

    for (var i = 0, len = form.elements.length; i < len; i++) {
      var formElement = form.elements[i];

      if (formElement.name === "" || formElement.disabled) {
        continue;
      }

      if (
        formElement.name &&
        !formElement.disabled &&
        (formElement.checked ||
          /select|textarea/i.test(formElement.nodeName) ||
          /hidden|text|search|tel|url|email|password|datetime|date|month|week|time|datetime-local|number|range|color/i.test(
            formElement.type
          ))
      ) {
        var stringKeys = stringKey(formElement.name, formElement.value);
        hash = this.extend(hash, stringKeys);
      }
    }

    return hash;
  }
  extend() {
    var extended = {},
      i = 0,
      _this = this;

    // Merge the object into the extended object
    var merge = function merge(obj) {
      for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) {
          // If property is an object, merge properties
          if (Object.prototype.toString.call(obj[prop]) === "[object Object]") {
            extended[prop] = _this.extend(extended[prop], obj[prop]);
          } else {
            extended[prop] = obj[prop];
          }
        }
      }
    };

    // Loop through each object and conduct a merge
    for (; i < arguments.length; i++) {
      merge(arguments[i]);
    }

    return extended;
  }
}

class AddToCart {
  constructor(element) {
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.pageLoader = document.body.querySelector(".pageLoader");
    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on(
      "click",
      "[data-action=add-to-cart]",
      this.addToCart.bind(this)
    );
  }

  async addToCart(event) {
    event.preventDefault();

    const addToCartButton = event.target;
    const formElement = addToCartButton.closest("form");

    const idInput = formElement.querySelector('[name="id"]');
    if (idInput) {
      idInput.removeAttribute("disabled");
    }

    const formHelper = new Form();
    const serialized = formHelper.serialize(formElement);
    const requestedQty = Number(serialized.quantity) || 1;

    // loading state
    this.pageLoader.style.width = "100%";
    addToCartButton.setAttribute("disabled", "disabled");

    try {
      const payload = {
        items: [
          {
            id: serialized.id,
            quantity: requestedQty,
            ...(serialized.properties ? { properties: serialized.properties } : {}),
          },
        ],
      };

      const addRes = await fetch(`${window.routes.localeRootUrl}/cart/add.js`, {
        method: "POST",
        body: JSON.stringify(payload),
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
      });

      if (!addRes.ok) {
        const content = await addRes.json().catch(() => ({}));
        const msg =
          content.description ||
          content.message ||
          "Could not add to cart. Please try again.";
        this.handleCartError(addToCartButton, msg);
        throw new Error(msg);
      }

      this.handleCartSuccess(addToCartButton, {
        id: serialized.id,
        quantity: requestedQty,
      });
    } catch (err) {
      console.error("❌ Error adding to cart:", err);
      this.handleCartError(
        addToCartButton,
        err.message || "Could not add to cart. Please try again."
      );
    } finally {
      this.pageLoader.style.width = "0%";
      addToCartButton.removeAttribute("disabled");
    }
  }

  handleCartSuccess(addToCartButton, serialized) {
    // Close PhotoSwipe if it's open after successful add to cart
    if (window.currentPhotoSwipeInstance) {
      window.currentPhotoSwipeInstance.close();
    }

    if (window.theme.cartMode === "page") {
      location.href = window.routes.cart_page_url;
    } else if (window.location.href.indexOf("cart") !== -1) {
      location.reload();
    } else {
      addToCartButton.removeAttribute("disabled");
      this.pageLoader.style.width = 0;
      this.element.dispatchEvent(
        new CustomEvent("product:added", {
          bubbles: true,
          detail: {
            variant: serialized.id,
            quantity: serialized.quantity,
          },
        })
      );
    }
  }

  handleCartError(addToCartButton, message) {
    const errorElement =
      this.element.querySelector(".ProductForm--Error") ||
      document.querySelector(".pm__form-error");

    if (errorElement) {
      errorElement.classList.add("visible");
      setTimeout(() => errorElement.classList.remove("visible"), 3000);
    } else {
      console.error(message);
    }

    addToCartButton.removeAttribute("disabled");
    this.pageLoader.style.width = 0;
  }
}

/*GLOBAL FUNCTIONS */

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe, .focusable"
    )
  );
}

const trapFocusHandlers = {};

/**
 * How did the user last interact with the page?
 *
 * :focus-visible cannot answer this on its own. When a script moves focus — opening a
 * drawer, popup or dialog — the browser has no way to know whether the user got there
 * by mouse or by keyboard, and for some elements it errs towards showing a ring. That
 * puts a focus ring on a control the pointer user never navigated to. Tracking the last
 * modality lets programmatic focus decide, while leaving :focus-visible in charge of
 * every ordinary focus.
 * @type {"pointer"|"keyboard"}
 */
let lastInputModality = "pointer";

/**
 * The element currently carrying a suppressed focus ring, if any.
 * @type {Element|null}
 */
let silentFocusElement = null;

/**
 * Has the user actually done anything yet?
 *
 * Components that open on load — an auto-opened drawer, a popup that is visible in the
 * markup and gets closed during setup, anything initialised from a constructor — must
 * never move focus. Doing so drops the user's tab position into the middle of the page,
 * so their first Tab continues from there and everything above it, the header included,
 * becomes unreachable without cycling the whole document.
 * @type {boolean}
 */
let userHasInteracted = false;

/** Restore the focus ring on whichever element had it suppressed. */
function clearSilentFocus() {
  if (!silentFocusElement) return;
  delete silentFocusElement.dataset.focusSilent;
  silentFocusElement = null;
}

// Text fields always match :focus-visible, even when clicked — browsers assume the user
// is about to type. That draws a ring around a field the user just clicked into. Mark a
// pointer-focused text field silent; the ring comes back on Tab/Escape (real navigation),
// and tabbing into a field always shows it.
const TEXT_ENTRY_FIELDS =
  'input:not([type="checkbox"]):not([type="radio"]):not([type="button"])' +
  ':not([type="submit"]):not([type="reset"]):not([type="range"])' +
  ':not([type="color"]):not([type="file"]):not([type="hidden"]), textarea';

// Keys that mean "I am navigating by keyboard now". Plain typing is excluded on
// purpose: entering text in a field the user clicked into must not suddenly draw a
// ring around it. Inside a text field, Space/arrows/Home/End/Enter are editing keys —
// treating them as navigation was flashing the search (and other) input ring mid-type.
const NAVIGATION_KEYS = new Set([
  "Tab", "Escape", "Enter", " ", "Home", "End", "PageUp", "PageDown",
  "ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"
]);
const TEXT_FIELD_NAV_KEYS = new Set(["Tab", "Escape"]);

document.addEventListener(
  "keydown",
  (event) => {
    userHasInteracted = true;
    if (!NAVIGATION_KEYS.has(event.key)) return;
    const inTextField = event.target?.matches?.(TEXT_ENTRY_FIELDS);
    if (inTextField && !TEXT_FIELD_NAV_KEYS.has(event.key)) return;
    lastInputModality = "keyboard";
    clearSilentFocus();
  },
  true
);

// Enter on a form checkbox. Natively only Space toggles a checkbox; Enter triggers
// implicit form submission instead, which on the contact form fires validation rather
// than ticking the opt-in. Make Enter behave like Space for these.
document.addEventListener("keydown", (event) => {
  if (event.key !== "Enter") return;
  const box = event.target;
  if (!box.matches || !box.matches('.form-checkbox input[type="checkbox"]')) return;
  event.preventDefault();
  box.click();
});

["pointerdown", "mousedown", "touchstart"].forEach((type) =>
  document.addEventListener(
    type,
    () => {
      lastInputModality = "pointer";
      userHasInteracted = true;
    },
    true
  )
);

document.addEventListener(
  "focusin",
  (event) => {
    if (lastInputModality !== "pointer") return;
    const field = event.target;
    if (!field.matches || !field.matches(TEXT_ENTRY_FIELDS)) return;
    clearSilentFocus();
    field.dataset.focusSilent = "";
    silentFocusElement = field;
  },
  true
);

/**
 * Move focus to an element, suppressing the focus ring when the user is working with a
 * pointer. The flag is held until Tab/Escape (or a navigation key outside a text field)
 * rather than until the element blurs — a drawer opening can blur and refocus the same
 * element while it settles, and a blur-based flag would be lost in that shuffle.
 * @param {Element} element
 */
function focusWithoutStealingRing(element) {
  if (!element) return;
  // Never pull focus out of its resting position before the user has interacted.
  if (!userHasInteracted) return;
  clearSilentFocus();
  if (lastInputModality === "pointer") {
    element.dataset.focusSilent = "";
    silentFocusElement = element;
  }
  element.focus();
}

/**
 * Is this element actually rendered? A focusable element inside a collapsed step,
 * an off-screen carousel slide or a `visibility: hidden` panel is still matched by
 * the selector above but cannot receive focus, so it must not count as a boundary.
 * @param {Element} el
 * @returns {boolean}
 */
function isRendered(el) {
  if (!el.getClientRects().length) return false;
  const style = window.getComputedStyle(el);
  return style.visibility !== "hidden";
}

/**
 * Keep keyboard focus inside a modal container until it is closed (WCAG 2.1.2 / 2.4.3).
 * The boundaries are recomputed on every Tab rather than captured once, because the
 * contents of drawers and popups change while they are open — the product finder swaps
 * steps and injects results, so a first/last pair taken at open time goes stale and
 * focus leaks out into the page behind.
 * @param {Element} container
 * @param {Element} elementToFocus - fallback when the container holds nothing focusable
 */
// Double-click guard for toggles. Disabling the button instead (the old approach) made it
// unfocusable, so focus could not return to it and a focused toggle was blurred to <body>.
// Only real user clicks count, and handlers sharing one click event are not blocked.
function isRepeatActivation(button, event, ms = 1000) {
  if (!button || !event?.isTrusted) return false;
  const last = button._lastActivation;
  if (last && last.event !== event && event.timeStamp - last.time < ms) return true;
  if (!last || last.event !== event) button._lastActivation = { event, time: event.timeStamp };
  return false;
}

function trapFocus(container, elementToFocus = container) {
  removeTrapFocus();

  const focusable = () => getFocusableElements(container).filter(isRendered);

  trapFocusHandlers.keydown = function (event) {
    if (event.key !== "Tab") return;

    const elements = focusable();
    if (!elements.length) return;

    const first = elements[0];
    const last = elements[elements.length - 1];

    // Focus escaped the container entirely (script, autofocus, click-through) — pull it back.
    if (!container.contains(event.target)) {
      event.preventDefault();
      first.focus();
      return;
    }

    if (!event.shiftKey && event.target === last) {
      event.preventDefault();
      first.focus();
    } else if (event.shiftKey && event.target === first) {
      event.preventDefault();
      last.focus();
    }
  };

  // Deliberately no focusin pull-back: trapFocus is also used for non-modal panels
  // (the selectbox dropdowns), where yanking focus back would fight with the user
  // clicking elsewhere on the page. Tab is handled above, and a Tab press from
  // outside the container is pulled back in there.
  trapFocusHandlers.focusin = null;
  trapFocusHandlers.focusout = null;

  document.addEventListener("keydown", trapFocusHandlers.keydown, true);

  // Arm the trap regardless, but only move focus once the user is actually driving.
  if (!userHasInteracted) return;

  const initial = focusable();
  if (initial.length) {
    focusWithoutStealingRing(initial[0]);
  } else {
    if (!elementToFocus.hasAttribute("tabindex")) {
      elementToFocus.setAttribute("tabindex", "-1");
    }
    elementToFocus.focus();
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("keydown", trapFocusHandlers.keydown, true);
  if (trapFocusHandlers.focusin) {
    document.removeEventListener("focusin", trapFocusHandlers.focusin);
  }
  if (trapFocusHandlers.focusout) {
    document.removeEventListener("focusout", trapFocusHandlers.focusout);
  }
  trapFocusHandlers.keydown = null;
  trapFocusHandlers.focusin = null;
  trapFocusHandlers.focusout = null;

  if (elementToFocus) elementToFocus.focus();
}

class Dropdown {
  constructor() {
    this.domDelegate = new Delegate(document.body);
    this.breakpoint = responsive.getCurrentBreakpoint();
    this.allDropdowns = document.querySelectorAll(".Dropdown");
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.lock = false;
    this.bindEvents();
  }

  bindEvents() {
    // Bind event for general dropdown toggle - ALWAYS bind this regardless of breakpoint
    this.domDelegate.on(
      "click",
      "[data-action=toggle-dropdown]",
      this.toggleDropdown.bind(this)
    );

    // ADDITIONAL: Bind specifically for info__dropdown-button class used in PDP
    this.domDelegate.on(
      "click",
      ".info__dropdown-button[data-action='toggle-dropdown']",
      this.toggleDropdown.bind(this)
    );

    let selector;
    switch (this.breakpoint) {
      case "desktop":
        // For lap-and-up breakpoint, bind event for desktop dropdown toggle
        selector = "[data-action=toggle-desktop-dropdown]";
        break;
      case "pocket":
        // For pocket breakpoint, bind event for mobile dropdown toggle
        selector = "[data-action=toggle-mobile-dropdown]";
        break;
      default:
        // If no specific breakpoint, set selector as false to skip binding
        selector = false;
        break;
    }

    if (selector) {
      // Bind event for specific breakpoint dropdown toggle
      this.domDelegate.on("click", selector, this.toggleDropdown.bind(this));
    }
  }

  updateAllDropdowns() {
    this.allDropdowns = document.querySelectorAll(".Dropdown");
  }

  openDropdown(elem, target) {
    if (this.lock) return;
    this.lock = true;
    // Open the dropdown by setting appropriate attributes and performing animation
    const DropdownButton = elem.querySelector(".Dropdown--Button");
    const DropdownContent = elem.querySelector(".Dropdown--Content");

    this.allDropdowns.forEach((dropdown) => {
      if (
        dropdown !== target.closest(".Dropdown") &&
        dropdown.querySelector("[aria-expanded='true']") &&
        !dropdown.classList.contains("do-not-close")
      ) {
        this.closeDropdown(dropdown, true);
      }
    });

    const transitionEndHandler = (event) => {
      if (event.propertyName === "height") {
        this.lock = false;

        DropdownContent.removeEventListener(
          "transitionend",
          transitionEndHandler
        );
      }
    };

    DropdownContent.addEventListener("transitionend", transitionEndHandler);

    DropdownButton.setAttribute("aria-expanded", "true");
    new RevolutionAnimation(DropdownContent, "true").slideDown();
  }

  closeAllDropdowns(namespace) {
    namespace.querySelectorAll(".Dropdown").forEach((dropdown) => {
      if (
        dropdown.querySelector("[aria-expanded='true']") &&
        !dropdown.classList.contains("do-not-close")
      ) {
        this.closeDropdown(dropdown);
      }
    });
  }

  closeDropdown(elem, ignore) {
    if (this.lock && !ignore) return;
    this.lock = true;
    // Close the dropdown by setting appropriate attributes and performing animation
    const DropdownButton = elem.querySelector(".Dropdown--Button");
    const DropdownContent = elem.querySelector(".Dropdown--Content");
    const transitionEndHandler = (event) => {
      if (event.propertyName === "height") {
        if (DropdownContent.getAttribute("aria-hidden") == "false") {
          DropdownContent.setAttribute("aria-hidden", "true");
        }

        this.lock = false;

        DropdownContent.removeEventListener(
          "transitionend",
          transitionEndHandler
        );
      }
    };

    DropdownContent.addEventListener("transitionend", transitionEndHandler);

    new RevolutionAnimation(DropdownContent, "true").slideUp();
    DropdownButton.setAttribute("aria-expanded", false);
  }

  toggleDropdown(event, target) {
    event.preventDefault();

    const mainDropdown = target.closest(".Dropdown");
    const isOpen = target.getAttribute("aria-expanded") === "true";

    if (!this.lock) {
      if (isOpen) {
        // If dropdown is open, close it
        this.closeDropdown(mainDropdown, target);

        if (mainDropdown.classList.contains('filter__dropdown')) {
          mainDropdown.dispatchEvent(
            new CustomEvent("close:filters", { bubbles: true })
          );
        }
      } else {
        // If dropdown is closed, open it
        this.openDropdown(mainDropdown, target);

        if (mainDropdown.classList.contains('filter__dropdown')) {
          mainDropdown.dispatchEvent(
            new CustomEvent("open:filters", { bubbles: true })
          );
        }
      }
    }
  }
}

const allDropdowns = new Dropdown();

class RevolutionSwiper {
  constructor(element, additionalSwiper) {
    var options =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.element = element;
    this.thumb = additionalSwiper;
    this.initialConfig = JSON.parse(
      element.getAttribute("data-swiper-settings")
    );

    if (additionalSwiper) {
      this.initialConfigThumbs = JSON.parse(
        additionalSwiper.getAttribute("data-swiper-thumb-settings")
      );
    }
    this.options = options;
    this.build();
  }

  selectCell(index) {
    this.swiperElement.slideTo(index);
  }

  resize() {
    this.swiperElement.resize();
  }

  build() {
    var _this = this,
      configThumb = this.initialConfigThumbs;
    if (configThumb != null) {
      this.thumbSwiper = new Swiper(this.thumb, configThumb);
      this.initialConfig.thumbs["swiper"] = this.thumbSwiper;
    }

    this.swiperElement = new Swiper(this.element, this.initialConfig);
    this.selectedIndex = this.swiperElement.activeIndex;

    this.swiperElement.on("slideChange", function () {

      _this.element.dispatchEvent(
        new CustomEvent("swiper:slide-changed", {
          bubbles: true,
          detail: {
            currentIndex: _this.swiperElement.activeIndex,
            element: _this.swiperElement.el[0],
          },
        })
      );

      // Scroll thumb swiper to make the active slide visible
      if (_this.thumbSwiper) {
        const activeIndex = _this.swiperElement.activeIndex;
        _this.thumbSwiper.slideTo(activeIndex);
      }
    });
  }
}

class Drawer {
  static instances = new Set();

  constructor(element, options = {}) {
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.element._drawerInstance = this;

    // iPhone viewport height fix
    if (navigator.platform === "iPhone") {
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );
    }

    this.onOpen = options.onOpen || function () { };
    this.onClose = options.onClose || function () { };
    this.isOpen = false;
    this._openedOverlay = false;
    Drawer.instances.add(this);

    const initiallyExpanded = this.element.getAttribute("aria-expanded") === "true";
    if (initiallyExpanded) {
      this.isOpen = true;
      this.element.style.display = "block";
      this.element.classList.add("Drawer--is-open");
    } else {
      this.isOpen = false;
      this.element.style.display = "none";
      this.element.classList.remove("Drawer--is-open");
    }

    this.bindEvents();
  }

  bindEvents() {
    this.delegateBody.on(
      "click",
      `[data-action="open-drawer"][data-toggle-id="${this.element.id}"]`,
      this.openDrawer.bind(this)
    );
    this.delegateBody.on(
      "click",
      `[data-action="close-drawer"][data-toggle-id="${this.element.id}"]`,
      this.closeDrawer.bind(this)
    );
    this.delegateBody.on(
      "click",
      `[data-action="toggle-drawer"][data-toggle-id="${this.element.id}"]`,
      this.toggleDrawer.bind(this)
    );
    this.delegateBody.on(
      "click",
      `[data-action="open-drawer"][data-toggle-id="favorites-drawer"], [data-action="toggle-drawer"][data-toggle-id="favorites-drawer"]`,
      () => {
        const el = document.getElementById("favorites-drawer");
        if (!el) return;
        if (typeof el.renderProducts === "function") el.renderProducts();
      }
    );

    this.delegateBody.on("click", `[data-action="open-search"]`, this.openDrawer.bind(this));
    this.delegateBody.on("click", `[data-action="close-search"]`, this.closeDrawer.bind(this));

    this._openListener = this.openDrawer.bind(this);
    this._closeListener = this.closeDrawer.bind(this);
    this.calculateMaxHeightListener = this.maxHeight.bind(this);

    this.delegateBody.on("menu:open", this._closeListener);

    // Escape closes the innermost open drawer. A popup or open list inside it handles its
    // own Escape first, so leave those alone.
    const closeOnEscape = (event) => {
      if (event.key !== "Escape" || event.defaultPrevented) return;
      const isOpen = this.element.id === "quickSearch" ? this.element.__searchBar?.isOpen : this.isOpen;
      if (!isOpen || window.globalPopup?.activePopups?.length) return;
      event.preventDefault();
      event.stopPropagation();
      this.closeDrawer();
    };
    this.element.addEventListener("keydown", closeOnEscape);
    // Focus has not reached the drawer yet right after it opens; still let Escape close it.
    document.addEventListener("keydown", (event) => {
      const focusInOpenDrawer = Array.from(Drawer.instances).some(
        (inst) => inst.isOpen && inst.element.contains(document.activeElement)
      );
      if (!focusInOpenDrawer) closeOnEscape(event);
    });

    responsive.addResizeListener(this, this.calculateMaxHeightListener);
  }

  static closeAllExcept(exceptInstance) {
    for (const inst of Drawer.instances) {
      if (inst.isOpen && inst !== exceptInstance) {
        inst.closeDrawer();
      }
    }
  }

  static closeAll() {
    for (const inst of Drawer.instances) {
      if (inst.isOpen) inst.closeDrawer();
    }
  }

  maxHeight() {
    if (this.element.closest("main-menu-dropdown")) return;

    this.element.style.height = window.innerHeight + "px";

    if (this.element.getAttribute("id") === "cart" || this.element.getAttribute("id") === "sidebarFavorites") {
      const footer = this.element.querySelector(".CartDrawer--Footer");
      const footerHeight = footer ? footer.offsetHeight : 0;

      const headerEl = this.element.querySelector(".CartHeader");
      const header = headerEl ? headerEl.offsetHeight : 0;

      const itemWrapper = this.element.querySelector(".CartItems--Wrapper");
      if (itemWrapper !== null) {
        itemWrapper.style.height = window.innerHeight - footerHeight - header + "px";
      }
    }
  }

  toggleDrawer(event) {
    if (event) event.preventDefault();

    const toggleBtn = event?.target?.closest?.('[data-action="toggle-drawer"]');
    if (isRepeatActivation(toggleBtn, event)) return;

    if (!this.isOpen && toggleBtn) this._triggerElement = toggleBtn;
    this.isOpen ? this.closeDrawer() : this.openDrawer();
  }

  openDrawer(event) {
    if (event) event.preventDefault();

    // WCAG 2.4.3 Focus Order: remember the trigger so focus can return to it on close.
    // Without this, closing a drawer drops focus to <body> and keyboard users restart
    // from the top of the page.
    if (event?.target) {
      this._triggerElement =
        event.target.closest("[data-action]") || event.target;
    }

    const quickSearchToggleBtn = event?.target?.closest?.('[data-toggle-id="quickSearch"]');
    const toggleBtn = quickSearchToggleBtn || event?.target?.closest?.(
      '[data-action="toggle-drawer"], [data-action="open-drawer"], [data-action="open-search"]'
    );
    if (isRepeatActivation(toggleBtn, event, quickSearchToggleBtn ? 400 : 1000)) return false;

    if (this.element.getAttribute("id") === "quickSearch") {
      const sb = this.element.__searchBar;
      if (sb && typeof sb.openSearch === "function") {
        sb.openSearch(event);
      }
      return false;
    }

    // Don't close other drawers if this is accountDrawer on mobile
    const isAccountDrawer = this.element.getAttribute("id") === "accountDrawer";
    const isMobile = window.innerWidth <= 1024;
    const shouldCloseOthers = !(isAccountDrawer && isMobile);

    if (shouldCloseOthers) {
      if (this._openDelayTimeout) {
        clearTimeout(this._openDelayTimeout);
        this._openDelayTimeout = null;
      }

      const hasOtherOpen = Array.from(Drawer.instances).some(
        (inst) => inst !== this && inst.isOpen
      );

      // treat open popups like open drawers (delay open until they fully close)
      const hasPopupOpen = !!(
        window.globalPopup &&
        window.globalPopup.activePopups &&
        window.globalPopup.activePopups.length
      );

      if (hasOtherOpen || hasPopupOpen) {
        Drawer.closeAllExcept(this);

        if (window.globalPopup && typeof window.globalPopup.closeAllPopups === "function") {
          window.globalPopup.closeAllPopups();
        }

        this._openDelayTimeout = setTimeout(() => {
          this._openDelayTimeout = null;
          this.openDrawer();
        }, 1000);

        return false;
      }

      Drawer.closeAllExcept(this);
    }

    // Close modal-country when opening accountDrawer on mobile
    if (isAccountDrawer && isMobile) {
      const modalCountry = document.getElementById("modal-country");
      if (modalCountry && modalCountry.getAttribute("aria-hidden") === "false") {
        if (window.globalPopup && typeof window.globalPopup.closePopup === "function") {
          window.globalPopup.closePopup(modalCountry);
        }
        // Wait for modal to close before opening drawer
        if (this._openDelayTimeout) {
          clearTimeout(this._openDelayTimeout);
          this._openDelayTimeout = null;
        }
        this._openDelayTimeout = setTimeout(() => {
          this._openDelayTimeout = null;
          this.openDrawer();
        }, 1000);
        return false;
      }
    } else {
      // Close all popups for other drawers
      if (window.globalPopup && typeof window.globalPopup.closeAllPopups === "function") {
        window.globalPopup.closeAllPopups();
      }
    }

    // Notify other components
    this.element.dispatchEvent(new CustomEvent("close:search", { bubbles: true }));

    if (this.element.getAttribute("id") === "cart") {
      this.element.dispatchEvent(new CustomEvent("cart-drawer:open", { bubbles: true }));
    }

    if (this.isOpen) return false;

    // Prepare for opening animation
    this.element.style.display = "block";
    this.element.classList.remove("Drawer--is-closing");
    void this.element.offsetWidth;
    this.element.classList.add("Drawer--is-open");

    this.maxHeight();

    if (this.element.getAttribute("id") === "Drawer") {
      const closeBtn = document.querySelector(".Drawer--Close");
      if (closeBtn) closeBtn.style.display = "block";

      this.element.dispatchEvent(new CustomEvent("sidebar-drawer:open", { bubbles: true }));
    }

    this.element.setAttribute("aria-expanded", "true");

    const overlayDisabled =
      this.element.getAttribute("data-disable-overlay") === "true" ||
      this.element.getAttribute("data-page-overlay") === "false";

    if (
      !overlayDisabled &&
      this.element.getAttribute("id") !== "mobile-menu-drawer" &&
      !this.element.hasAttribute("data-subdrawer")
    ) {
      // Clean up any pending overlay close operations from other drawers
      if (this.pageOverlayElement._pendingCloseHandler) {
        this.pageOverlayElement.removeEventListener("transitionend", this.pageOverlayElement._pendingCloseHandler);
        this.pageOverlayElement._pendingCloseHandler = null;
      }
      if (this.pageOverlayElement._pendingCloseTimeout) {
        clearTimeout(this.pageOverlayElement._pendingCloseTimeout);
        this.pageOverlayElement._pendingCloseTimeout = null;
      }

      this.pageOverlayElement.style.display = "block";
      this.element.setAttribute("aria-hidden", "false");
      requestAnimationFrame(() => {
        this.pageOverlayElement.classList.add("is-visible");
      });
      this.pageOverlayElement.addEventListener("click", this._closeListener);
      this._openedOverlay = true;
    } else {
      this._openedOverlay = false;
    }

    if (this.element.getAttribute("id") === "mobile-menu-drawer") {
      const toggleMenuBtn = document.querySelector(".header-hamburger-btn");
      if (toggleMenuBtn) toggleMenuBtn.setAttribute("aria-expanded", "true");
    }

    // Scroll lock
    const focus = this.element.querySelector("[data-scrollable]");
    bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
    document.body.classList.add("scrollLock");

    this.isOpen = true;
    IOSScrollLock.lock();

    setTimeout(() => {
      if (this.isOpen) trapFocus(this.element);
    }, 400);

    this.element.dispatchEvent(new CustomEvent("drawer:opened", { bubbles: true }));

    this.onOpen();
    return false;
  }

  closeDrawer(event) {
    if (this.element.getAttribute("id") === "quickSearch") {
      const sb = this.element.__searchBar;
      if (sb && typeof sb.closeSearch === "function") {
        sb.closeSearch(event);
      }
      return;
    }

    if (!this.isOpen) return;
    if (event) event.preventDefault();

    const quickSearchToggleBtn = event?.target?.closest?.('[data-toggle-id="quickSearch"]');
    const toggleBtn = quickSearchToggleBtn || event?.target?.closest?.(
      '[data-action="toggle-drawer"], [data-action="close-drawer"], [data-action="close-search"]'
    );
    if (isRepeatActivation(toggleBtn, event, quickSearchToggleBtn ? 400 : 1000)) return;

    // Scroll unlock — but if another drawer is still open, restore its lock
    const otherOpenDrawer = Array.from(Drawer.instances).find(
      (inst) => inst !== this && inst.isOpen
    );

    if (otherOpenDrawer) {
      // Only clear this drawer's scroll lock, then re-apply the other drawer's
      const thisScrollable = this.element.querySelector("[data-scrollable]");
      if (thisScrollable) bodyScrollLock.enableBodyScroll(thisScrollable);

      const otherScrollable = otherOpenDrawer.element.querySelector("[data-scrollable]");
      if (otherScrollable) bodyScrollLock.disableBodyScroll(otherScrollable, bodyScrollLockOptions);
      // Keep scrollLock class since another drawer is open
    } else {
      document.body.classList.remove("scrollLock");
      bodyScrollLock.clearAllBodyScrollLocks();
    }

    if (this.element.getAttribute("id") === "cart") {
      const options = JSON.parse(this.element.getAttribute("data-settings"));
      if (options["showRecommendations"]) {
        this.element.querySelector(".CartDrawer--Expendable").setAttribute("aria-expanded", false);

        setTimeout(() => {
          this.element.querySelector(".CustomCart__Recommendations").innerHTML = "";
        }, 800);
      }
    }

    if (this.element.getAttribute("id") === "mobile-menu-drawer") {
      const toggleMenuBtn = document.querySelector(".header-hamburger-btn");
      if (toggleMenuBtn) toggleMenuBtn.setAttribute("aria-expanded", "false");

      const onTransitionEnd = (e) => {
        if (e.propertyName !== "visibility") return;
        this.element
          .querySelectorAll('.Drawer--wrapper[aria-expanded="true"]')
          .forEach((subDrawer) => {
            subDrawer.setAttribute("aria-expanded", "false");
          });
        this.element.removeEventListener("transitionend", onTransitionEnd);
      };

      this.element.addEventListener("transitionend", onTransitionEnd);
    }

    this.element.setAttribute("aria-expanded", "false");

    // Only hand focus back if focus is actually inside this drawer and the trigger is
    // still in the document and visible; otherwise release the trap without moving focus,
    // so a drawer closing during page setup cannot reposition the user's tab position.
    const focusIsInside = this.element.contains(document.activeElement);
    const returnTarget =
      focusIsInside &&
      this._triggerElement?.isConnected &&
      this._triggerElement.offsetParent !== null
        ? this._triggerElement
        : null;
    removeTrapFocus(returnTarget);
    this.isOpen = false;
    this.onClose();

    IOSScrollLock.unlock();

    this.element.dispatchEvent(new CustomEvent("drawer:closed", { bubbles: true }));

    // Closing animation
    this.element.classList.remove("Drawer--is-open");
    this.element.classList.add("Drawer--is-closing");

    // Store drawer ID for later check
    const closingDrawerId = this.element.getAttribute("id");

    if (this._openedOverlay) {
      this.pageOverlayElement.classList.remove("is-visible");
      this.pageOverlayElement.removeEventListener("click", this._closeListener);
    }

    const onTransitionEnd = (e) => {
      if (e.target !== this.element) return;
      this.element.removeEventListener("transitionend", onTransitionEnd);
      this.element.classList.remove("Drawer--is-closing");
      this.element.style.display = "none";
      this.element.setAttribute("aria-hidden", "true");

      // Check NOW if modal-country is open before hiding overlay
      const isAccountDrawer = closingDrawerId === "accountDrawer";
      const isMobile = window.innerWidth <= 1024;
      const modalCountry = document.getElementById("modal-country");
      const modalCountryOpen =
        modalCountry &&
        (modalCountry.getAttribute("aria-hidden") === "false" ||
          modalCountry.getAttribute("aria-expanded") === "true");
      const shouldKeepOverlay = isAccountDrawer && isMobile && modalCountryOpen;

      if (this._openedOverlay && !shouldKeepOverlay) {
        // Wait for overlay transition before setting display none
        const overlayTransitionHandler = (evt) => {
          if (evt.target !== this.pageOverlayElement) return;
          this.pageOverlayElement.style.display = "none";
          this.pageOverlayElement.removeEventListener("transitionend", overlayTransitionHandler);
          this.pageOverlayElement._pendingCloseHandler = null;
          if (this.pageOverlayElement._pendingCloseTimeout) {
            clearTimeout(this.pageOverlayElement._pendingCloseTimeout);
            this.pageOverlayElement._pendingCloseTimeout = null;
          }
        };

        // Store handler on overlay element so other drawers can clean it up
        this.pageOverlayElement._pendingCloseHandler = overlayTransitionHandler;
        this.pageOverlayElement.addEventListener("transitionend", overlayTransitionHandler);

        // Fallback in case transitionend doesn't fire
        this.pageOverlayElement._pendingCloseTimeout = setTimeout(() => {
          this.pageOverlayElement.removeEventListener("transitionend", overlayTransitionHandler);
          this.pageOverlayElement.style.display = "none";
          this.pageOverlayElement._pendingCloseHandler = null;
          this.pageOverlayElement._pendingCloseTimeout = null;
        }, 400);
      }
    };

    this.element.addEventListener("transitionend", onTransitionEnd);
  }
}

window.Drawer = Drawer;

class RevolutionAnimation {
  constructor(element, directAnimation) {
    this.element = element;

    this._seenBlocks = new WeakSet();
    this._seenTargets = new WeakSet();
    this._observersByTarget = new WeakMap();

    this._mutationObserver = null;

    if (!directAnimation) {
      this.scan(document);

      this._mutationObserver = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          for (const node of mutation.addedNodes) {
            if (node.nodeType !== Node.ELEMENT_NODE) continue;

            if (node.matches?.("[data-animation]")) {
              this._initBlock(node, { reset: false });
            }

            node.querySelectorAll?.("[data-animation]").forEach((blk) => {
              this._initBlock(blk, { reset: false });
            });
          }
        }
      });

      this._mutationObserver.observe(document.body, { childList: true, subtree: true });
    }
  }

  destroy() {
    if (this._mutationObserver) {
      try {
        this._mutationObserver.disconnect();
      } catch (e) { }
      this._mutationObserver = null;
    }

    try {
    } catch (e) { }
  }

  scan(root = document) {
    root.querySelectorAll?.("[data-animation]").forEach((blk) => {
      this._initBlock(blk, { reset: false });
    });
  }

  refresh(root = document, { reset = true } = {}) {
    if (!root) root = document;

    const blocks =
      root.matches?.("[data-animation]")
        ? [root]
        : Array.from(root.querySelectorAll?.("[data-animation]") || []);

    blocks.forEach((blk) => this._initBlock(blk, { reset }));
  }

  resetSubtree(root = document) {
    if (!root) root = document;

    if (root.classList?.contains("animatedContent")) {
      root.removeAttribute("data-loaded");
    }
    root.querySelectorAll?.(".animatedContent[data-loaded]").forEach((el) => {
      el.removeAttribute("data-loaded");
    });

    this._seenTargets = new WeakSet();
    this._seenBlocks = new WeakSet();
  }

  _initBlock(block, { reset }) {
    if (!block) return;

    if (!reset && this._seenBlocks.has(block)) return;

    this._seenBlocks.add(block);

    if (reset) this._prepareForReanimate(block);

    const targets = [];

    if (block.classList?.contains("animatedContent")) targets.push(block);
    block.querySelectorAll?.(".animatedContent").forEach((el) => targets.push(el));

    targets.forEach((target) => {
      if (target.closest("[data-priority]")) {
        target.style.opacity = "1";
        target.style.visibility = "visible";
        target.classList.add("RevolutionAnimation--in");
      } else {
        this._observeTarget(target, block.dataset.animation);
      }
    });
  }

  _prepareForReanimate(animationRoot) {
    if (!animationRoot) return;

    if (animationRoot.classList?.contains("animatedContent")) {
      animationRoot.removeAttribute("data-loaded");
      animationRoot.classList.remove("RevolutionAnimation--in");
    }

    animationRoot.querySelectorAll?.(".animatedContent[data-loaded]").forEach((el) => {
      el.removeAttribute("data-loaded");
      el.classList.remove("RevolutionAnimation--in");
    });
  }

  _observeTarget(target, animationType) {
    if (!target) return;

    if (this._seenTargets.has(target)) return;
    this._seenTargets.add(target);

    target.classList.add("anim-" + animationType);

    const observer = new IntersectionObserver(
      (entries) => {
        const hit = entries.some((e) => e.isIntersecting || e.intersectionRatio > 0);
        if (!hit) return;

        observer.unobserve(target);

        this._runAnimation(animationType, target);
      },
      { threshold: 0.15 }
    );

    this._observersByTarget.set(target, observer);
    observer.observe(target);
  }

  _runAnimation(type, target) {
    const map = {
      elementFromTop: "elementFromTop",
      elementFromBottom: "elementFromBottom",
      elementFromRight: "elementFromRight",
      elementFromLeft: "elementFromLeft",
      elementFromLeftBig: "elementFromLeftBig",
      elementFromRightBig: "elementFromRightBig",
      elementScaleIn: "elementScaleIn",
      elementScaleOut: "elementScaleOut",
      elementFadeIn: "elementFadeIn",
    };

    const method = map[type];
    if (!method) return;

    this[method]([target]);
  }

  slideUp() {
    // Batch DOM reads and writes - avoid forced reflow
    const height = this.element.scrollHeight;
    this.element.style.height = height + "px";
    // Use rAF to avoid forcing layout recalculation
    requestAnimationFrame(() => {
      this.element.style.height = 0;
    });
  }

  slideDown() {
    if (this.element.style.height === "auto") return;
    this.element.style.pointerEvents = "none";

    const _this = this;
    this.element.style.height = this.element.scrollHeight + "px";
    this.element.setAttribute("aria-hidden", false);

    const transitionEnded = function (event) {
      _this.element.style.pointerEvents = "all";
      if (event.propertyName === "height") {
        _this.element.style.height = "auto";
        _this.element.removeEventListener("transitionend", transitionEnded);
      }
    };

    this.element.addEventListener("transitionend", transitionEnded);
  }

  _applyCssAnimation(target, durationMs, delayMs = 0) {
    if (target.hasAttribute("data-loaded")) return;
    target.setAttribute("data-loaded", true);
    target.style.setProperty("--anim-duration", durationMs + "ms");
    target.style.setProperty("--anim-delay", delayMs + "ms");
    requestAnimationFrame(() => {
      target.classList.add("RevolutionAnimation--in");
    });
  }

  elementScaleOut(elements) {
    const duration = window.theme.animationDuration * 2;
    const delay = window.theme.animationBetweenElements;
    elements.forEach((el, i) => this._applyCssAnimation(el, duration, delay * i));
  }

  elementScaleIn(toReveal) {
    const duration = window.theme.animationDuration * 2;
    const delay = window.theme.animationBetweenElements;
    toReveal.forEach((el, i) => this._applyCssAnimation(el, duration, delay * i));
  }

  elementFromTop(toReveal) {
    const duration = window.theme.animationDuration;
    const delay = window.theme.animationBetweenElements;
    toReveal.forEach((el, i) => this._applyCssAnimation(el, duration, delay * i));
  }

  elementFromBottom(toReveal) {
    const duration = window.theme.animationDuration;
    const delay = window.theme.animationBetweenElements;
    toReveal.forEach((el, i) => this._applyCssAnimation(el, duration, delay * i));
  }

  elementFromRight(toReveal) {
    const duration = window.theme.animationDuration;
    const delay = window.theme.animationBetweenElements;
    toReveal.forEach((el, i) => this._applyCssAnimation(el, duration, delay * i));
  }

  elementFromLeft(toReveal) {
    const duration = window.theme.animationDuration;
    const delay = window.theme.animationBetweenElements;
    toReveal.forEach((el, i) => this._applyCssAnimation(el, duration, delay * i));
  }

  elementFromRightBig(toReveal) {
    const duration = window.theme.animationDuration;
    const delay = window.theme.animationBetweenElements;
    toReveal.forEach((el, i) => this._applyCssAnimation(el, duration, delay * i));
  }

  elementFromLeftBig(toReveal) {
    const duration = window.theme.animationDuration;
    const delay = window.theme.animationBetweenElements;
    toReveal.forEach((el, i) => this._applyCssAnimation(el, duration, delay * i));
  }

  elementFadeIn(toReveal) {
    const duration = window.theme.animationDuration;
    const delay = window.theme.animationBetweenElements;
    toReveal.forEach((el, i) => this._applyCssAnimation(el, duration, delay * i));
  }
}

// ✅ single instance
if (window.theme && window.theme.enableAnimations) {
  document.addEventListener("DOMContentLoaded", function () {
    if (!window.__revolutionAnimation) window.__revolutionAnimation = new RevolutionAnimation();
  });
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.input = this.querySelector("input");
    this.changeEvent = new Event("quantity:changed", { bubbles: true });
    this.options = JSON.parse(this.element.getAttribute("data-settings"));

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);

    if (this.options['noVariants'] == "true") {
      this.toggleAddButton();
    }
  }

  toggleAddButton() {
    let quantity = "";
    const addButton = document.querySelector(".ProductPage--ATC"),
      addButtonInner = addButton.querySelector(".SelfAlign"),
      quantityEl = document.querySelector('.QuantitySelector__ProductQuantity');
    if (quantityEl) {
      quantity = quantityEl.value();
    }
    if (window.variantInfo.show_icon) {
      var buySvg =
        '<svg class="Svg Svg--shopping_cart mr-m" width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M25.31 5.19547C25.1687 5.02127 24.9568 4.91946 24.7325 4.91797H9.11751L9.60501 6.41797H23.75L21.7475 15.418H10.4975L7.07001 4.56547C6.99476 4.33174 6.80986 4.14965 6.57501 4.07797L3.50001 3.13297C3.24278 3.05393 2.96292 3.11812 2.76584 3.30137C2.56877 3.48461 2.48443 3.75907 2.54459 4.02137C2.60476 4.28366 2.80028 4.49393 3.05751 4.57297L5.75001 5.39797L9.19251 16.273L7.96251 17.278L7.86501 17.3755C7.2374 18.0987 7.21221 19.1659 7.80501 19.918C8.21952 20.4221 8.84817 20.7002 9.50001 20.668H22.0175C22.4317 20.668 22.7675 20.3322 22.7675 19.918C22.7675 19.5038 22.4317 19.168 22.0175 19.168H9.38001C9.20436 19.162 9.0446 19.0646 8.95873 18.9113C8.87286 18.7579 8.87334 18.5709 8.96001 18.418L10.7675 16.918H22.3475C22.705 16.9267 23.0189 16.6818 23.0975 16.333L25.475 5.83297C25.5212 5.6064 25.4603 5.37117 25.31 5.19547ZM20.75 25.168C21.682 25.168 22.4375 24.4125 22.4375 23.4805C22.4375 22.5485 21.682 21.793 20.75 21.793C19.818 21.793 19.0625 22.5485 19.0625 23.4805C19.0625 24.4125 19.818 25.168 20.75 25.168ZM12.185 23.4805C12.185 24.4125 11.4295 25.168 10.4975 25.168C9.56553 25.168 8.81001 24.4125 8.81001 23.4805C8.81001 22.5485 9.56553 21.793 10.4975 21.793C11.4295 21.793 12.185 22.5485 12.185 23.4805Z" fill="#121212"></path></svg>';
    } else {
      var buySvg = "";
    }

    if (!addButton) return;
    if (!quantity) { quantity = 1; }

    addButton.removeAttribute("disabled");
    addButton.classList.remove("ProductCard--Sold__Out");
    if (window.variantInfo.show_price) {
      var priceElement =
        "<span class='u-p3 ml-s'>" +
        Shopify.formatMoney(
          this.options['price'] * quantity,
          window.theme.moneyFormat
        );
      +"</span>";
    } else {
      var priceElement = "";
    }

    addButtonInner.innerHTML =
      buySvg + window.variantStrings.addToCart + priceElement;

  }

}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class ProductForm extends HTMLElement {
  constructor() {
    super();
    new AddToCart(this);
  }
}

customElements.define("product-form", ProductForm);

class Countdown extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    const counterWrapper = this.element.querySelector('.component-countDownWrapper');

    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    let counterString = this.options['countdownString'];
    counterString = counterString.replace('{countdown}', '<span class="u-pb6 component-countDown">00:00:00</span>');
    counterWrapper.innerHTML = counterString;

    const dateNow = new Date();
    const todaysDay = dateNow.getDay();

    const countdownDay = this.options.countdownDays;

    this.dayDifference = countdownDay - todaysDay;

    if (this.dayDifference < 0) {
      // If the countdown day is earlier in the week, add 7 to the difference
      this.dayDifference += 7;
    }

    this.counter = this.element.querySelector(".component-countDown");
    setInterval(this.countDown.bind(this), 1000);
  }

  countDown() {
    const dateNow = new Date();
    const currentHours = dateNow.getHours();
    const currentMinutes = dateNow.getMinutes();
    let countDate = new Date(`March 3, 2099 ${this.options.countdownTime}`);

    if (this.options['countdownType'] == 'to_date') {
      countDate = new Date(this.options.countdownDate);
    }

    const difference = countDate - dateNow;

    const seconds = 1000;
    const minutes = seconds * 60;
    const hours = minutes * 60;
    const days = hours * 24;

    let textDays = Math.floor(difference / (1000 * 60 * 60 * 24));
    let textHours = Math.floor((difference % days) / hours);
    let textMinutes = Math.floor((difference % hours) / minutes);
    let textSeconds = Math.floor((difference % minutes) / seconds);

    const [targetHours, targetMinutes] = this.options.countdownTime.split(':').map(Number);
    if (targetHours < currentHours || (targetHours === currentHours && targetMinutes <= currentMinutes) && this.options['countdownType'] == 'reccuring') {
      textDays = this.dayDifference - 1;
    } else if (this.options['countdownType'] == 'reccuring') {
      textDays = this.dayDifference;
    }

    const displayHours = textHours;
    const formatHours = displayHours < 10 ? `0${displayHours}` : displayHours;
    const formatMinutes = textMinutes < 10 ? `0${textMinutes}` : textMinutes;
    const formatSeconds = textSeconds < 10 ? `0${textSeconds}` : textSeconds;

    if (textDays > 0) {
      this.counter.innerText = `${textDays}d ${formatHours}:${formatMinutes}:${formatSeconds}`;
    } else {
      this.counter.innerText = `${formatHours}:${formatMinutes}:${formatSeconds}`;
    }
  }
}

customElements.define("countdown-element", Countdown);

var stateWasEmpty = true;

class CartDrawer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    this.focusElement = false;
    this.drawer = new Drawer(this.element, {
      onClose: () => {
        this.isOpen = false;
        this.recommendationsOpen = false;
        this.alreadyEntered = false;
        this.onClose();
      },
      onOpen: () => {
        this.isOpen = true;

        if (this.alreadyEntered == false) {
          this.onOpen();
        }
        this.alreadyEntered = true;
      },
    });

    this.loader = this.element.querySelector(".itemLoader");

    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    this.pageLoader = document.body.querySelector(".pageLoader");
    this.emptyCartCollection = this.element.querySelector('.cart-drawer__recommendations');
    this.breakpoint = responsive.getCurrentBreakpoint();
    this.cartIds = false;
    this.isOpen = false;
    this.recommendationsOpen = false;
    this.recommendationLoading = false;
    this.breakpoint = responsive.getCurrentBreakpoint();

    this.alreadyEntered = false;
    new AddToCart(this.element);
    this.loadRecommendations();

    this.bindEvents();
    this.cleanupInvalidMarketItems();
  }

  async cleanupInvalidMarketItems() {
    try {
      const localeRoot = window.routes?.localeRootUrl || '';
      const cart = await fetch(`${localeRoot}/cart.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
      if (!cart || !cart.items || !cart.items.length) return;

      const invalidKeys = [];
      await Promise.all(
        cart.items.map(async (item) => {
          if (!item.handle) return;
          try {
            const res = await fetch(`${localeRoot}/products/${item.handle}`, { method: 'HEAD' });
            if (res.status !== 404) return;
            invalidKeys.push(item.key);
            const node = this.element.querySelector(`#cart-item__${item.id}`);
            if (node) node.style.display = 'none';
          } catch (e) {
            /* ignore */
          }
        })
      );
      if (!invalidKeys.length) return;

      for (const key of invalidKeys) {
        try {
          await fetch(`${localeRoot}/cart/change.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity: 0 }),
          });
        } catch (e) {
          console.error('[cart-market-cleanup] failed to remove', key, e);
        }
      }
      this.renderCart();
    } catch (e) {
      console.error('[cart-market-cleanup] error', e);
    }
  }

  bindEvents() {
    if (window.theme.listener == "false") {
      this.onProductAddedListener = this.onProductAdded.bind(this);
      document.addEventListener("cart-drawer:open", this.onOpen.bind(this));

      document.addEventListener("product:added", this.onProductAddedListener);
      this.delegateElement.on(
        "click",
        '[data-action="update-item-quantity"], [data-action="remove-item"]',
        this.updateItemQuantity.bind(this)
      );
      this.delegateElement.on(
        "change",
        '[data-action="update-change-quantity"]',
        this.updateItemQuantity.bind(this)
      );
      this.delegateElement.on(
        "quantity:changed",
        ".cart-item__quantity",
        this.updateItemQuantity.bind(this)
      );

      // Only bind replace cart item events if we're NOT on the cart page
      if (!(window.theme.cartMode === 'page' && window.location.pathname === window.routes.cart_page_url)) {
        this.delegateBody.on(
          "click",
          '[data-action="replace-cart-item"]',
          this.handleReplaceCartItem.bind(this)
        );
      }

      window.theme.listener = "true";
    }
  }

  onOpen() {
    if (this.element.getAttribute("aria-expanded") == "false") {
      setTimeout(() => {
        if (this.element.hasAttribute('data-open-drawer')) {
          this.focusElement = this.element.querySelector("[data-scrollable]");        }
      }, 500);

      if (this.options["showRecommendations"] && this.alreadyEntered == false) {
        this.loadRecommendations(true);
      }
    }
    const header = this.element.querySelector(".cart-drawer__header");
    const headerHeight = header.offsetHeight;

    document.documentElement.style.setProperty(
      "--cart-drawer__header-height",
      headerHeight + "px"
    );

    if (this.element.querySelector(".cart-drawer__footer")) {
      document.documentElement.style.setProperty(
        "--cart-drawer__footer-height",
        this.element.querySelector(".cart-drawer__footer").offsetHeight + "px"
      );
    }

    if (this.element.querySelector(".cart-drawer__shipping")) {
      document.documentElement.style.setProperty(
        "--cart-drawer__shipping-height",
        this.element.querySelector(".cart-drawer__shipping").offsetHeight + "px"
      );
    }
  }

  onClose() {
    if (this.breakpoint == 'desktop' && this.recommendationContainer) {
      this.recommendationContainer.setAttribute("aria-expanded", "false");
      this.recommendationContainer = null;
    }
  }

  handleTransitionEnd(target) {
    target.setAttribute("aria-hidden", "true");
    target.style.display = "none";
    this.recommendationContainer.removeEventListener(
      "transitionend",
      this.transitionEndHandler
    );
  }

  async handleReplaceCartItem(e) {
    e.preventDefault();

    const atcButton = e.target;
    atcButton.setAttribute("disabled", "disabled");

    // Step 1: Get the current line item ID from localStorage
    const currentLineId = localStorage.getItem("current-line-item");
    if (!currentLineId) {
      const errorMsg = "No line item ID found for replacement";
      setTimeout(() => {
        this.handleAddCartError(atcButton, errorMsg)
        atcButton.removeAttribute("disabled");
      }, 2000);
      return;
    }

    // Step 2: Get the quick-add form
    const form = document.querySelector('.quick-add-product form');
    if (!form) {
      console.error('Quick-add form not found');
      return;
    }

    // Step 3: Extract form data
    const formData = new FormData(form);
    const newVariantId = formData.get('id');
    const newQuantity = 1;

    // Step 4: Collect custom properties
    const newProperties = {};
    for (let [key, value] of formData.entries()) {
      if (key.startsWith('properties[')) {
        const propName = key.match(/properties\[(.*?)\]/)?.[1];
        if (propName) {
          newProperties[propName] = value;
        }
      }
    }

    // Step 5: Call the existing replaceCartItem method
    await this.replaceCartItem(e, currentLineId, newVariantId, newQuantity, newProperties);

    if (window.theme.cartMode === 'page') {
      location.href = window.routes.cart_page_url;
    }
  }

  async replaceCartItem(e, currentLineId, newVariantId, newQuantity = 1, newProperties = {}) {
    e.preventDefault();

    // If we're on the cart page, redirect to the product page for editing instead
    if (window.theme.cartMode === 'page' && window.location.pathname === window.routes.cart_page_url) {
      e.preventDefault();
      const cartItem = document.querySelector(`[data-line-id="${currentLineId}"]`)?.closest('.cart-item');
      if (cartItem) {
        const productLink = cartItem.querySelector('a[href*="/products/"]');
        if (productLink) {
          window.location.href = productLink.href;
          return;
        }
      }
      window.location.reload();
      return;
    }

    try {
      const addToCartButton = e.target;
      addToCartButton.setAttribute("disabled", "disabled");

      const cartItem = document.querySelector(`[data-line-id="${currentLineId}"]`)?.closest('.cart-item');
      if (cartItem) {
        const itemLoader = cartItem.querySelector('.itemLoader');
        if (itemLoader) itemLoader.classList.add('is-visible');
      }

      // Remove the current item
      const removeResponse = await fetch(`${window.routes.localeRootUrl}/cart/change.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({ id: currentLineId, quantity: 0 })
      });

      if (!removeResponse.ok) throw new Error('Failed to remove current item');

      // Step 2: Add the new item
      const addResponse = await fetch(`${window.routes.localeRootUrl}/cart/add.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
          items: [{ id: newVariantId, quantity: newQuantity, properties: newProperties }]
        })
      });

      const addData = await addResponse.json(); // Parse JSON once

      if (!addResponse.ok) {
        const errorMsg = addData.description || addData.message || addData.error || "Cannot add this quantity";
        console.warn("Add to cart failed:", errorMsg);

        // Refresh cart to show the removal (item was removed but add failed)
        await this.renderCart(false, false);

        // Show error and re-enable button
        this.handleAddCartError(addToCartButton, errorMsg);

        // Clean up
        localStorage.removeItem("current-line-item");
        this.currentLineId = null;

        throw new Error(errorMsg); // Stop execution
      }

      // Step 3: Refresh the cart drawer (success case)
      await this.renderCart(false, false);

      // Step 4: Cleanup
      localStorage.removeItem("current-line-item");
      this.currentLineId = null;

      // Step 5: Fire success event
      this.element.dispatchEvent(new CustomEvent('cart:item-replaced', {
        bubbles: true,
        detail: { oldLineId: currentLineId, newVariantId, newQuantity, newProperties, cartData: addData }
      }));

      return addData;

    } catch (error) {
      console.error('Error replacing cart item:', error);
      throw error;
    } finally {
      const cartItem = document.querySelector(`[data-line-id="${currentLineId}"]`)?.closest('.cart-item');
      if (cartItem) {
        const itemLoader = cartItem.querySelector('.itemLoader');
        if (itemLoader) itemLoader.classList.remove('is-visible');
      }
    }
  }

  handleAddCartError(addToCartButton, message) {
    const errorElement =
      this.element.querySelector(".ProductForm--Error") ||
      document.querySelector(".pm__form-error");

    if (errorElement) {
      errorElement.classList.add("visible");
      setTimeout(() => errorElement.classList.remove("visible"), 3000);
    } else {
      console.error(message);
    }

    addToCartButton.removeAttribute("disabled");
    this.pageLoader.style.width = 0;
  }

  async updateItemQuantity(event, target) {
    event.preventDefault();

    const cartItem = target.closest(".cart-item");
    const itemLoader = cartItem.querySelector(".itemLoader");
    if (itemLoader) itemLoader.classList.add("is-visible");

    // 🔹 Determine intended new quantity
    let quantity;
    if (target.tagName === "INPUT") {
      quantity = Math.max(parseInt(target.value, 10) || 0, 0);
    } else {
      quantity = parseInt(target.getAttribute("data-quantity"), 10);
    }

    const lineId = target.getAttribute("data-line-id");

    try {
      // Update cart via Shopify
      const payload = { id: lineId, quantity };

      const response = await fetch(`${window.routes.localeRootUrl}/cart/change.js`, {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await response.json();

      // Check if Shopify capped the quantity due to inventory limits
      // (happens when "Continue selling when out of stock" is enabled)
      const updatedItem = data.items.find(item => item.key === lineId);
      if (updatedItem && updatedItem.quantity < quantity) {
        console.warn(`⚠️ Shopify capped quantity from ${quantity} to ${updatedItem.quantity} (inventory limit)`);
        if (itemLoader) itemLoader.classList.remove("is-visible");
        return; // stop here, don't proceed with UI updates
      }

      // STEP 3: Handle UI updates
      if (window.theme.cartMode === "page" && window.location.pathname === window.routes.cart_page_url) {
        window.location.reload();
        return;
      }

      if (data.item_count == 0) {
        this.loader.classList.add("is-visible");
        this.renderCart(false, false);
      } else if (quantity == 0) {
        const nextItem = cartItem.nextElementSibling;
        cartItem.classList.add("removing");
        setTimeout(() => {
          cartItem.remove();
          if (nextItem) {
            nextItem.classList.add("repo--top");
            setTimeout(() => nextItem.classList.remove("repo--top"), 350);
          }
        }, 350);
        if (data.item_count > 0 && this.options.showRecommendations) {
          this.options["productId"] = data.items[0].product_id;
          this.renderCart(false, false, false, null, true);
          return;
        }
      } else {
        const lineNumber = cartItem?.id || target.getAttribute("data-id") || lineId;
        this.renderCart(lineNumber, true);
      }
    } catch (err) {
      console.error("Failed to update item quantity:", err);
    } finally {
      if (itemLoader) itemLoader.classList.remove("is-visible");
    }
  }

  onProductAdded(event) {
    let details = false;
    if (event.detail) {
      details = event.detail;
    }

    if (window.theme.cartCount == 0 && this.isOpen == true) {
      this.loader.classList.add("is-visible");
    }

    this.renderCart(false, false, true, details).then(() => {
      if (this.element.hasAttribute('data-open-drawer')) {
        if (this.isOpen == false) {
          this.isOpen = true;
          this.onOpen();
          this.alreadyEntered = true;
          this.drawer.openDrawer();
        }
      }

      Toast.success(
        window.toastStrings?.added_to_cart_title || 'Added to cart',
        '',
        window.toastStrings?.view_cart || 'View'
      );
    });
  }

  renderCart(lineNumber, quantityChange, productAdd, productAddEvent, updateCount) {
    // If we're on the cart page, just reload the page instead of trying to render cart drawer
    if (window.theme.cartMode === 'page' && window.location.pathname === window.routes.cart_page_url) {
      window.location.reload();
      return Promise.resolve();
    }

    this.pageLoader.style.width = 90 + "%";
    var _this = this;
    return fetch(
      window.routes.localeRootUrl + "/?section_id=main-cart_drawer",
      {
        credentials: "same-origin",
        method: "GET",
      }
    ).then(function (content) {
      content.text().then(function (html) {
        _this.replaceContent(
          html,
          lineNumber,
          quantityChange,
          productAdd,
          productAddEvent,
          updateCount
        );

      });
    });
  }

  replaceContent(
    html,
    lineNumber,
    quantityChange,
    productAdd,
    productAddEvent,
    updateCount
  ) {

    // Prepare the page loader animation
    this.pageLoader.style.width = "100%";
    setTimeout(() => {
      this.pageLoader.style.left = "unset";
      this.pageLoader.style.right = "0px";
      this.pageLoader.style.width = "0%";

      setTimeout(() => {
        this.pageLoader.style.left = "0px";
        this.pageLoader.style.right = "unset";
      }, 550);

    }, 100)

    // Create a temporary element to parse the new HTML content
    const tempElement = document.createElement("div");
    tempElement.innerHTML = html;

    // Extract options and update cart count
    const newOptions = JSON.parse(
      tempElement.querySelector("#cart-drawer").getAttribute("data-settings")
    );
    this.options = newOptions;

    if (tempElement.querySelector("[data-ids]")) {
      this.cartIds = tempElement
        .querySelector("[data-ids]")
        .dataset.ids.split(",")
        .filter((item) => item !== "");
      if (updateCount) {
        this.cartIds = this.cartIds.filter((item) => item !== this.removeId);
        this.removeid = null;
        this.loadRecommendations();
      }
    } else {
      // Fixed: Initialize as empty array when no items in cart
      this.cartIds = [];
    }

    const itemCount = newOptions.itemCount;
    window.theme.cartCount = parseInt(itemCount);
    const countEls = document.querySelectorAll('.header__cart-count');
    const drawerCountEl = document.querySelector(".cart-drawer__count");

    if (countEls.length > 0) {
      countEls.forEach((el) => {
        if (itemCount > 0) {
          el.textContent = '';
          el.style.display = '';
        } else {
          el.textContent = '';
          el.style.display = 'none';
        }
      });
    }

    if (drawerCountEl) drawerCountEl.innerHTML = `(${itemCount})`;

    if (updateCount) {
      this.updateCartFooter(tempElement);
      return;
    }
    if (lineNumber && tempElement.querySelector(`#${lineNumber}`)) {
      this.updateCartItem(lineNumber, tempElement);
    } else if (productAdd && stateWasEmpty == false && lineNumber) {
      this.addContent(tempElement, productAddEvent);
    } else {
      this.replaceCartContent(tempElement);
    }

    this.updateCartFooter(tempElement);

    this.element.dispatchEvent(
      new CustomEvent("cart:render", { bubbles: true })
    );

    if (itemCount == 0) {
      stateWasEmpty = true;
    } else {
      stateWasEmpty = false;
    }

    // Additional actions after a brief delay
    setTimeout(() => {
      if (
        this.options.showRecommendations &&
        this.isOpen == true
      ) {
        this.loadRecommendations();
      }
    }, 200);
  }

  updateCartItem(lineNumber, tempElement) {
    const cartItemParent = this.element.querySelector(`#${lineNumber}`);
    const newCartItemInfo = tempElement.querySelector(
      `#${lineNumber} .cart-item__info `
    );
    const oldCartItemInfo = cartItemParent.querySelector(`#${lineNumber} .cart-item__info`);

    if (!cartItemParent) {
      this.element
        .querySelector(".itemLoader")
        .classList.remove("is-visible");
    } else {
      cartItemParent
        .querySelector(".itemLoader")
        .classList.remove("is-visible");
    }

    if (newCartItemInfo) {
      cartItemParent.querySelector('.cart-item__inner').replaceChild(
        newCartItemInfo,
        oldCartItemInfo
      );
    } else if (cartItemParent) {
      this.removeCartItem(cartItemParent);
    }
  }

  addContent(tempElement, productAddEvent) {
    if (this.isOpen) {
      this.element.querySelector(".cart-drawer__wrapper").scrollTop = 0;

    }
    const itemToAdd = tempElement.querySelector(
      `#cart-item__${productAddEvent.variant}`
    );
    const cartWrapper = this.element.querySelector(".cart-drawer__items");
    const firstItem = cartWrapper.firstElementChild;
    if (cartWrapper.querySelector(`#cart-item__${productAddEvent.variant}`)) {
      this.updateCartItem(`cart-item__${productAddEvent.variant}`, tempElement);
    } else {
      const height = this.calculateDetachedElement(itemToAdd);
      document.documentElement.style.setProperty(
        "--repositioning_value",
        `${height}px`
      );
      firstItem.classList.add("repo--bottom");
      this.loader.classList.remove("is-visible");
      setTimeout(() => {
        cartWrapper.prepend(itemToAdd);
        itemToAdd.classList.add("repo--adding");
        firstItem.classList.remove("repo--bottom");

        setTimeout(() => {
          itemToAdd.classList.remove("repo--adding");
        }, 350);
      }, 350);
    }
  }

  calculateDetachedElement(element) {
    // 1. Create a detached container
    const detachedContainer = document.createElement("div");
    detachedContainer.style.position = "absolute";
    detachedContainer.style.visibility = "hidden";
    detachedContainer.style.height = "auto";
    detachedContainer.style.width = "auto";
    detachedContainer.style.top = "-9999px"; // Off-screen positioning

    // 2. Append the new item to the detached container
    detachedContainer.appendChild(element);

    // 3. Append the detached container to the body (but off-screen)
    this.element.appendChild(detachedContainer);

    // 4. Get the offset height of the new item
    const newItemHeight = element.offsetHeight + 16;

    // 5. Remove the detached container from the DOM
    this.element.removeChild(detachedContainer);

    // Now you have the height of the new item without it ever being visible
    return newItemHeight;
  }

  updateCartFooter(tempElement) {
    const itemCount = this.options.itemCount;
    if (itemCount > 0) {

      const footerParent = document.querySelector(".cart-drawer__footer");

      const newFooterTotals = tempElement.querySelector(
        ".cart_drawer__footer-totals"
      );
      const oldFooterTotals = document.querySelector(".cart_drawer__footer-totals");

      if (!footerParent || !newFooterTotals) return;
      if (oldFooterTotals) {

        footerParent.replaceChild(
          newFooterTotals,
          oldFooterTotals
        );
      } else {
        footerParent.prepend(newFooterTotals);
      }

      const newShippingBar = tempElement.querySelector(
        ".cart-drawer__shipping-progress-bar"
      );
      if (newShippingBar) {
        const currentShippingBar = document.querySelector(
          ".cart-drawer__shipping-progress-bar"
        );
        if (currentShippingBar) {
          let percent = newShippingBar.dataset.percent;
          if (percent > 100) {
            percent = 100;
          }
          currentShippingBar.dataset.percent = percent;
          currentShippingBar.style.width = `${percent}%`;
          if (percent == 100) {
            currentShippingBar.classList.add("done");
            currentShippingBar.classList.remove("active");
          } else {
            currentShippingBar.classList.remove("done");
            currentShippingBar.classList.add("active");
          }
          this.element.querySelector(".cart-drawer__shipping-text").innerHTML =
            tempElement.querySelector(".cart-drawer__shipping-text").innerHTML;
        } else {
          const headerParent = this.element.querySelector(
            ".cart-drawer__header"
          );
          headerParent.appendChild(
            tempElement.querySelector(".cart-drawer__shipping")
          );
        }
      }

    } else {
      this.clearCartFooter(tempElement);
      stateWasEmpty = true;
    }

    if (this.element.querySelector(".cart-drawer__footer")) {
      document.documentElement.style.setProperty(
        "--cart-drawer__footer-height",
        this.element.querySelector(".cart-drawer__footer").offsetHeight + "px"
      );
    }

    if (this.element.querySelector(".cart-drawer__shipping")) {
      document.documentElement.style.setProperty(
        "--cart-drawer__shipping-height",
        this.element.querySelector(".cart-drawer__shipping").offsetHeight + "px"
      );
    }
  }

  clearCartFooter(tempElement) {

    if (!tempElement.querySelector(".cart-drawer__wrapper")) return;
    if (document.querySelector(".cart-drawer__footer")) {
      document
        .querySelector(".cart-drawer__footer")
        .classList.add("removing");
    }

    const wrapperParent = this.element.querySelector(".cart-drawer__wrapper");
    if (wrapperParent) {
      wrapperParent.innerHTML = tempElement.querySelector(
        ".cart-drawer__wrapper"
      ).innerHTML;
    }
  }

  replaceCartContent(tempElement) {

    const cartWrapperParent = this.element.querySelector(
      ".cart-drawer__wrapper"
    ).parentNode;
    const currentScrollPosition = this.element.querySelector(
      ".cart-drawer__wrapper"
    ).scrollTop;

    cartWrapperParent.replaceChild(
      tempElement.querySelector(".cart-drawer__wrapper"),
      this.element.querySelector(".cart-drawer__wrapper")
    );
    setTimeout(() => {
      this.loader.classList.remove("is-visible");
    }, 200);
    this.element.querySelector(".cart-drawer__wrapper").scrollTop =
      currentScrollPosition;

    setTimeout(() => {
      const header = this.element.querySelector(".cart-drawer__header");
      const headerHeight = header.offsetHeight;

      document.documentElement.style.setProperty(
        "--cart-drawer__header-height",
        headerHeight + "px"
      );
      if (cartWrapperParent.querySelector(".cart-drawer__footer")) {
        document.documentElement.style.setProperty(
          "--cart-drawer__footer-height",
          cartWrapperParent.querySelector(".cart-drawer__footer").offsetHeight + "px"
        );
      }

      if (cartWrapperParent.querySelector(".cart-drawer__shipping")) {
        document.documentElement.style.setProperty(
          "--cart-drawer__shipping-height",
          cartWrapperParent.querySelector(".cart-drawer__shipping").offsetHeight + "px"
        );
      }

    }, 100);
  }

  async loadRecommendations() {
    let recommendationsContainer = this.element.querySelector(
      ".cart-drawer__recommendations"
    );

    // Check if recommendations container exists before proceeding
    if (!recommendationsContainer) {
      console.warn("Recommendations container not found");
      return;
    }

    this.recommendationLoading = true;

    const productId = this.options["productId"];
    const baseUrl = window.routes.localeRootUrl;
    let url;

    // Determine the URL based on whether a product ID is present
    if (!productId) {
      // Fixed: Use proper base URL for empty cart recommendations
      url = `${baseUrl}?section_id=helper-recommendations`;
    } else {
      let limit = this.element.getAttribute('product-limit');
      url = `${baseUrl}/recommendations/products?section_id=helper-recommendations&product_id=${productId}&limit=${limit}&intent=${this.options["intent"]}`;
    }

    recommendationsContainer.classList.remove("transition--done");
    if (this.recommendationsOpen == true) {
      recommendationsContainer.classList.add("transition");
    }

    return await fetch(url)
      .then((response) => response.text())
      .then((content) => {
        this.recommendationLoading = false;
        const container = document.createElement("div");
        container.innerHTML = content;

        let recommendedIds = null;
        if (container.querySelector(".cart-drawer__rec-item")) {
          recommendedIds = [
            ...container.querySelectorAll(".cart-drawer__rec-item"),
          ].map((item) => item.dataset.id);
        }

        // Fixed: Initialize cartIds properly for empty cart scenario
        if (!this.cartIds) {
          if (recommendationsContainer.dataset.ids) {
            // Cart has items - get IDs from data attribute
            this.cartIds = recommendationsContainer.dataset.ids
              .split(",")
              .filter((item) => item !== "");
          } else {
            // Cart is empty - initialize as empty array instead of false
            this.cartIds = [];
          }
        }

        // Fixed: Handle empty cart scenario properly
        if (this.cartIds && recommendedIds && recommendedIds.length > 0) {
          // Only check for common items if cart actually has items
          if (this.cartIds.length > 0) {
            const hasCommonItem = this.cartIds.some((item) =>
              recommendedIds.includes(item)
            );

            if (hasCommonItem) {
              return;
            }
          }
          // If cart is empty (cartIds.length === 0), skip the common item check
          // and proceed to show recommendations
        }

        if (recommendedIds && recommendedIds.length > 0) {
          let recommendationsHTML = container.querySelector(
            ".cart-drawer__upsell"
          )?.innerHTML;

          if (recommendationsHTML) {
            recommendationsContainer.innerHTML = recommendationsHTML;
          }

          new AddToCart(this.element);
          new RevolutionAnimation(this.element.querySelector(".cart-drawer__recommendations", "true"));
        } else {
        }
      })
      .catch((error) => {
        console.error("Failed to load recommendations:", error);
      });
  }

  handleTransitionRec(target, container) {
    if (event.propertyName !== "transform") return;
    target.setAttribute("aria-hidden", "true");
    target.style.display = "none";
    container.classList.remove("transition");
    this.recommendationsOpen = false;
    this.el.removeEventListener("transitionend", this.transitionRecEnd);
  }

}
customElements.define("cart-drawer", CartDrawer);

class QuickAddDrawer extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
  }

  connectedCallback() {
    new AddToCart(this.element);
    new Drawer(this.element);
    this.spinningLoader = this.element.querySelector('.quick-add-drawer .Drawer--Content .spinningLoader');
    this.currentLineId = null;

    this.bindEvents();
  }

  bindEvents() {
    // Listen for clicks on any button with data-product-url
    this.delegateBody.on(
      'click',
      '.pc__instant-atc, .cart-item__edit',
      this.handleAtcClick.bind(this)
    );

    document.addEventListener("quick-add-drawer:product-loaded", this.setupHeightVariables.bind(this));
  }

  setupHeightVariables() {
    if (this.element.querySelector(".quick-add-drawer .Drawer--Header")) {
      document.documentElement.style.setProperty(
        "--quick-add-drawer__header-height",
        this.element.querySelector(".quick-add-drawer .Drawer--Header").offsetHeight + "px"
      );
    }

    if (this.element.querySelector(".quick-add-product__footer")) {
      document.documentElement.style.setProperty(
        "--quick-add-drawer__footer-height",
        this.element.querySelector(".quick-add-product__footer").offsetHeight + "px"
      );
    }
  }

  handleAtcClick(e) {
    const button = e.target.closest('[data-product-url]');
    if (!button) return;

    const productUrl = button.getAttribute('data-product-url');
    this.currentLineId = button.getAttribute("data-line-id");

    this.openDrawerWithProduct(productUrl);
  }

  async openDrawerWithProduct(url) {
    try {
      this.setLoadingState(true);

      const response = await fetch(url + '?view=quick-add');
      const html = await response.text();

      const placeholder = this.querySelector('.pc__information-placeholder');
      placeholder.innerHTML = html;

      this.element.dispatchEvent(new CustomEvent('quick-add-drawer:product-loaded', { bubbles: true }));

      // EDIT MODE
      // If we have a currentLineId, this is an edit operation
      if (this.currentLineId) {

        localStorage.setItem("current-line-item", this.currentLineId);
        localStorage.setItem("quick-atc-drawer-mode", 'edit-cart');
        const submitButton = this.element.querySelector(".quick-add-product__footer .pm__atc-button--main");
        if (submitButton) {
          submitButton.setAttribute("data-action", "replace-cart-item");
        }
      } else {
        // Clean up any previous edit state
        localStorage.removeItem("current-line-item");
        localStorage.removeItem("quick-atc-drawer-mode", 'add-to-cart');
      }
    } catch (error) {
      console.error('Error loading product:', error);
    } finally {
      this.setLoadingState(false);
    }
  }

  setLoadingState(isLoading) {
    if (isLoading) {
      this.spinningLoader.classList.add('is-visible');
    } else {
      this.spinningLoader.classList.remove('is-visible');
    }
  }
}

customElements.define("quick-add-drawer", QuickAddDrawer);


class CarouselTest extends HTMLElement {
  constructor() {
    super();
    const _this = this;
    this.element = this;
    this.domDelegate = new Delegate(this.element);

    this.bindEvents();

    new AddToCart(this.element);
  }

  bindEvents() {

  }

}
customElements.define("carousel-test", CarouselTest);


class CollectionShowcase extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.responsive = new Responsive(true, false);
    this.layoutOption = this.dataset.layout;

    this.activeSwiper = null;
    this.hoverUnsubscribers = [];

    if (this.layoutOption === "slider") {
      this.dynamicDesc = this.querySelector(".collection-showcase__header-dynamic--description");
      this.totalSlides = Number(this.querySelector("swiper-init")?.dataset.totalSlides || 0);

      // Apply font type if available
      const fontType = this.querySelector(".collection-showcase__item")?.getAttribute("data-font-type");
      if (this.dynamicDesc && fontType) {
        this.dynamicDesc.classList.add(`u-${fontType}`);
      }

      this.setupMode();
      document.addEventListener("breakpoint:changed", this.setupMode.bind(this));
      this.initDragIndicatorHelper();
    }

  }

  setupMode() {
    if (this.layoutOption !== "slider") return;
    this.clearListeners();

    if (this.responsive.currentBreakpoint === "desktop") {
      this.enableHoverMode();
    } else {
      this.enableSwiperMode();
    }
  }

  clearListeners() {
    if (this.activeSwiper) {
      this.activeSwiper.off("slideChange");
      this.activeSwiper = null;
    }
    this.hoverUnsubscribers.forEach(unsub => unsub());
    this.hoverUnsubscribers = [];
  }

  enableSwiperMode() {
    this.addEventListener(
      "swiper:initialized",
      e => {
        const swiperObj = e.detail?.swiper;
        if (!swiperObj?.swiperElement) return;
        const swiper = swiperObj.swiperElement;
        this.activeSwiper = swiper;
        this.updateFromIndex(swiper.activeIndex);
        swiper.on("slideChange", () => this.updateFromIndex(swiper.activeIndex));
      },
      { once: true }
    );
  }

  enableHoverMode() {
    const slides = [...this.element.querySelectorAll(".swiper-slide")];
    slides.forEach((slide, index) => {
      const enter = () => this.updateFromIndex(index);
      slide.addEventListener("mouseenter", enter);
      this.hoverUnsubscribers.push(() => slide.removeEventListener("mouseenter", enter));
    });
    this.updateFromIndex(0);
  }

  updateFromIndex(i) {
    if (!this.dynamicDesc) return;

    const activeSlide = this.element.querySelector(`.swiper-slide:nth-child(${i + 1})`);
    const description = activeSlide?.dataset.description || "";
    this.dynamicDesc.innerHTML = description;
  }

  initDragIndicatorHelper() {
    const indicator = this.element.querySelector('.drag-indicator');
    if (!indicator) return;

    const swiperInitEl = this.element.querySelector('swiper-init.swiper');
    if (!swiperInitEl) return;

    let areas = Array.from(swiperInitEl.querySelectorAll('[data-drag-area]'));
    if (!areas.length && swiperInitEl.hasAttribute('data-drag-area')) areas = [swiperInitEl];
    if (!areas.length) return;

    let isOverArea = false;
    let isDragging = false;
    let isDraggable = false;

    const getSwiperInstance = () => {
      const rev = typeof swiperInitEl.getSwiper === 'function' ? swiperInitEl.getSwiper() : null;
      return rev && rev.swiperElement ? rev.swiperElement : null;
    };

    const computeDraggable = () => {
      const s = getSwiperInstance();
      if (!s) {
        isDraggable = false;
        return;
      }
      const locked = !!s.isLocked;
      const touchAllowed = s.allowTouchMove !== false;
      const hasMultipleSlides = Array.isArray(s.slides) ? s.slides.length > 1 : true;
      isDraggable = touchAllowed && !locked && hasMultipleSlides;
    };

    const show = () => {
      if (isOverArea && !isDragging && isDraggable) indicator.classList.add('is-visible');
    };

    const hide = () => indicator.classList.remove('is-visible');

    const refresh = () => {
      computeDraggable();
      if (!isDraggable) hide();
      else show();
    };

    const onMove = (e) => {
      if (!isOverArea || !isDraggable) return;
      indicator.style.left = `${e.clientX}px`;
      indicator.style.top = `${e.clientY}px`;
    };

    const onUp = () => {
      isDragging = false;
      show();
    };

    document.addEventListener('pointermove', onMove, { passive: true });
    document.addEventListener('pointerup', onUp, { passive: true });
    document.addEventListener('pointercancel', onUp, { passive: true });

    areas.forEach((area) => {
      area.addEventListener('pointerenter', () => {
        isOverArea = true;
        refresh();
      }, { passive: true });

      area.addEventListener('pointerleave', () => {
        isOverArea = false;
        isDragging = false;
        hide();
      }, { passive: true });

      area.addEventListener('pointerdown', () => {
        isDragging = true;
        hide();
      }, { passive: true });
    });

    const onSwiperEvent = (e) => {
      if (e.target !== swiperInitEl) return;
      refresh();
    };

    this.element.addEventListener('swiper:initialized', onSwiperEvent);
    this.element.addEventListener('swiper:destroyed', onSwiperEvent);

    let tries = 0;
    const tryInit = () => {
      refresh();
      if (getSwiperInstance() || tries++ > 60) return;
      requestAnimationFrame(tryInit);
    };
    requestAnimationFrame(tryInit);

    hide();
  }
}

customElements.define("collection-showcase", CollectionShowcase);

class SliderTextSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.carouselElement = this.element.querySelector(".swiper");
    this.carousel = new RevolutionSwiper(this.carouselElement);

  }
}
customElements.define("slider-text", SliderTextSection);

class Banner extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.previousRealIndex = 0;
    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );
    this.hasAutoplay = !!this.options.autoplay;
    this.swiperElement = this.querySelector('swiper-init');

    if (this.options.numberOfSlides > 1) {
      this.swiperElement.addEventListener('swiper:initialized', () => {
        this.carousel = this.swiperElement.getSwiper();
        this.fixPagination();
        this.positionPagination();
        const swiper = this.carousel.swiperElement;

        swiper.on("slideChange", () => requestAnimationFrame(() => this.positionPagination()));
        swiper.on("slideChangeTransitionEnd", () => this.positionPagination());
        swiper.on("resize", () => this.positionPagination());
        this.bindHalfClick();
        this.bindHalfHoverCursor();

        if (this.hasAutoplay && this.options.deferAutoplay) {
          this.deferAutoplay(swiper);
        }

        this.applyReducedMotionPreference(swiper);
      });

      this.handleResize = debounce(this.onResize.bind(this), 250);
      window.addEventListener('resize', this.handleResize);

      this.onImagesReady = this.createObserver.bind(this);
      this.swiperElement.addEventListener("swiper:slide-changed", () => {
        this.createObserver();
      });

      this.createObserver();
    } else {
      this.createObserver();
    }

    this.bindEvents();
  }

  /**
   * Honour an OS-level request for reduced motion by not auto-advancing the slideshow.
   * No UI: this only responds to a preference the user has already expressed in their
   * system settings, and leaves the slideshow untouched for everyone else.
   * @param {Object} swiper - the underlying Swiper instance
   */
  applyReducedMotionPreference(swiper) {
    if (!swiper || !swiper.autoplay) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      swiper.autoplay.stop();
    }
  }

  bindEvents() {
    let hasSlideChanged = false;
    this.swiperElement?.addEventListener('swiper:initialized', () => {
      this.carousel?.swiperElement?.on("slideChange", function () {
        if (!hasSlideChanged) {
          const pagination = document.querySelector('.media-slideshow__pagination--autoplay');
          if (pagination) {
            pagination.classList.add('slideshow-started');
          }
          hasSlideChanged = true;
        }
      });
    });
  }

  bindHalfClick() {
    if (this.__halfClickBound) return;
    this.__halfClickBound = true;

    const isInteractive = (t) =>
      !!t.closest("a,button,input,textarea,select,summary,details,[role='button'],[data-no-slide-click]");

    const target =
      this.element.querySelector(".media-slideshow__wrapper") || this.element;

    target.addEventListener("pointerup", (e) => {
      if (!responsive.matchesBreakpoint("lap_and_up")) return;

      if (e.button && e.button !== 0) return;
      if (isInteractive(e.target)) return;

      const swiper = this.carousel?.swiperElement;
      if (!swiper) return;

      const rect = this.element.getBoundingClientRect();
      const x = e.clientX - rect.left;

      // Swiper edge info
      const params = swiper.params || {};
      const loopsOrRewinds = !!params.loop || !!params.rewind;

      const atBeginning = swiper.isBeginning && !loopsOrRewinds;
      const atEnd = swiper.isEnd && !loopsOrRewinds;

      if (x < rect.width / 2) {
        if (atBeginning) return;
        swiper.slidePrev();
      } else {
        if (atEnd) return;
        swiper.slideNext();
      }

      this.resetAutoplayAfterTransition();
    });
  }

  deferAutoplay(swiper) {
    if (!swiper?.autoplay) return;
    swiper.autoplay.stop();

    const startAutoplay = () => {
      this.autoplayStarted = true;
      swiper.autoplay.start();
      if (typeof swiper.autoplay.run === "function") swiper.autoplay.run();
    };

    const onInteraction = () => {
      if (this.autoplayStarted) return;
      startAutoplay();
      this.element.removeEventListener("pointerdown", onInteraction);
      this.element.removeEventListener("pointerenter", onInteraction);
    };

    this.element.addEventListener("pointerdown", onInteraction);
    this.element.addEventListener("pointerenter", onInteraction);
  }

  resetAutoplayAfterTransition() {
    if (!this.hasAutoplay) return;
    const swiper = this.carousel?.swiperElement;
    if (!swiper?.autoplay || !swiper.params.autoplay) return;

    const restart = () => {
      swiper.autoplay.stop();
      swiper.autoplay.start();
      if (typeof swiper.autoplay.run === "function") swiper.autoplay.run();
    };

    swiper.once("slideChangeTransitionEnd", restart);
  }

  onResize() {
    const newBreakpoint = responsive.getCurrentBreakpoint();

    if (this.currentBreakpoint !== newBreakpoint) {
      this.currentBreakpoint = newBreakpoint;

      if (this.options.numberOfSlides > 1) {
        this.changeImageQuality();

        setTimeout(() => {
          this.fixPagination();
          this.positionPagination();
        }, 100);
      }
    }
  }

  createObserver() {
    this.observer = new IntersectionObserver(this.handleIntersect.bind(this), { threshold: 0.5 });
    this.observer.observe(this.element);
  }

  handleIntersect(entries) {
    var _this = this;
    entries.forEach((entry) => {
      if (entry.intersectionRatio === 1 || entry.isIntersecting == true) {
        if (_this.options["numberOfSlides"] > 1) {
          _this.changeImageQuality();
        } else {
          _this.changeImageQuality(true);
        }
        _this.observer.unobserve(_this);
      }
    });
  }

  changeImageQuality(singleItem) {
    const breakpoint = responsive.getCurrentBreakpoint();

    let imageContainers;
    if (singleItem) {
      imageContainers =
        Array.from(this.element.querySelectorAll(".image__element")).slice(0, 2);

    } else {
      const currentIndex = this.carousel.swiperElement.activeIndex;
      const cellElement = this.carousel.swiperElement.slides[currentIndex];

      imageContainers = Array.from(
        cellElement.querySelectorAll(".image__element")).slice(0, 2);
    }

    if (imageContainers.length === 0) {
      return;
    }

    let imageToReveal;
    if (
      breakpoint === "pocket" ||
      breakpoint === "phone" ||
      breakpoint === "tablet"
    ) {
      imageToReveal = imageContainers[0];
    } else {
      if (imageContainers.length == 2) {
        imageToReveal = imageContainers[1];
      } else {
        imageToReveal = imageContainers[0];
      }
    }

    if (!imageToReveal || imageToReveal.dataset.loadedImage === "true") {
      return;
    }

    if (imageToReveal.dataset.src) {
      const replaceUrl = imageToReveal.dataset.src.replace(
        "{width}x",
        "width=2600"
      );
      imageToReveal.src = replaceUrl;
      imageToReveal.dataset.loadedImage = "true";
    }
  }

  fixPagination() {
    const paginationEl = this.element.querySelector(".media-slideshow__pagination");

    if (!paginationEl) {
      console.warn("Pagination element not found");
      return;
    }

    if (this.carousel && this.carousel.swiperElement) {
      this.carousel.swiperElement.pagination.render();
      this.carousel.swiperElement.pagination.update();

    }

    paginationEl.style.display = "flex";
    paginationEl.style.opacity = "1";
  }

  positionPagination() {
    if (this._rafPositionPagination) return;
    this._rafPositionPagination = requestAnimationFrame(() => {
      this._rafPositionPagination = null;

      const w = this.element.querySelector(".media-slideshow__wrapper");
      const p = this.element.querySelector(".media-slideshow__pagination");
      const s = this.element.querySelector(".swiper-slide-active");
      if (!w || !p || !s) return;

      // The campaign badge image sits in the slide too; it must never be taken for the slide media
      const m =
        s.querySelector(".banner__imageContainer .VideoRatio, .banner__imageContainer video, .banner__imageContainer img") ||
        s.querySelector(".VideoRatio, video, img:not(.split-media-img):not(.campaign-badge__img)") ||
        s;

      // Batch reads
      const wb = w.getBoundingClientRect();
      const mb = m.getBoundingClientRect();
      const offset = responsive.matchesBreakpoint("lap_and_up") ? 24 : 16;

      // Single write
      p.style.bottom = Math.max(0, wb.height - ((mb.bottom - wb.top) - offset)) + "px";
    });
  }

  bindHalfHoverCursor() {
    const target =
      this.element.querySelector(".media-slideshow__wrapper") || this.element;

    const isInteractive = (t) =>
      !!t.closest("a,button,input,textarea,select,summary,details,[role='button'],[data-no-slide-click]");

    target.addEventListener("pointermove", (e) => {
      if (!responsive.matchesBreakpoint("lap_and_up")) return;

      const swiper = this.carousel?.swiperElement;
      if (!swiper) return;

      if (e.target.closest(".hero-banner-txt-content__wrapper") || isInteractive(e.target)) {
        target.classList.remove("half-left", "half-right");
        return;
      }

      const rect = this.element.getBoundingClientRect();
      const x = e.clientX - rect.left;

      const params = swiper.params || {};
      const loopsOrRewinds = !!params.loop || !!params.rewind;

      const atBeginning = swiper.isBeginning && !loopsOrRewinds;
      const atEnd = swiper.isEnd && !loopsOrRewinds;

      // LEFT HALF
      if (x < rect.width / 2) {
        // On first slide in stop mode → default cursor (no arrow)
        if (atBeginning) {
          target.classList.remove("half-left", "half-right");
          return;
        }
        target.classList.add("half-left");
        target.classList.remove("half-right");
      } else {
        if (atEnd) {
          target.classList.remove("half-left", "half-right");
          return;
        }
        target.classList.add("half-right");
        target.classList.remove("half-left");
      }
    });

    target.addEventListener("pointerleave", () => {
      target.classList.remove("half-left", "half-right");
    });
  }

}
customElements.define("banner-hero", Banner);

class GlobalTopOffset {
  constructor() {
    this.root = document.documentElement;
    this._raf = null;
    this._cachedHeaderH = 0;
    this._cachedAnnH = 0;
    this._header = document.querySelector("#header");
    this._ann = document.querySelector("announcement-bar");

    this.update = this.update.bind(this);
    this.measureHeights = this.measureHeights.bind(this);

    // Only measure heights on resize/load/drawer events — not scroll
    window.addEventListener("resize", this._onMeasure, { passive: true });
    window.addEventListener("load", () => this._onMeasure());
    document.addEventListener("drawer:opened", () => this._onMeasure(), true);
    document.addEventListener("drawer:closed", () => this._onMeasure(), true);

    // Scroll only checks transparency class — no reflow
    window.addEventListener("scroll", this.requestUpdate, { passive: true });

    this.measureHeights();
    this.update();
  }

  _onMeasure = () => {
    this.measureHeights();
    this.requestUpdate();
  };

  measureHeights() {
    this._cachedHeaderH = this._header ? this._header.offsetHeight : 0;
    this._cachedAnnH = this._ann ? this._ann.offsetHeight : 0;
  }

  requestUpdate = () => {
    if (this._raf) return;
    this._raf = requestAnimationFrame(() => {
      this._raf = null;
      this.update();
    });
  };

  update() {
    const headerIsTransparent = this._header?.classList.contains("Header--Transparent");

    if (headerIsTransparent) {
      this.root.style.setProperty("--global-top-offset", "0px");
      return;
    }

    this.root.style.setProperty("--global-top-offset", `${this._cachedHeaderH + this._cachedAnnH}px`);
  }
}

new GlobalTopOffset();

class Header extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.options = JSON.parse(this.getAttribute("data-settings"));
    this.scrollableElement = this.element.querySelector("[data-scrollable]");
    this.announcementElement = document.querySelector(".announcement-bar--sticky");
    this.desktopMenuOverlayElement = document.querySelector(".desktopMenuOverlay");
    this.headerTransparent = false;
    this._isClosing = false;
    this.wasTransparentBeforeDrawer = false;
    this.drawerBlocksTransparency = false;
    this.prevOffset = window.scrollY || 0;
    this.activeOverlays = 0;
    this.topGuardPx = 12;

    if (this.options.sticky) {
      this.toggleSticky();
    } else if (this.announcementElement) {
      this.adjustToStickyAnn();
    }

    // Batch all layout reads into a single rAF to avoid layout thrashing
    requestAnimationFrame(() => {
      const headerEl = document.querySelector("#header");
      if (headerEl) {
        const headerHeight = headerEl.offsetHeight;
        document.documentElement.style.setProperty("--header-height-fixed", headerHeight + "px");
      }
      this.updateVisibleHeight();
    });
    window.onload = () => setTimeout(() => this.updateVisibleHeight(), 500);
    this.bindEvents();
    this.initMegaMenuLayoutVars();
    this.checkMenuWrap();
  }

  //Check if menu has 2 or more rows and adjust the ::after styling of menu items so they don't overlap
  checkMenuWrap() {
    const ul = this.element.querySelector('.desktop-menu-list');
    if (!ul) return;

    const lis = ul.querySelectorAll('.header-link-desk');
    if (lis.length === 0) return;

    const firstTop = lis[0].offsetTop;
    let hasWrapped = false;

    for (let i = 1; i < lis.length; i++) {
      if (lis[i].offsetTop !== firstTop) {
        hasWrapped = true;
        break;
      }
    }

    if (hasWrapped) {
      ul.classList.add('has-wrapped');
    } else {
      ul.classList.remove('has-wrapped');
    }
  }

  toggleSticky() {
    if (this.announcementElement) {
      this.element.parentElement.classList.add("header--sticky-with-ann");
    } else {
      this.element.parentElement.classList.add("header--sticky");
    }

    this.element.parentElement.classList.remove("Header--Transparent");
  }

  adjustToStickyAnn() {
    this.element.classList.add("header--not-sticky");
  }

  bindEvents() {
    const _this = this;

    this.checkMenuWrapListener = this.checkMenuWrap.bind(this);
    window.addEventListener("resize", this.checkMenuWrapListener);

    this.toggleColorListener = this.toggleColor.bind(this);
    this.toggleTopBarListener = this.toggleTopBar.bind(this);

    if (this.options.transparent) {
      scrollListener.addScrollListener(this, this.toggleColorListener);
    }

    window.addEventListener("scroll", this.toggleColorListener);
    window.addEventListener("scroll", this.toggleTopBarListener);

    this.delegateBody.on("menu:close", this.closeMenu.bind(this), true);

    // Listen for drawer/popup events
    this.delegateBody.on("drawer:opened", this.onDrawerOpened.bind(this), true);
    this.delegateBody.on("drawer:closed", this.onDrawerClosed.bind(this), true);

    this.delegateElement.on(
      "mouseenter",
      "[aria-hasMenu='true']",
      this.openMenu.bind(this),
      true
    );
    this.delegateElement.on(
      "focusin",
      "[aria-hasMenu='true']",
      this.openMenu.bind(this),
      true
    );

    this.delegateElement.on(
      "focusout",
      "[aria-hasMenu='true']",
      (e, target) => {
        const to = e.relatedTarget;
        // Still focusing inside this item / its dropdown
        if (to && target.contains(to)) return;
        if (this._escapedMenuItem === target) this._escapedMenuItem = null;

        // Wait for the next focusin (sibling menu / single item) to run first
        setTimeout(() => {
          if (!this.element?.isConnected) return;
          if (target.contains(document.activeElement)) return;
          if (target.getAttribute("aria-expanded") !== "true") return;

          const active = document.activeElement;
          if (active && this.element.contains(active)) {
            const otherMenu = active.closest('[aria-hasMenu="true"]');
            if (otherMenu && otherMenu !== target) return;
            if (active.closest("[aria-singleMenu]")) return;
          }

          this.closeMenu(e, target);
        }, 0);
      },
      true
    );

    this.delegateElement.on(
      "mouseleave",
      "[aria-hasMenu='true']",
      this.closeMenu.bind(this),
      true
    );

    this.delegateElement.on(
      "mouseenter",
      "[aria-singleMenu]",
      (e, target) => {
        const openElement =
          this.element.querySelector('.header-menu-items [aria-expanded="true"]') ||
          this.element.querySelector('[aria-hasMenu="true"][aria-expanded="true"]');

        if (openElement && openElement !== target) {
          this.closeSiblingMenu(openElement, false);
        }

        // Hide overlay when hovering over menu item with aria-singleMenu
        if (this.desktopMenuOverlayElement && this.desktopMenuOverlayElement.classList.contains('is-visible')) {
          this.desktopMenuOverlayElement.classList.remove("is-visible");
        }
      },
      true
    );

    this.delegateElement.on(
      "focusin",
      "[aria-singleMenu]",
      (e, target) => {
        const openElement =
          this.element.querySelector('.header-menu-items [aria-expanded="true"]') ||
          this.element.querySelector('[aria-hasMenu="true"][aria-expanded="true"]');

        if (openElement && openElement !== target) {
          this.closeSiblingMenu(openElement, false);
        }
      },
      true
    );

    this.delegateElement.on(
      "mouseenter",
      ".desktop-menu__dropdown-wrapper, [aria-submenu], .header-row-desktop",
      () => clearTimeout(this._menuCloseTimer),
      true
    );

    this.delegateElement.on(
      "mouseleave",
      ".desktop-menu__dropdown-wrapper, [aria-submenu], .header-row-desktop",
      (e, submenuEl) => {
        const to = e.relatedTarget;
        if (to && (submenuEl.contains(to) || to.closest('[aria-hasMenu="true"]'))) return;
        this.closeMenu(e, submenuEl);
      },
      true
    );

    this._debouncedUpdateVisibleHeight = () => {
      if (this._rafUpdateVisible) return;
      this._rafUpdateVisible = requestAnimationFrame(() => {
        this._rafUpdateVisible = null;
        this.updateVisibleHeight();
      });
    };
    window.addEventListener("scroll", this._debouncedUpdateVisibleHeight, { passive: true });
    window.addEventListener("resize", this._debouncedUpdateVisibleHeight);

    // The header slides via a CSS transform transition. Scroll-driven reads stop
    // firing once scrolling stops, but the transition keeps animating for up to
    // 0.3s, leaving a stale mid-slide value. Re-sync the final value when the
    // transform transition actually finishes so the height always settles correctly.
    this._onHeaderTransitionEnd = (e) => {
      if (e.target === this.element && e.propertyName === "transform") {
        this.updateVisibleHeight();
      }
    };
    this.element.addEventListener("transitionend", this._onHeaderTransitionEnd);

    this.onDocClick = (e) => {
      if (!this.element.contains(e.target) || e.target.classList.contains("header-hamburger-btn")) {
        this.forceCloseMenu();
      }
    };

    document.addEventListener("click", this.onDocClick);

    this.onKeyDown = (e) => {
      if (e.key !== "Escape") return;
      clearTimeout(this._menuOpenTimer);
      const openItem = this.element.querySelector('[aria-hasMenu="true"][aria-expanded="true"]');
      const focusedItem = document.activeElement?.closest?.('[aria-hasMenu="true"]');
      const item = openItem || (focusedItem && this.element.contains(focusedItem) ? focusedItem : null);
      this.forceCloseMenu();
      if (!item || !item.contains(document.activeElement)) return;
      // Focus would otherwise stay on a link inside the now-hidden dropdown. Moving it to
      // the top-level link fires focusin on the item, so suppress the focus-to-open once.
      this._escapedMenuItem = item;
      item.querySelector(".header-main-links")?.focus();
    };
    document.addEventListener("keydown", this.onKeyDown);

    /*  this.initSearch(); */

  }

  updateVisibleHeight() {
    // Batch all layout reads, then batch all writes
    const headerEl = document.querySelector("#header");
    const headerHeight = headerEl ? headerEl.offsetHeight : 0;

    let visibleHeight;
    if (this.element.classList.contains("is-hidden")) {
      // Header is (being) hidden — its target visible height is 0. Don't read the
      // mid-transition transform via getBoundingClientRect(), which yields stale
      // intermediate values when scrolling fast and fights toggleTopBar's 0 write.
      visibleHeight = 0;
    } else {
      const rect = this.element.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      visibleHeight = Math.max(Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0), 0);
    }

    document.documentElement.style.setProperty("--header-dynamic-height", `${visibleHeight}px`);
    document.documentElement.style.setProperty("--header-height-fixed", headerHeight + "px");
  }

  toggleTopBar() {
    const current = window.scrollY;

    if (current <= this.topGuardPx) {
      this.element.classList.remove('is-hidden');
      this.updateVisibleHeight();
      this.prevOffset = current;
      return;
    }

    if (current > this.prevOffset) {
      this.element.classList.add('is-hidden');
      document.documentElement.style.setProperty("--header-dynamic-height", `0px`);
    } else {
      this.element.classList.remove('is-hidden');
      this.updateVisibleHeight();
    }

    this.prevOffset = current;
  }

  updateMenuPosition() {
    requestAnimationFrame(() => {
      const headerEl = document.querySelector("#header");
      if (headerEl) {
        document.documentElement.style.setProperty("--submenu-position", `${headerEl.offsetHeight}px`);
      }
    });
  }

  async openMenu(event, target) {
    if (target.getAttribute("aria-expanded") === "true") {
      return;
    }

    if (this._escapedMenuItem) {
      const escaped = this._escapedMenuItem;
      if (event?.type === "focusin" && escaped === target) return;
      this._escapedMenuItem = null;
    }

    clearTimeout(this._menuCloseTimer);
    this._menuCloseTimer = null;
    clearTimeout(this._menuOpenTimer);

    // Short delay if a menu is already open (switching), longer for initial open
    const hasOpenMenu = !!this.element.querySelector('[aria-hasMenu="true"][aria-expanded="true"]');
    const delay = hasOpenMenu ? 50 : 200;

    this._menuOpenTimer = setTimeout(async () => {
      if (target.getAttribute("aria-expanded") === "true") return;

      // Pin dropdown below header using fixed height (header is always visible when menu opens)
      const headerEl = document.querySelector("#header");
      if (headerEl) {
        document.documentElement.style.setProperty("--header-dynamic-height", `${headerEl.offsetHeight}px`);
      }

      this.element.dispatchEvent(new CustomEvent("menu:open", { bubbles: true }));
      this.updateMenuPosition(target);

      if (this.element.classList.contains("Header--Transparent")) {
        this.element.classList.remove("Header--Transparent");
        this.headerTransparent = true;
      }

      const siblings = Array.from(target.parentElement.children).filter(
        (child) => child !== target && child.getAttribute("aria-expanded") === "true"
      );

      await Promise.all(siblings.map(s => this.closeSiblingMenu(s, true)));

      const wrapper = target.querySelector(".desktop-menu__dropdown-wrapper");
      if (wrapper) {
        wrapper.style.display = '';
        wrapper.classList.remove("slide-in", "fade-in", "slide-out", "fade-out");
      }

      target.setAttribute("data-menu-hidden", "false");
      target.setAttribute("aria-expanded", "true");

      if (wrapper && siblings.length === 0) {
        wrapper.classList.add("slide-in");
      }

      if (wrapper && this.desktopMenuOverlayElement) {
        this.desktopMenuOverlayElement.style.display = "block";
        requestAnimationFrame(() => {
          this.desktopMenuOverlayElement.classList.add("is-visible");
        });
      }

      bodyScrollLock.disableBodyScroll(this.scrollableElement, bodyScrollLockOptions);
    }, delay);
  }

  closeMenu(event, target) {
    clearTimeout(this._menuOpenTimer);

    if (event && event.type === "mouseleave") {
      const to = event.relatedTarget;

      if (to && (
        target.contains(to) ||
        to.closest('.desktop-menu__dropdown-wrapper, [aria-submenu], .header-row-desktop')
      )) {
        return;
      }
    }

    if (this._menuCloseTimer) {
      clearTimeout(this._menuCloseTimer);
    }

    // Use a shorter delay for better UX, then use animation events for the actual closing
    this._menuCloseTimer = setTimeout(async () => {
      this._menuCloseTimer = null;

      const openElement =
        this.element.querySelector('.header-menu-items [aria-expanded="true"]') ||
        this.element.querySelector('[aria-hasMenu="true"][aria-expanded="true"]');

      if (openElement) {
        // closeSiblingMenu now uses animationend events instead of timeouts
        await this.closeSiblingMenu(openElement, false);
      }

      // Hide desktopMenuOverlay when all menus are closed
      const anyMenuOpen = this.element.querySelector('[aria-hasMenu="true"][aria-expanded="true"]');
      if (!anyMenuOpen && this.desktopMenuOverlayElement) {
        this.desktopMenuOverlayElement.classList.remove("is-visible");
        const transitionEndHandler = () => {
          this.desktopMenuOverlayElement.style.display = "none";
          this.desktopMenuOverlayElement.removeEventListener("transitionend", transitionEndHandler);
        };
        this.desktopMenuOverlayElement.addEventListener("transitionend", transitionEndHandler);
        setTimeout(() => {
          this.desktopMenuOverlayElement.removeEventListener("transitionend", transitionEndHandler);
          this.desktopMenuOverlayElement.style.display = "none";
        }, 850);
      }

      this.toggleColor();
      if (window.globalPopup.activePopups.length === 0 && this.scrollableElement) bodyScrollLock.enableBodyScroll(this.scrollableElement);
    }, 100);
  }

  closeSiblingMenu(element, isSwitch = false) {
    return new Promise(resolve => {
      if (!element) return resolve();

      const wrapper = element.querySelector('.desktop-menu__dropdown-wrapper');
      if (!wrapper) return resolve();

      wrapper.classList.remove("slide-out", "fade-out", "slide-in", "fade-in");

      if (isSwitch) {
        element.setAttribute('aria-expanded', 'false');
        element.setAttribute('data-menu-hidden', 'true');
        resolve();
        return;
      }

      element.setAttribute('aria-expanded', 'false');
      wrapper.classList.add("slide-out");

      // Use animationend event instead of timeout
      const handleAnimationEnd = (e) => {
        if (e.target === wrapper && e.animationName === 'slideOut') {
          wrapper.removeEventListener('animationend', handleAnimationEnd);
          if (element.getAttribute('data-menu-hidden') !== 'true') {
            element.setAttribute('data-menu-hidden', 'true');
            wrapper.classList.remove("slide-out");
          }
          resolve();
        }
      };

      wrapper.addEventListener('animationend', handleAnimationEnd);

      // Fallback timeout in case animation doesn't trigger
      setTimeout(() => {
        wrapper.removeEventListener('animationend', handleAnimationEnd);
        if (element.getAttribute('data-menu-hidden') !== 'true') {
          element.setAttribute('data-menu-hidden', 'true');
          wrapper.classList.remove("slide-out");
        }
        resolve();
      }, 250);
    });
  }

  forceCloseMenu() {
    if (!this.element) return;

    clearTimeout(this._menuOpenTimer);
    clearTimeout(this._menuCloseTimer);
    this._menuCloseTimer = null;

    this.element
      .querySelectorAll('[aria-hasMenu="true"][aria-expanded="true"]')
      .forEach(el => {
        el.setAttribute('aria-expanded', 'false');
        el.setAttribute('data-menu-hidden', 'true');
      });

    // Hide desktopMenuOverlay when forcing close
    if (this.desktopMenuOverlayElement) {
      this.desktopMenuOverlayElement.classList.remove("is-visible");
      const transitionEndHandler = () => {
        this.desktopMenuOverlayElement.style.display = "none";
        this.desktopMenuOverlayElement.removeEventListener("transitionend", transitionEndHandler);
      };
      this.desktopMenuOverlayElement.addEventListener("transitionend", transitionEndHandler);
      setTimeout(() => {
        this.desktopMenuOverlayElement.removeEventListener("transitionend", transitionEndHandler);
        this.desktopMenuOverlayElement.style.display = "none";
      }, 850);
    }

    // Only enable body scroll if there are no active popups
    const hasActivePopups = window.globalPopup && window.globalPopup.activePopups && window.globalPopup.activePopups.length > 0;
    if (this.scrollableElement && !hasActivePopups) {
      try { bodyScrollLock.enableBodyScroll(this.scrollableElement); } catch (e) { }
    }

    this.toggleColor();
  }

  toggleColor() {
    if (window.pageYOffset > 25) {
      this.element.classList.add("header--scrolled");
    } else {
      this.element.classList.remove("header--scrolled");
    }

    // Don't add transparency if drawer is blocking it
    if (this.drawerBlocksTransparency) {
      return;
    }

    if (this.options.transparent) {
      if (window.pageYOffset > 25 && this.options.sticky) {
        this.element.classList.remove("Header--Transparent");
      } else {
        this.element.classList.add("Header--Transparent");
      }
    }
  }

  onDrawerOpened(event) {
    if (!this.options.transparent) return;

    this.drawerBlocksTransparency = true;
    this.wasTransparentBeforeDrawer = this.element.classList.contains("Header--Transparent");

    if (this.wasTransparentBeforeDrawer) {
      this.element.classList.remove("Header--Transparent");
    }
  }

  onDrawerClosed(event) {
    if (!this.options.transparent) return;

    this.drawerBlocksTransparency = false;

    if (this.wasTransparentBeforeDrawer && window.pageYOffset <= 25) {
      this.element.classList.add("Header--Transparent");
    }

    this.wasTransparentBeforeDrawer = false;
  }

  // Direct methods for drawer/popup control
  handleDrawerOpening() {
    // Check if header SHOULD be transparent based on current conditions
    const shouldBeTransparent = this.options.transparent &&
      (window.pageYOffset <= 25 || !this.options.sticky);

    if (shouldBeTransparent) {
      // If it should be transparent but isn't, something else removed it
      if (!this.element.classList.contains("Header--Transparent")) {
        this.wasTransparentBeforeDrawer = true;
      } else {
        this.wasTransparentBeforeDrawer = true;
        this.element.classList.remove("Header--Transparent");
      }
    } else {
      this.wasTransparentBeforeDrawer = false;
    }

    // Block transparency while drawer is open
    this.drawerBlocksTransparency = true;
  }

  handleDrawerClosing() {
    // Unblock transparency
    this.drawerBlocksTransparency = false;

    if (this.wasTransparentBeforeDrawer && this.options.transparent) {
      if (window.pageYOffset <= 25 || !this.options.sticky) {
        this.element.classList.add("Header--Transparent");
      }
    }

    this.wasTransparentBeforeDrawer = false;
  }

  setMegaMenuLayoutVars({
    upperSelector = ".desktop-menu__upper",
    holderSelector = ".desktopMenu--LinkHolder",
    collectionSelector = ".desktop-menu__collection",
    promoSelector = ".promo-block",
    menuVar = "--menu-cols",
    collectionVar = "--collection-cols",
    maxMenuCols = 7,
    maxCollectionsWithMenu = 2,
    minCollectionsNoMenu = 4,
    maxCollectionsNoMenu = 6,
    fixedMenuWidthPx = 796
  } = {}) {
    if (!window.matchMedia("(min-width:1025px)").matches) return;

    const uppers = this.element.querySelectorAll(upperSelector);

    uppers.forEach((upper) => {
      const holder = upper.querySelector(holderSelector);
      const collection = upper.querySelector(collectionSelector);

      // ---------------------------
      // 1) COUNT MENU "PARENT" ITEMS
      // ---------------------------
      let menuCols = 0;

      if (holder) {
        const menuColumns = Array.from(holder.children).filter((el) => {
          if (!(el instanceof HTMLElement)) return false;

          // real menu columns
          if (
            el.classList.contains("desktop-menu__featured-container") ||
            el.classList.contains("mainMenu--MultipleItems") ||
            el.classList.contains("main-menu__image-wrapper") ||
            el.classList.contains("desktop-menu__block-collection")
          ) {
            return true;
          }

          // not columns
          if (el.classList.contains("desktop-menu__custom-button")) return false;
          if (el.classList.contains("desktop-menu__thumb-container")) return false;
          if (el.classList.contains("desktop-menu__buttons-container")) return false;

          return false;
        });

        menuCols = Math.min(menuColumns.length, maxMenuCols);

        // Hide items beyond max columns
        menuColumns.forEach((col, index) => {
          if (index >= maxMenuCols) {
            col.style.display = "none";
          } else {
            col.style.display = "";
          }
        });

        // Count submenus and collection items
        const submenus = menuColumns.filter(el =>
          el.classList.contains("desktop-menu__featured-container") ||
          el.classList.contains("mainMenu--MultipleItems") ||
          el.classList.contains("main-menu__image-wrapper")
        );
        const collections = menuColumns.filter(el =>
          el.classList.contains("desktop-menu__block-collection")
        );

        const submenuCount = submenus.length;
        const collectionCount = collections.length;

        // Check if we need space-between layout
        const needsSpaceBetween = (
          (submenuCount === 2 && collectionCount === 2) ||
          (submenuCount === 1 && collectionCount === 2) ||
          (submenuCount === 1 && collectionCount === 3) ||
          (submenuCount === 1 && collectionCount === 1) ||
          (submenuCount === 1 && collectionCount === 0) ||
          (submenuCount === 0 && collectionCount === 1)
        );

        // Add or remove class for space-between layout
        if (needsSpaceBetween) {
          holder.classList.add("desktopMenu--spaceBetween");
        } else {
          holder.classList.remove("desktopMenu--spaceBetween");
        }

        // Add class if only collections (no menus)
        if (submenuCount === 0 && collectionCount > 0) {
          holder.classList.add("desktopMenu--collectionsOnly");
        } else {
          holder.classList.remove("desktopMenu--collectionsOnly");
        }

        // set cols var
        holder.style.setProperty(menuVar, menuCols || 0);
      }

      // ---------------------------
      // 2) COLLECTIONS VISIBILITY + COLS
      // ---------------------------
      if (!collection) return;

      const promos = Array.from(collection.querySelectorAll(promoSelector));
      promos.forEach(p => (p.style.display = "")); // reset first

      if (menuCols > 0) {
        // menu exists -> show only 2 collections
        const visible = promos.slice(0, maxCollectionsWithMenu);
        const hidden = promos.slice(maxCollectionsWithMenu);

        hidden.forEach(p => (p.style.display = "none"));

        upper.style.setProperty(collectionVar, visible.length);

      } else {
        // no menu -> collections-only layout
        const visibleCount = Math.min(promos.length, maxCollectionsNoMenu);

        promos.slice(visibleCount).forEach(p => (p.style.display = "none"));

        // columns min 4 max 6; 1-2 still use 4-col grid
        const cols =
          visibleCount <= minCollectionsNoMenu
            ? minCollectionsNoMenu
            : Math.min(visibleCount, maxCollectionsNoMenu);

        upper.style.setProperty(collectionVar, cols);
      }
    });
  }

  initMegaMenuLayoutVars(options) {
    const run = () => this.setMegaMenuLayoutVars(options);
    run();
    window.addEventListener("resize", run);
    document.addEventListener("shopify:section:load", run);
  }
}
customElements.define("header-component", Header);

class MainMenuDropdown extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    this.initializeDrawers();
    this.bindEvents();
    this.updateHeights();
    this.adjustCustomMenuItems();
  }

  initializeDrawers() {
    const allDrawers = this.element.querySelectorAll(".Drawer--wrapper");
    allDrawers.forEach((drawer) => new Drawer(drawer));
  }

  bindEvents() {
    window.addEventListener("resize", this.updateHeights.bind(this));

    this.delegateElement.on(
      "click",
      '[data-action="toggle-subdrawer"]',
      this.toggleNextElement.bind(this)
    );

    this.delegateElement.on(
      "click",
      '[data-action="toggle-prev-subdrawer"]',
      this.togglePreviousElement.bind(this)
    );

    this.delegateElement.on(
      "click",
      '[data-action="toggle-mob-acc"]',
      this.handleAccPopup.bind(this)
    );

    document.addEventListener(
      "menu-drawer:closed",
      this.closeSubdrawers.bind(this)
    );
  }

  measureHeight(element) {
    if (!element) return 0;
    const rectHeight = Math.round(element.getBoundingClientRect().height);
    return rectHeight || element.offsetHeight || element.clientHeight || 0;
  }

  updateHeights() {
    const openWrapper =
      this.element.querySelector('[data-subdrawer][aria-expanded="true"]') ||
      this.element.querySelector("#mobile-menu-drawer") ||
      this.element;

    const headerElement =
      openWrapper.querySelector(".menu__header") ||
      this.element.querySelector(".menu__header");

    const footerElement = this.element.querySelector(".menu__bottom-content");

    const headerHeight = this.measureHeight(headerElement);
    const footerHeight = this.measureHeight(footerElement);

    document.documentElement.style.setProperty(
      "--mobile-menu-header-height",
      `${headerHeight}px`
    );
    document.documentElement.style.setProperty(
      "--mobile-menu-footer-height",
      `${footerHeight}px`
    );
  }

  toggleNextElement(event, target) {
    event.preventDefault();

    const nextId = target.getAttribute("data-toggle-id");
    const subdrawer = document.getElementById(nextId);
    if (!subdrawer) return;

    // close any other open subdrawers
    const openSubdrawers = this.element.querySelectorAll(
      '[data-subdrawer][aria-expanded="true"]'
    );
    openSubdrawers.forEach((drawer) => {
      drawer.setAttribute("aria-expanded", "false");
      const focus = drawer.querySelector("[data-scrollable]");
      if (focus) bodyScrollLock.enableBodyScroll(focus);
    });

    // reset all toggle buttons
    this.element
      .querySelectorAll('[data-action="toggle-subdrawer"]')
      .forEach((btn) => btn.setAttribute("aria-expanded", "false"));

    subdrawer.style.display = '';

    // open this one (2-step so CSS transition runs)
    requestAnimationFrame(() => {
      subdrawer.setAttribute("aria-hidden", "false");
      subdrawer.setAttribute("aria-expanded", "false");
    });
    void subdrawer.getBoundingClientRect();

    requestAnimationFrame(() => {
      subdrawer.setAttribute("aria-expanded", "true");

      const focus = subdrawer.querySelector("[data-scrollable]");
      if (focus) bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);

      target.setAttribute("aria-expanded", "true");
      this.updateHeights();
    });
  }

  togglePreviousElement(event, target) {
    event.preventDefault();

    const subdrawer = target.closest('[data-subdrawer]');
    if (!subdrawer) return;

    subdrawer.setAttribute("aria-expanded", "false");

    const focus = subdrawer.querySelector("[data-scrollable]");
    if (focus) bodyScrollLock.enableBodyScroll(focus);

    const controllingButton = this.element.querySelector(
      `[data-action="toggle-subdrawer"][data-toggle-id="${subdrawer.id}"]`
    );
    if (controllingButton) controllingButton.setAttribute("aria-expanded", "false");

    const onEnd = (e) => {
      if (["transform", "opacity", "clip-path"].includes(e.propertyName)) {
        subdrawer.setAttribute("aria-hidden", "true");
        subdrawer.removeEventListener("transitionend", onEnd);
        subdrawer.removeEventListener("animationend", onEnd);
        this.updateHeights();
      }
    };

    subdrawer.addEventListener("transitionend", onEnd);
    subdrawer.addEventListener("animationend", onEnd);
  }

  closeSubdrawers(event) {
    if (event) event.preventDefault();

    const subdrawers = this.element.querySelectorAll(
      ".Drawer--wrapper.menu__wrapper"
    );

    subdrawers.forEach((drawer) => {
      drawer.setAttribute("aria-expanded", "false");
      drawer.setAttribute("aria-hidden", "true");

      const focus = drawer.querySelector("[data-scrollable]");
      if (focus) bodyScrollLock.enableBodyScroll(focus);
    });

    this.element
      .querySelectorAll('[data-action="toggle-subdrawer"]')
      .forEach((btn) => btn.setAttribute("aria-expanded", "false"));

    this.updateHeights();
  }

  handleAccPopup(event, target) {
    event.preventDefault();

    const button = target.closest('[data-action="toggle-mob-acc"]');
    const popupId = button && button.getAttribute("aria-controls");
    const popupElement = popupId && document.getElementById(popupId);
    if (!popupElement) return;

    const menuDrawer = Array.isArray(Drawer.instances)
      ? Drawer.instances.find((d) => d.element.id === "menu")
      : null;

    if (menuDrawer && menuDrawer.isOpen) {
      menuDrawer.closeDrawer();

      const style = window.getComputedStyle(menuDrawer.element);
      const durations = style.transitionDuration
        .split(",")
        .map((s) => parseFloat(s) || 0);
      const delays = style.transitionDelay
        .split(",")
        .map((s) => parseFloat(s) || 0);

      const waitMs = Math.max(
        ...durations.map((d, i) => (d + (delays[i] || 0)) * 1000)
      );

      setTimeout(() => {
        window.globalPopup.openPopup(popupElement);
      }, waitMs);
    } else {
      window.globalPopup.openPopup(popupElement);
    }
  }

  adjustCustomMenuItems() {
    // Get all desktop menu dropdowns
    const dropdowns = document.querySelectorAll('.desktop-menu__dropdown-wrapper');

    dropdowns.forEach(dropdown => {
      // Check if any custom link has an icon or subtitle
      const allCustomIcons = dropdown.querySelectorAll('.desktop-menu__custom-icon');
      const allCustomSubtitles = dropdown.querySelectorAll('.desktop-menu__custom-subtitle');

      const hasAnyIcon = Array.from(allCustomIcons).some(icon => icon.querySelector('img'));
      const hasAnySubtitle = Array.from(allCustomSubtitles).some(subtitle => subtitle.textContent.trim() !== '');

      if (hasAnyIcon) {
        allCustomIcons.forEach(icon => icon.classList.add('adjust'));
      } else {
        allCustomIcons.forEach(icon => icon.remove());
      }

      // Handle subtitles
      if (hasAnySubtitle) {
        allCustomSubtitles.forEach(subtitle => subtitle.classList.add('adjust'));
      } else {
        allCustomSubtitles.forEach(subtitle => subtitle.remove());
      }
    });
  }
}

customElements.define("main-menu-dropdown", MainMenuDropdown);

class Transition {
  constructor() {
    this.supportsViewTransitions = !!document.startViewTransition;
    this.pageOverlay = document.querySelector(".pageTransition");

    if (!this.isPageLoaded) {
      document.addEventListener(
        "DOMContentLoaded",
        this.onPageLoaded.bind(this)
      );
    } else {
      this.onPageLoaded();
    }
  }

  onPageLoaded() {
    this.isPageLoaded = true;
    // Skip overlay if browser handles it via @view-transition CSS
    if (this.supportsViewTransitions) return;
    // Localization market switch handles its own overlay lifecycle
    if (sessionStorage.getItem('localization-pending')) return;
    // Fallback for older browsers: show the overlay, then fade it out
    if (this.pageOverlay && window.theme.showPageTransition) {
      this.pageOverlay.style.display = "block";
      this.pageOverlay.animate([{ opacity: 1 }, { opacity: 0 }], {
        duration: 100,
        fill: "forwards",
        easing: "ease-in-out",
        iterations: 1,
      });
    }
  }

  onPageUnload(event, target) {
    if (
      event.defaultPrevented ||
      event.ctrlKey ||
      event.metaKey ||
      !window.theme.showPageTransition ||
      !this.pageOverlay
    ) {
      return;
    }

    event.preventDefault();

    if (this.supportsViewTransitions) {
      document.startViewTransition(() => {
        window.location.href = target.href;
      });
    } else if (this.pageOverlay) {
      this.pageOverlay.animate([{ opacity: 0 }, { opacity: 1 }], {
        duration: 250,
        fill: "forwards",
        easing: "ease-in-out",
      }).onfinish = () => {
        window.location.href = target.href;
      };
    }
  }
}
new Transition();

class VideoComponent extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );
    this.trueObserver = false;
    this.delegateElement = new Delegate(this.element);
    this._videoAssetsRequested = false;

    // Same pipeline as Happy Day: poster → first interaction; product card →
    // viewport; otherwise init (hidden menu embeds wait until visible).
    const hasPoster = this.hasVideoPoster();
    const productCardInitOnViewport =
      this.options["product_card_init_on_viewport"] === true;

    const startPlaybackPipeline = () => {
      if (!this.isConnected) return;
      if (productCardInitOnViewport) {
        this._initOnViewport();
        return;
      }
      if (hasPoster) {
        this._initOnInteraction();
        return;
      }
      if (!this.isVideoVisiblyRenderable() || !this.isInViewport()) {
        this.observeAndLoad();
        return;
      }
      this._initVideo();
    };

    startPlaybackPipeline();
  }

  hasVideoPoster() {
    // Only a poster already on the page counts: one still inside the <template>
    // is invisible, so waiting for interaction would leave a blank box.
    return !!(
      this.element.querySelector(".videoHolder--Placeholder") ||
      this.element
        .closest(".VideoRatio, .VideoRatio--Full")
        ?.querySelector("[data-video-poster], .videoHolder--Placeholder")
    );
  }

  _initVideo() {
    if (this.options["using_fade"] == "fade") {
      const swiperSlide = this.element.closest(".swiper-slide");
      if (
        this.element.dataset.position == 0 ||
        (swiperSlide && swiperSlide.classList.contains("swiper-slide-active")) ||
        (swiperSlide &&
          swiperSlide.classList.contains("swiper-slide-duplicate-active"))
      ) {
        this.checkLoaded();
        this.bindEvents();
      } else {
        this.bindEvents();
      }
    } else {
      this.checkLoaded();
    }
  }

  _initOnViewport() {
    if (this._productCardInitObserver || this._productCardInitTriggered) return;

    const initInViewport = () => {
      if (this._productCardInitTriggered) return;
      this._productCardInitTriggered = true;
      this._disconnectProductCardInitObserver();
      this._initVideo();
    };

    this._productCardInitObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting || entry.intersectionRatio > 0) {
            initInViewport();
          }
        });
      },
      {
        threshold: 0.01,
        rootMargin: "350px 0px 350px 0px",
      }
    );

    this._productCardInitObserver.observe(this.element);
  }

  _disconnectProductCardInitObserver() {
    if (!this._productCardInitObserver) return;
    this._productCardInitObserver.disconnect();
    this._productCardInitObserver = null;
  }

  _initOnInteraction() {
    if (!VideoComponent._interactionPromise) {
      VideoComponent._interactionPromise = new Promise((resolve) => {
        const events = ["scroll", "mousemove", "click", "touchstart"];
        const handler = () => {
          events.forEach((e) =>
            window.removeEventListener(e, handler, { capture: true })
          );
          resolve();
        };
        events.forEach((e) =>
          window.addEventListener(e, handler, {
            once: true,
            capture: true,
            passive: true,
          })
        );
      });
    }
    VideoComponent._interactionPromise.then(() => {
      if (this.isConnected) this.observeAndLoad();
    });
  }

  isVideoVisiblyRenderable() {
    const style = window.getComputedStyle(this.element);
    if (style.display === "none" || style.visibility === "hidden") return false;
    const rect = this.element.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  // Vertical only: a slide beside the visible one still counts as on screen.
  isInViewport() {
    const rect = this.element.getBoundingClientRect();
    return rect.bottom > 0 && rect.top < window.innerHeight;
  }

  // Nothing off-screen joins the page load. Until `load` a video starts once it is on
  // screen; after it, a screen early, so it is already playing when it scrolls in.
  observeAndLoad() {
    if (this._videoAssetsRequested) return;

    if (this.isVideoVisiblyRenderable() && this.isInViewport()) {
      this._initVideo();
      return;
    }

    if (!("IntersectionObserver" in window)) return;

    const observe = (rootMargin) => {
      if (this._videoAssetsRequested) return;
      if (this._loadObserver) this._loadObserver.disconnect();
      this._loadObserver = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (
              entry.isIntersecting &&
              this.isVideoVisiblyRenderable() &&
              !this._videoAssetsRequested
            ) {
              this._loadObserver.disconnect();
              this._initVideo();
              break;
            }
          }
        },
        { rootMargin, threshold: 0 }
      );
      this._loadObserver.observe(this.element);
    };

    if (document.readyState === "complete") {
      observe("100% 0px");
    } else {
      observe("0px");
      window.addEventListener("load", () => observe("100% 0px"), { once: true });
    }
  }

  bindEvents() {
    window.removeEventListener(
      "swiper:slide-changed",
      this.onSlideChangeListener
    );
    this.onSlideChangeListener = this.onSlideChange.bind(this);
    window.addEventListener("swiper:slide-changed", this.onSlideChangeListener);
  }

  bindClickEvents() {
    if (!this.options["controls"]) return;

    this.onVideoClickListener = this.onVideoClick.bind(this);

    this.element.removeEventListener("click", this.onVideoClickListener);
    this.element.addEventListener("click", this.onVideoClickListener);
  }

  onVideoClick(event) {
    // Don't toggle if clicking on custom controls
    if (
      event.target.closest('[data-action="toggle-state"]') ||
      event.target.closest('[data-action="toggle-sound"]') ||
      event.target.closest(".vjs-control-bar")
    ) {
      return;
    }

    if (!this.videoPlayer) return;

    if (this.videoPlayer.paused()) {
      if (this.options["muted"]) {
        this.videoPlayer.muted("true");
      }
      const playPromise = this.videoPlayer.play();
      if (playPromise !== undefined) {
        playPromise.catch(() => {
          // Silently catch autoplay prevention
        });
      }
    } else {
      this.videoPlayer.pause();
    }
  }

  checkLoaded() {
    var _this = this;
    this._videoAssetsRequested = true;
    if (this._loadObserver) {
      this._loadObserver.disconnect();
      this._loadObserver = null;
    }
    if (this.videoPlayer) return;
    ensureVideoAssets();
    if (typeof videojs !== "undefined") {
      this.videoPlayerInitialization();
    } else {
      setTimeout(function () {
        _this.checkLoaded();
      }, 100);
    }
  }

  onSlideChange(event) {
    this.elementPosition = parseInt(this.element.getAttribute("data-position"));
    if (event.detail.currentIndex == this.elementPosition) {
      if (!this.element.getAttribute("loaded")) {
        var node = document.createElement("div");
        node.appendChild(
          this.element
            .querySelector("template")
            .content.firstElementChild.cloneNode(true)
        );
        // Append only. This used to chain .focus(), which moved keyboard focus into the
      // video every time a slide loaded — and the hero autoplays, so focus was pulled
      // into the first section on a timer. Tab then continued from there and the header
      // could only be reached after cycling the whole page (WCAG 2.4.3).
      this.element.appendChild(node.firstElementChild);
        this.element.setAttribute("loaded", true);
        if (!this.videoPlayer) {
          this.checkLoaded();
        } else {
          if (this.options["viewport"]) {
            const playPromise = this.videoPlayer.play();
            if (playPromise !== undefined) {
              playPromise.catch(() => {});
            }
            this.createObserver();
          }
        }
      } else {
        if (!this.videoPlayer) {
          this.checkLoaded();
        } else {
          if (this.options["viewport"]) {
            const playPromise = this.videoPlayer.play();
            if (playPromise !== undefined) {
              playPromise.catch(() => {});
            }
            this.createObserver();
          }
        }
      }
    } else if (
      this.videoPlayer &&
      this.videoPlayer.el_.classList.contains("vjs-playing")
    ) {
      this.videoPlayer.pause();
    }
  }

  videoPlayerInitialization() {
    if (this.videoPlayer) return;
    if (!this.element.getAttribute("loaded")) {
      const node = document.createElement("div");
      node.appendChild(
        this.element
          .querySelector("template")
          .content.firstElementChild.cloneNode(true)
      );
      // Append only. This used to chain .focus(), which moved keyboard focus into the
      // video every time a slide loaded — and the hero autoplays, so focus was pulled
      // into the first section on a timer. Tab then continued from there and the header
      // could only be reached after cycling the whole page (WCAG 2.4.3).
      this.element.appendChild(node.firstElementChild);
      this.element.setAttribute("loaded", true);
    }

    const isMobile = responsive.matchesBreakpoint("pocket");

    let aspect_ratio = "";
    let src = "";
    let host = "html5";

    if (isMobile) {
      aspect_ratio = this.options["aspect_mob"] || "9:16";

      if (this.options["videoType"] == "video_inside_media") {
        const sources = this.options["videod"]["sources"];
        let topQuality = null;
        sources.forEach((obj) => {
          if (obj.format === "mp4") {
            if (!topQuality) topQuality = obj;
            if (topQuality.height < obj.height) topQuality = obj;
          }
        });
        const aspectRatioHeight = Math.floor(
          100 / this.options["videod"]["aspect_ratio"]
        );
        if (!this.options["video_ratio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
        src = topQuality["url"] + "#t=0.001";
      } else if (this.options["videoType"] == "video_inside_media_external") {
        const aspectRatioHeight = Math.floor(
          100 / this.options["videom"]["aspect_ratio"]
        );
        if (!this.options["video_ratio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
        host = this.options["videom"]["host"];
        if (host == "youtube") {
          src =
            "https://www.youtube.com/watch?v=" +
            this.options["videom"]["external_id"];
        } else {
          src = this.options["videom"]["external_id"];
        }
      } else {
        if (this.options["videom"].includes("youtube")) {
          host = "youtube";
        } else if (this.options["videom"].includes("vimeo")) {
          host = "vimeo";
        }
        src = this.options["videom"];
      }
    } else {
      aspect_ratio = this.options["aspect_desk"] || "16:9";

      if (this.options["videoType"] == "video_inside_media") {
        const sources = this.options["videod"]["sources"];
        let topQuality = null;
        sources.forEach((obj) => {
          if (obj.format === "mp4") {
            if (!topQuality) topQuality = obj;
            if (topQuality.height < obj.height) topQuality = obj;
          }
        });
        src = topQuality["url"] + "#t=0.001";
        const aspectRatioHeight = Math.floor(
          100 / this.options["videod"]["aspect_ratio"]
        );

        if (!this.options["video_ratio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
      } else if (this.options["videoType"] == "video_inside_media_external") {
        host = this.options["videod"]["host"];
        const aspectRatioHeight = Math.floor(
          100 / this.options["videod"]["aspect_ratio"]
        );
        if (!this.options["video_ratio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
        if (host == "youtube") {
          src =
            "https://www.youtube.com/watch?v=" +
            this.options["videod"]["external_id"];
        } else {
          src = this.options["videod"]["external_id"];
        }
      } else {
        if (this.options["videod"].includes("youtube")) {
          host = "youtube";
        } else if (this.options["videod"].includes("vimeo")) {
          host = "vimeo";
        }
        src = this.options["videod"];
      }
    }

    if (!src) {
      src = "https://www.youtube.com/watch?v=_9VUPq3SxOc";
      host = "youtube";
    }

    const type =
      host === "youtube"
        ? "video/youtube"
        : host === "vimeo"
          ? "video/vimeo"
          : "video/mp4";

    aspect_ratio = aspect_ratio.replace("/", ":");
    const payload = {
      aspectRatio: aspect_ratio,
      autoplay: false,
      muted: this.options["muted"],
      loop: this.options["loop"],
      controls: false,
      poster: false,
      preload: "metadata",
      playsinline: true,
      responsive: true,
      techOrder: [host],
      disablePictureInPicture: true,
      sources: [
        {
          type: type,
          src: src,
        },
      ],
    };

    const videoplayerID = this.element.querySelector("video");
    this.videoPlayer = videojs(videoplayerID, payload);

    const _this = this;
    this.videoPlayer.on("ready", function () {
      _this.element.querySelector(".videoHolder").style.display = "block";

      if (_this.trueObserver == false && _this.options["viewport"]) {
        _this.createObserver();
      }

      _this.bindCustomControls();
      _this.bindClickEvents();
    });

    if (this.options["muted"] && host == "vimeo") {
      this.videoPlayer.on("play", function () {
        _this.videoPlayer.muted("true");
      });
    }
  }

  bindCustomControls() {
    this.stateElements = this.element.querySelectorAll(
      "[data-action='toggle-state']"
    );
    this.soundElements = this.element.querySelectorAll(
      "[data-action='toggle-sound']"
    );

    if (!this.stateElements.length || !this.soundElements.length) return;

    this.delegateElement.on("click", "[data-action='toggle-state']", () => {
      this.videoPlayer.paused()
        ? this.videoPlayer.play()
        : this.videoPlayer.pause();
    });

    this.delegateElement.on("click", "[data-action='toggle-sound']", () => {
      this.videoPlayer.muted()
        ? this.videoPlayer.muted(false)
        : this.videoPlayer.muted(true);
    });

    // `data-state` drives which icon/label the CSS reveals; `aria-label` names the
    // action the button performs. These were previously one and the same attribute,
    // which meant the accessible name was the English word "playing"/"muted" in
    // every locale and the label could not be translated without breaking the CSS.
    const syncControlLabels = this.syncControlLabels.bind(this);

    // Liquid renders the initial states from the Muted setting, but the player can
    // already disagree by the time it is ready (autoplay started, or the browser
    // forced mute), so take the states from the player once up front as well.
    syncControlLabels();
    this.videoPlayer.on("play", syncControlLabels);
    this.videoPlayer.on("pause", syncControlLabels);
    this.videoPlayer.on("volumechange", syncControlLabels);
  }

  /**
   * Set the play/pause and sound button states and accessible names from the player.
   */
  syncControlLabels() {
    const setState = (elements, state, label) =>
      elements.forEach((el) => {
        el.dataset.state = state;
        el.setAttribute("aria-label", label);
      });

    const paused = this.videoPlayer.paused();
    setState(
      this.stateElements,
      paused ? "paused" : "playing",
      paused
        ? window.a11yStrings?.play || "Play"
        : window.a11yStrings?.pause || "Pause"
    );

    const muted = this.videoPlayer.muted();
    setState(
      this.soundElements,
      muted ? "muted" : "unmuted",
      muted
        ? window.a11yStrings?.unmute || "Unmute"
        : window.a11yStrings?.mute || "Mute"
    );
  }

  createObserver() {
    const observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      threshold: 0.2,
      rootMargin: "200px 0px 200px 0px",
    });

    observer.observe(this.element);
    this.trueObserver = true;
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.intersectionRatio === 1 || entry.isIntersecting == true) {
        if (!this.videoPlayer) {
          this.checkLoaded();
          return;
        }

        if (this.options["viewport"] && this.videoPlayer) {
          if (this.options["muted"]) {
            this.videoPlayer.muted("true");
          }
          const checkIfPlaying = () => {
            if (!this.videoPlayer.el_.classList.contains("vjs-playing")) {
              const playPromise = this.videoPlayer.play();
              if (playPromise !== undefined) {
                playPromise.catch(() => {});
              }
              setTimeout(checkIfPlaying, 100);
            }
          };

          checkIfPlaying();
        }
      } else if (
        entry.intersectionRatio === 0 ||
        entry.isIntersecting == false
      ) {
        if (
          this.videoPlayer &&
          this.videoPlayer.el_.classList.contains("vjs-playing")
        ) {
          this.videoPlayer.pause();
        }
      }
    });
  }
}
customElements.define("video-component", VideoComponent);

class VideoComponentSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );
    this.isTextDisabled = this.element.getAttribute("data-text-disable");
    this.sectionId = this.element.getAttribute("data-section-id");
    this.trueObserver = false;
    this.delegateElement = new Delegate(this.element);
    this.videoPlayer = null;
    this.isInitialized = false;
    this._videoAssetsRequested = false;

    this.playLabelText = this.element.dataset.play || "PLAY";
    this.pauseLabelText = this.element.dataset.pause || "PAUSE";
    this.cursorLabel = null;
    this.headingBlock = this.element
      .closest(".video-section__inner-container")
      ?.querySelector(".heading-block");

    if (this.options["controls"]) {
      this.initCursorLabel();
    }

    const isDesktop =
      !responsive.matchesBreakpoint("phone") ||
      !responsive.matchesBreakpoint("pocket");
    const position = this.element.dataset.position;
    const hasPoster = this.hasVideoPoster();

    if (this.options["using_fade"] == "fade") {
      if (isDesktop) {
        this.setupScrollBasedLoading();
      } else {
        this.bindEvents();

        if (
          position == 0 ||
          this.element
            .closest(".swiper-slide")
            ?.classList.contains("swiper-slide-active") ||
          this.element
            .closest(".swiper-slide")
            ?.classList.contains("swiper-slide-duplicate-active")
        ) {
          if (hasPoster) {
            this._initOnInteraction();
          } else {
            this.observeAndLoad();
          }
        }
      }
    } else if (hasPoster) {
      this._initOnInteraction();
    } else {
      this.observeAndLoad();
    }
  }

  hasVideoPoster() {
    // Only a poster already on the page counts: one still inside the <template>
    // is invisible, so waiting for interaction would leave a blank box.
    return !!(
      this.element.querySelector(".videoHolder--Placeholder") ||
      this.element
        .closest(".VideoRatio, .VideoRatio--Full")
        ?.querySelector("[data-video-poster], .videoHolder--Placeholder")
    );
  }

  _initOnInteraction() {
    if (!VideoComponentSection._interactionPromise) {
      VideoComponentSection._interactionPromise = new Promise((resolve) => {
        const events = ["scroll", "mousemove", "click", "touchstart"];
        const handler = () => {
          events.forEach((e) =>
            window.removeEventListener(e, handler, { capture: true })
          );
          resolve();
        };
        events.forEach((e) =>
          window.addEventListener(e, handler, {
            once: true,
            capture: true,
            passive: true,
          })
        );
      });
    }
    VideoComponentSection._interactionPromise.then(() => {
      if (this.isConnected) this.observeAndLoad();
    });
  }

  isVideoVisiblyRenderable() {
    const style = window.getComputedStyle(this.element);
    if (style.display === "none" || style.visibility === "hidden") return false;
    const rect = this.element.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  // Vertical only: a slide beside the visible one still counts as on screen.
  isInViewport() {
    const rect = this.element.getBoundingClientRect();
    return rect.bottom > 0 && rect.top < window.innerHeight;
  }

  // Nothing off-screen joins the page load. Until `load` a video starts once it is on
  // screen; after it, a screen early, so it is already playing when it scrolls in.
  observeAndLoad() {
    if (this._videoAssetsRequested) return;

    if (this.isVideoVisiblyRenderable() && this.isInViewport()) {
      this.checkLoaded();
      return;
    }

    if (!("IntersectionObserver" in window)) return;

    const observe = (rootMargin) => {
      if (this._videoAssetsRequested) return;
      if (this._loadObserver) this._loadObserver.disconnect();
      this._loadObserver = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (
              entry.isIntersecting &&
              this.isVideoVisiblyRenderable() &&
              !this._videoAssetsRequested
            ) {
              this._loadObserver.disconnect();
              this.checkLoaded();
              break;
            }
          }
        },
        { rootMargin, threshold: 0 }
      );
      this._loadObserver.observe(this.element);
    };

    if (document.readyState === "complete") {
      observe("100% 0px");
    } else {
      observe("0px");
      window.addEventListener("load", () => observe("100% 0px"), { once: true });
    }
  }

  initCursorLabel() {
    const isMobile = responsive.matchesBreakpoint("pocket");
    if (isMobile) return;

    const label = document.createElement("div");
    label.className = "video-section__cursor-label u-s1";
    label.textContent = this.playLabelText;
    this.element.appendChild(label);

    this.cursorLabel = label;

    this.element.addEventListener("mouseenter", () => {
      this.cursorLabel.classList.add("is-visible");
    });

    this.element.addEventListener("mouseleave", () => {
      this.cursorLabel.classList.remove("is-visible");
    });

    this.element.addEventListener("mousemove", (event) => {
      if (!this.cursorLabel) return;

      const rect = this.element.getBoundingClientRect();
      const offsetY = event.clientY - rect.top;
      const bottomZoneStart = rect.height - 40;

      if (offsetY >= bottomZoneStart) {
        this.cursorLabel.classList.remove("is-visible");
        return;
      }

      this.cursorLabel.classList.add("is-visible");
      this.cursorLabel.style.left = event.clientX + 32 + "px";
      this.cursorLabel.style.top = event.clientY - 16 + "px";
    });
  }

  setupScrollBasedLoading() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.isInitialized) {
            observer.unobserve(this.element);
            this.checkLoaded();
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: "100px",
      }
    );

    observer.observe(this.element);
  }

  bindEvents() {
    window.removeEventListener(
      "swiper:slide-changed",
      this.onSlideChangeListener
    );
    this.onSlideChangeListener = this.onSlideChange.bind(this);
    window.addEventListener("swiper:slide-changed", this.onSlideChangeListener);
  }

  bindHoverEvents() {
    if (this.options["play_in_view_mob_hover_desk"]) {
      this.onMouseEnterListener = this.onMouseEnter.bind(this);
      this.onMouseLeaveListener = this.onMouseLeave.bind(this);

      this.element.addEventListener("mouseenter", this.onMouseEnterListener);
      this.element.addEventListener("mouseleave", this.onMouseLeaveListener);
    }
  }

  onMouseEnter() {
    const isMobile = responsive.matchesBreakpoint("pocket");
    if (
      !isMobile &&
      this.videoPlayer &&
      this.options["play_in_view_mob_hover_desk"] &&
      !this.options["play_in_view"] &&
      !this.options["viewport"]
    ) {
      if (this.options["muted"]) {
        this.videoPlayer.muted("true");
      }
      this.videoPlayer.play();
    }
  }

  onMouseLeave() {
    const isMobile = responsive.matchesBreakpoint("pocket");
    if (
      !isMobile &&
      this.videoPlayer &&
      this.options["play_in_view_mob_hover_desk"] &&
      !this.options["play_in_view"] &&
      !this.options["viewport"]
    ) {
      if (this.videoPlayer.el_.classList.contains("vjs-playing")) {
        this.videoPlayer.pause();
      }
    }
  }

  checkLoaded() {
    var _this = this;
    this._videoAssetsRequested = true;
    if (this._loadObserver) {
      this._loadObserver.disconnect();
      this._loadObserver = null;
    }
    if (this.videoPlayer) return;
    ensureVideoAssets();
    if (typeof videojs !== "undefined") {
      this.videoPlayerInitialization();
      if (this.videoPlayer && !this.options.viewport) {
        this.videoPlayer.pause();
      }
    } else {
      setTimeout(function () {
        _this.checkLoaded();
      }, 100);
    }
  }

  onSlideChange(event) {
    this.elementPosition = parseInt(this.element.getAttribute("data-position"));
    const isMobile = responsive.matchesBreakpoint("pocket");

    if (event.detail.currentIndex == this.elementPosition) {
      if (this.element.getAttribute("loaded")) {
        if (!isMobile && this.videoPlayer) {
          this.reinitializeVideoPlayer();
        } else if (!this.videoPlayer) {
          this.checkLoaded();
        }
      } else {
        var node = document.createElement("div");
        node.appendChild(
          this.element
            .querySelector("template")
            .content.firstElementChild.cloneNode(true)
        );
        // Append only. This used to chain .focus(), which moved keyboard focus into the
      // video every time a slide loaded — and the hero autoplays, so focus was pulled
      // into the first section on a timer. Tab then continued from there and the header
      // could only be reached after cycling the whole page (WCAG 2.4.3).
      this.element.appendChild(node.firstElementChild);
        this.element.setAttribute("loaded", true);
        this.checkLoaded();
      }

      if (
        this.options["play_in_view"] ||
        this.options["viewport"] ||
        (this.options["play_in_view_mob_hover_desk"] && isMobile)
      ) {
        setTimeout(() => {
          if (this.videoPlayer) {
            this.videoPlayer.play();
            this.createObserver();
          }
        }, 200);
      }
    } else if (
      this.videoPlayer &&
      this.videoPlayer.el_.classList.contains("vjs-playing")
    ) {
      this.videoPlayer.pause();
    }
  }

  videoPlayerInitialization() {
    if (!this.element.getAttribute("loaded")) {
      const node = document.createElement("div");
      node.appendChild(
        this.element
          .querySelector("template")
          .content.firstElementChild.cloneNode(true)
      );
      // Append only. This used to chain .focus(), which moved keyboard focus into the
      // video every time a slide loaded — and the hero autoplays, so focus was pulled
      // into the first section on a timer. Tab then continued from there and the header
      // could only be reached after cycling the whole page (WCAG 2.4.3).
      this.element.appendChild(node.firstElementChild);
      this.element.setAttribute("loaded", true);
    }

    const isMobile = responsive.matchesBreakpoint("pocket");

    let aspect_ratio = "";
    let src = "";
    let host = "html5";

    if (isMobile) {
      aspect_ratio = this.options["aspect_mob"] || "9:16";

      if (this.options["videoType"] == "video_inside_media") {
        const sources = this.options["videod"]["sources"];
        let topQuality = null;
        sources.forEach((obj) => {
          if (obj.format === "mp4") {
            if (!topQuality) topQuality = obj;
            if (topQuality.height < obj.height) topQuality = obj;
          }
        });
        const aspectRatioHeight = Math.floor(
          100 / this.options["videod"]["aspect_ratio"]
        );
        if (!this.options["video_ratio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
        src = topQuality["url"] + "#t=0.001";
      } else if (this.options["videoType"] == "video_inside_media_external") {
        const aspectRatioHeight = Math.floor(
          100 / this.options["videom"]["aspect_ratio"]
        );
        if (!this.options["video_ratio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
        host = this.options["videom"]["host"];
        if (host == "youtube") {
          src =
            "https://www.youtube.com/watch?v=" +
            this.options["videom"]["external_id"];
        } else {
          src = this.options["videom"]["external_id"];
        }
      } else {
        if (this.options["videom"].includes("youtube")) {
          host = "youtube";
        } else if (this.options["videom"].includes("vimeo")) {
          host = "vimeo";
        }
        src = this.options["videom"];
      }
    } else {
      aspect_ratio = this.options["aspect_desk"] || "16:9";

      if (this.options["videoType"] == "video_inside_media") {
        const sources = this.options["videod"]["sources"];
        let topQuality = null;
        sources.forEach((obj) => {
          if (obj.format === "mp4") {
            if (!topQuality) topQuality = obj;
            if (topQuality.height < obj.height) topQuality = obj;
          }
        });
        src = topQuality["url"] + "#t=0.001";
        const aspectRatioHeight = Math.floor(
          100 / this.options["videod"]["aspect_ratio"]
        );

        if (!this.options["video_ratio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
      } else if (this.options["videoType"] == "video_inside_media_external") {
        host = this.options["videod"]["host"];
        const aspectRatioHeight = Math.floor(
          100 / this.options["videod"]["aspect_ratio"]
        );
        if (!this.options["video_ratio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
        if (host == "youtube") {
          src =
            "https://www.youtube.com/watch?v=" +
            this.options["videod"]["external_id"];
        } else {
          src = this.options["videod"]["external_id"];
        }
      } else {
        if (this.options["videod"].includes("youtube")) {
          host = "youtube";
        } else if (this.options["videod"].includes("vimeo")) {
          host = "vimeo";
        }
        src = this.options["videod"];
      }
    }

    if (!src) {
      src = "https://www.youtube.com/watch?v=_9VUPq3SxOc";
      host = "youtube";
    }

    const type =
      host === "youtube"
        ? "video/youtube"
        : host === "vimeo"
          ? "video/vimeo"
          : "video/mp4";

    aspect_ratio = aspect_ratio.replace("/", ":");
    const payload = {
      aspectRatio: aspect_ratio,
      autoplay: false,
      muted: this.options["muted"],
      loop: this.options["loop"],
      controls: this.options["controls"],
      poster: false,
      preload: "metadata",
      playsinline: true,
      responsive: true,
      techOrder: [host],
      disablePictureInPicture: true,
      bigPlayButton: true,
      controlBar: this.options["controls"]
        ? {
          children: [
            "playToggle",
            "progressControl",
            "CustomControlSpacer",
            "MuteToggle",
            "fullscreenToggle",
          ],
        }
        : false,
      sources: [
        {
          type: type,
          src: src,
        },
      ],
    };

    const videoplayerID = this.element.querySelector("video");
    this.videoPlayer = videojs(videoplayerID, payload);

    const _this = this;
    this.videoPlayer.on("ready", function () {
      _this.element.querySelector(".videoHolder").style.display = "block";

      _this.bindHoverEvents();

      const isMobile = responsive.matchesBreakpoint("pocket");
      if (!isMobile) {
        setTimeout(() => {
          _this.ensureDesktopControls();
        }, 100);
      }

      if (
        !_this.trueObserver &&
        (_this.options["play_in_view_mob_hover_desk"] ||
          _this.options["play_in_view"] ||
          _this.options["viewport"])
      ) {
        _this.createObserver();
      }
    });

    this.videoPlayer.on("play", () => {
      if (this.cursorLabel) {
        this.cursorLabel.textContent = this.pauseLabelText;
      }
      if (this.headingBlock) {
        this.headingBlock.classList.add("is-hidden");
      }
    });

    this.videoPlayer.on("pause", () => {
      if (this.cursorLabel) {
        this.cursorLabel.textContent = this.playLabelText;
      }
      if (this.headingBlock) {
        this.headingBlock.classList.remove("is-hidden");
      }
    });

    this.videoPlayer.on("ended", () => {
      if (this.cursorLabel) {
        this.cursorLabel.textContent = this.playLabelText;
      }
      if (this.headingBlock) {
        this.headingBlock.classList.remove("is-hidden");
      }
    });

    if (this.options["muted"] && host == "vimeo") {
      this.videoPlayer.on("play", function () {
        _this.videoPlayer.muted("true");
      });
    }

    if (this.options["controls"]) {
      if (host == "html5") {
        this.videoPlayer.on("touchstart", function () {
          if (event.target.closest(".vjs-control-bar")) return;

          if (_this.videoPlayer.paused()) {
            _this.videoPlayer.play();
          } else {
            _this.videoPlayer.pause();
          }
        });
      }

      if (host !== "html5") {
        this.videoPlayer.on("click", function () {
          if (event.target.closest(".vjs-control-bar")) return;

          if (_this.videoPlayer.paused()) {
            _this.videoPlayer.play();
          } else {
            _this.videoPlayer.pause();
          }
        });
      }
    } else {
      this.videoPlayer.off("click");
      this.videoPlayer.off("touchstart");
      this.videoPlayer.controls(false);

      const videoEl = this.element.querySelector(".video-js");
      if (videoEl) {
        videoEl.style.cursor = "default";

        videoEl.addEventListener(
          "click",
          function (e) {
            e.preventDefault();
            e.stopPropagation();
            return false;
          },
          true
        );

        videoEl.addEventListener(
          "touchstart",
          function (e) {
            e.preventDefault();
            e.stopPropagation();
            return false;
          },
          true
        );
      }
    }
  }

  createObserver() {
    const observer = new IntersectionObserver(
      this.handleIntersect.bind(this),
      {
        threshold: 0.2,
        rootMargin: "200px 0px 200px 0px",
      }
    );

    const element = this.element;
    observer.observe(element);
    this.trueObserver = true;
  }

  handleIntersect(entries) {
    const isMobile = responsive.matchesBreakpoint("pocket");

    entries.forEach((entry) => {
      if (entry.intersectionRatio === 1 || entry.isIntersecting === true) {
        if (!this.videoPlayer) {
          this.checkLoaded();
          return;
        }

        if (
          (this.options["play_in_view"] || this.options["viewport"]) &&
          this.videoPlayer
        ) {
          if (this.options["muted"]) {
            this.videoPlayer.muted("true");
          }

          const loop = () => {
            if (!this.videoPlayer.el_.classList.contains("vjs-playing")) {
              this.videoPlayer.play();
              setTimeout(loop, 100);
            }
          };
          loop();
        } else if (
          this.options["play_in_view_mob_hover_desk"] &&
          this.videoPlayer &&
          isMobile
        ) {
          if (this.options["muted"]) {
            this.videoPlayer.muted("true");
          }
          const loop = () => {
            if (!this.videoPlayer.el_.classList.contains("vjs-playing")) {
              this.videoPlayer.play();
              setTimeout(loop, 100);
            }
          };
          loop();
        }
      } else {
        if (
          (this.options["play_in_view"] || this.options["viewport"]) &&
          this.videoPlayer &&
          this.videoPlayer.el_.classList.contains("vjs-playing")
        ) {
          this.videoPlayer.pause();
        } else if (
          this.options["play_in_view_mob_hover_desk"] &&
          isMobile &&
          this.videoPlayer &&
          this.videoPlayer.el_.classList.contains("vjs-playing")
        ) {
          this.videoPlayer.pause();
        }
      }
    });
  }

  disposeVideoPlayer() {
    if (this.videoPlayer) {
      try {
        this.videoPlayer.dispose();
        this.videoPlayer = null;
      } catch (e) {
        console.warn("VideoComponent: Error disposing video player:", e);
        this.videoPlayer = null;
      }
    }
  }

  ensureDesktopControls() {
    if (!this.videoPlayer) return;

    if (this.options["controls"]) {
      this.videoPlayer.controls(true);

      const isMobile = responsive.matchesBreakpoint("pocket");
      if (!isMobile) {
        const textTrackDisplay =
          this.element.querySelector(".vjs-text-track-display");
        if (textTrackDisplay) {
          textTrackDisplay.style.pointerEvents = "none";
        }
      }
    } else {
      this.videoPlayer.controls(false);
      const videoEl = this.element.querySelector(".video-js");
      if (videoEl) {
        videoEl.style.pointerEvents = "none";
        videoEl.style.cursor = "default";
      }
    }
  }

  reinitializeVideoPlayer() {

    this.disposeVideoPlayer();
    this.element.removeAttribute("loaded");
    this.element.removeAttribute("data-loaded");

    const existingHolder = this.element.querySelector(".videoHolder");
    if (existingHolder) {
      existingHolder.remove();
    }

    setTimeout(() => {
      this.checkLoaded();
    }, 50);
  }
}

customElements.define("section-video-component", VideoComponentSection);


class SearchBar extends HTMLElement {
  constructor() {
    super();

    // base refs
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    // key elements (guard every lookup)
    this.searchInputElement = this.element.querySelector('[name="q"]');
    this.searchResultsElement = this.element.querySelector(".searchWrapper");
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.clearSearchButton = this.element.querySelector(".search-input__clear");
    this.searchInputContainer = this.element.querySelector(".search-header__input-container");
    this.formElement = this.element.querySelector("form.searchForm");

    // options
    const settingsAttr = this.element.getAttribute("data-settings");
    try {
      this.options = settingsAttr ? JSON.parse(settingsAttr) : {};
    } catch {
      this.options = {};
    }

    // initial layout snapshot (guard)
    this.initialSearchLayout = this.searchResultsElement ? this.searchResultsElement.cloneNode(true) : null;

    // feature flags
    this.headerTransparent = false;
    this.isOpen = false;
  }

  connectedCallback() {
    // Defer layout read to connectedCallback to avoid constructor reflow
    requestAnimationFrame(() => {
      const headerEl = this.element.querySelector(".search-header");
      if (headerEl) {
        document.documentElement.style.setProperty("--search-header-height", `${headerEl.offsetHeight + 48}px`);
      }
    });

    this.drawer = new Drawer(this.element);
    this.element.__searchBar = this;

    this.bindEvents();
  }

  disconnectedCallback() {
    this.element.__searchBar = null;
  }

  bindEvents() {
    this._onInputListener = debounce(this.onInput.bind(this), 450);

    this.delegateBody.on("click", '[data-action="open-search"]', this.openSearch.bind(this));
    this.delegateBody.on("click", ".search[aria-expanded=false] .searchInput--Wrapper", this.openSearch.bind(this));
    this.delegateElement.on("click", '[data-action="clear-input"]', this.resetSearch.bind(this));
    this.delegateElement.on("click", '[data-action="close-search"]', this.closeSearch.bind(this));

    if (this.searchInputElement) {
      this.searchInputElement.addEventListener("input", this._onInputListener);
    }

    this.delegateElement.on("click", '[data-action="search-string"]', this.onInput.bind(this));
    this.delegateElement.on("keypress", '[data-action="search-string"]', this.onInput.bind(this));

    this.delegateBody.on("menu:open", this.closeSearch.bind(this));
    this.delegateBody.on("close:search", this.closeSearch.bind(this));
    this.delegateBody.on("drawer:open", this.closeSearch.bind(this));
    this.delegateBody.on("popup:opened", this.closeSearch.bind(this));
    this.delegateBody.on("cart-drawer:open", this.closeSearch.bind(this));
    this.delegateBody.on("account-drawer:open", this.closeSearch.bind(this));

    this.delegateBody.on("mobile-menu:open", this.showSearchInputMobile.bind(this));
    this.delegateBody.on("mobile-menu:close", this.hideSearchInputMobile.bind(this));

    this.delegateElement.on("submit", "form.searchForm", this.handleFormSubmit.bind(this));
  }

  // ✅ FULL FIX:
  // Every new search submit MUST start without type in the URL.
  // type can only be added later by tab clicks (outside this component).
  handleFormSubmit(event) {
    event.preventDefault();

    const q = (this.searchInputElement?.value || "").trim();

    const action = this.formElement?.getAttribute("action") || this.formElement?.action || "/search";
    const url = new URL(action, window.location.origin);

    if (q) url.searchParams.set("q", q);
    else url.searchParams.delete("q");

    // ✅ Critical: NEVER inherit or keep `type` on new searches
    url.searchParams.delete("type");

    // ✅ Also prevent "poisoned q" like q="test&type=article"
    const qVal = url.searchParams.get("q");
    if (qVal && qVal.includes("?")) url.searchParams.set("q", qVal.split("?")[0]);

    // Optional: keep sort_by if you want search submit to preserve it
    const cur = new URLSearchParams(window.location.search);
    const sortBy = cur.get("sort_by");
    if (sortBy) url.searchParams.set("sort_by", sortBy);
    else url.searchParams.delete("sort_by");

    window.location.href = url.toString();
  }

  showSearchInputMobile() {
    this.element.style.display = "";
    requestAnimationFrame(() => {
      this.element.setAttribute("aria-hidden", "false");
      this.searchResultsElement.setAttribute("aria-hidden", true);
      this.searchResultsElement.style.display = "none";
    });
    document.documentElement.style.setProperty(
      "--search-input-heignt",
      `${this.element.querySelector(".searchInput--Wrapper").offsetHeight}px`
    );
  }

  hideSearchInputMobile() {
    const handleTransitionEnd = () => {
      const mobileMenuDrawer = document.querySelector("main-menu-dropdown .menu__drawer");
      if (mobileMenuDrawer.getAttribute("aria-hidden") == "false") {
        this.element.style.display = "none";
      }

      this.searchInputContainer.removeEventListener("transitionend", handleTransitionEnd);
    };
    this.searchInputContainer.addEventListener("transitionend", handleTransitionEnd);

    this.searchResultsElement.setAttribute("aria-hidden", "");
    this.searchResultsElement.style.display = "";
    this.element.setAttribute("aria-hidden", "true");
  }

  openSearch(event, _skipDelay = false) {
    if (event?.preventDefault) event.preventDefault();

    // Bail when click originated from the close button. The close button lives
    // inside `.searchInput--Wrapper`, so without this guard the body-delegated
    // ".search[aria-expanded=false] .searchInput--Wrapper" listener re-opens
    // the search the moment closeSearch flips aria-expanded to false.
    if (event?.target?.closest?.('[data-action="close-search"], .closeSearch')) {
      return;
    }

    if (!_skipDelay) {
      // NEW: delay also if any popup is open
      const hasPopupOpen = !!(window.globalPopup && window.globalPopup.activePopups && window.globalPopup.activePopups.length);

      const hasOtherDrawerOpen =
        window.Drawer && Drawer.instances && this.drawer
          ? Array.from(Drawer.instances).some((inst) => inst !== this.drawer && inst.isOpen)
          : false;

      if (hasPopupOpen || hasOtherDrawerOpen) {
        if (this._openDelayTimeout) {
          clearTimeout(this._openDelayTimeout);
          this._openDelayTimeout = null;
        }

        if (hasOtherDrawerOpen && window.Drawer && typeof Drawer.closeAllExcept === "function" && this.drawer) {
          Drawer.closeAllExcept(this.drawer);
        } else if (window.Drawer && typeof Drawer.closeAll === "function") {
          Drawer.closeAll();
        }

        if (hasPopupOpen && window.globalPopup && typeof window.globalPopup.closeAllPopups === "function") {
          window.globalPopup.closeAllPopups();
        }

        this._openDelayTimeout = setTimeout(() => {
          this._openDelayTimeout = null;
          this.openSearch(null, true);
        }, 1000);

        return false;
      }
    }

    if (window.Drawer && typeof Drawer.closeAllExcept === "function" && this.drawer) {
      Drawer.closeAllExcept(this.drawer);
    } else if (window.Drawer && typeof Drawer.closeAll === "function") {
      Drawer.closeAll();
    }

    if (window.globalPopup) window.globalPopup.closeAllPopups?.();

    // If already open and not closing, toggle it closed
    if (this.isOpen && !this._isClosing) {
      this.closeSearch();
      return;
    }

    // If currently closing, force-finish the close first so we can re-open
    if (this._isClosing) {
      this._forceFinishClose();
    }

    // Prevent duplicate open calls
    if (this._isOpening) return;

    this._isOpening = true;

    // Cancel any stale hide timeout from a previous close
    if (this._hideTimeout) {
      clearTimeout(this._hideTimeout);
      this._hideTimeout = null;
    }

    this.element.dispatchEvent(new CustomEvent("menu:close", { bubbles: true }));
    this.element.dispatchEvent(new CustomEvent("drawer:close-other", { bubbles: true }));

    if (!this.element) {
      console.error("Search element not found");
      this._isOpening = false;
      return;
    }

    this.element.style.display = "block";

    requestAnimationFrame(() => {
      const search = document.querySelector("#quickSearch");
      if (search) {
        if (search._clipAnimating) {
          search.removeEventListener("transitionend", search._clipAnimating);
          search._clipAnimating = null;
        }

        search.classList.add("is-animating");
        void search.offsetWidth;

        const onEnd = (e) => {
          if (e.target !== search) return;
          if (e.propertyName !== "clip-path") return;
          search.classList.remove("is-animating");
          search.removeEventListener("transitionend", onEnd);
          search._clipAnimating = null;
        };

        search._clipAnimating = onEnd;
        search.addEventListener("transitionend", onEnd);

        search.setAttribute("aria-hidden", "false");
        search.setAttribute("aria-expanded", "true");
      }
    });

    const headerSearchBar = document.querySelector(".header-search");
    if (headerSearchBar) headerSearchBar.classList.add("hidden");

    if (typeof responsive !== "undefined" && this.pageOverlayElement) {
      // Clean up any pending close operations from any component
      if (this.pageOverlayElement._pendingCloseHandler) {
        this.pageOverlayElement.removeEventListener("transitionend", this.pageOverlayElement._pendingCloseHandler);
        this.pageOverlayElement._pendingCloseHandler = null;
      }
      if (this.pageOverlayElement._pendingCloseTimeout) {
        clearTimeout(this.pageOverlayElement._pendingCloseTimeout);
        this.pageOverlayElement._pendingCloseTimeout = null;
      }

      this.pageOverlayElement.style.top = "calc(var(--header-height-fixed) + var(--announcement-dynamic-height))";
      this.pageOverlayElement.style.display = "block";
      requestAnimationFrame(() => {
        this.pageOverlayElement.classList.add("is-visible");
      });
    }

    const scrollable = this.element.querySelector("[data-scrollable]");
    if (typeof bodyScrollLock !== "undefined" && scrollable) {
      try {
        bodyScrollLock.disableBodyScroll(scrollable, bodyScrollLockOptions);
        this.element.style.setProperty("--body-scroll-lock-offset", document.body.style.paddingRight || "0px");
      } catch {}
    }
    document.body.classList.add("scrollLock");

    setTimeout(() => {
      // The search panel is a Drawer, but openSearch sets `drawer.isOpen` directly rather
      // than going through Drawer.openDrawer, so it never received the focus trap that the
      // cart, favourites and menu drawers get. Trap here. trapFocus also lands focus on the
      // search field, which is the first focusable element in the panel.
      trapFocus(this.element);
    }, 200);

    const headerElement = document.querySelector("header-component");
    if (headerElement && headerElement.classList.contains("Header--Transparent")) {
      this.element._wasTransparentBeforeOpen = true;
      if (headerElement.drawerBlocksTransparency !== undefined) {
        headerElement.drawerBlocksTransparency = true;
      }
      headerElement.classList.remove("Header--Transparent");
    } else {
      this.element._wasTransparentBeforeOpen = false;
    }

    this.isOpen = true;
    this._isOpening = false;
    if (this.drawer) this.drawer.isOpen = true;

    if (this.pageOverlayElement) {
      this.closeListener = this.closeSearch.bind(this);
      this.pageOverlayElement.addEventListener("click", this.closeListener);
    }

    return false;
  }

  closeSearch(event) {
    if (event?.preventDefault) event.preventDefault();

    // Stop click events from bubbling further up the DOM. Without this, the
    // same click reaches body-delegated handlers (Drawer.closeDrawer and the
    // searchInput--Wrapper open handler) and triggers redundant work or a
    // re-open after aria-expanded flips to false.
    if (event?.type === "click" && typeof event.stopPropagation === "function") {
      event.stopPropagation();
    }

    // Cancel any pending delayed open
    if (this._openDelayTimeout) {
      clearTimeout(this._openDelayTimeout);
      this._openDelayTimeout = null;
    }

    if (!this.isOpen) return;

    // Prevent multiple close operations
    if (this._isClosing) return;
    this._isClosing = true;

    const search = document.querySelector("#quickSearch");
    if (search) {
      if (search._clipAnimating) {
        search.removeEventListener("transitionend", search._clipAnimating);
        search._clipAnimating = null;
      }

      search.classList.add("is-animating");
      void search.offsetWidth;

      const onEnd = (e) => {
        if (e.target !== search) return;
        if (e.propertyName !== "clip-path") return;
        search.classList.remove("is-animating");
        search.removeEventListener("transitionend", onEnd);
        search._clipAnimating = null;
      };

      search._clipAnimating = onEnd;
      search.addEventListener("transitionend", onEnd);
    }

    this.element.setAttribute("aria-hidden", "true");
    this.element.setAttribute("aria-expanded", "false");

    // Clean up any existing listener to prevent stacking
    if (this.handleSearchCloseBinder) {
      this.element.removeEventListener("transitionend", this.handleSearchCloseBinder);
    }

    this.handleSearchCloseBinder = this.handleSearchClose.bind(this);
    this.element.addEventListener("transitionend", this.handleSearchCloseBinder, { once: true });

    if (this.pageOverlayElement) {
      // Remove is-visible class to trigger transition
      this.pageOverlayElement.classList.remove("is-visible");

      // Set display: none after transition completes
      const overlayCloseListener = (e) => {
        if (e.target !== this.pageOverlayElement) return;

        if (this.pageOverlayElement._pendingCloseTimeout) {
          clearTimeout(this.pageOverlayElement._pendingCloseTimeout);
          this.pageOverlayElement._pendingCloseTimeout = null;
        }

        this.pageOverlayElement.style.display = "none";
        this.pageOverlayElement.removeEventListener("transitionend", overlayCloseListener);
        this.pageOverlayElement._pendingCloseHandler = null;
      };

      // Store handler on overlay element so other components can clean it up
      this.pageOverlayElement._pendingCloseHandler = overlayCloseListener;
      this.pageOverlayElement.addEventListener("transitionend", overlayCloseListener);

      // Fallback in case transitionend doesn't fire
      this.pageOverlayElement._pendingCloseTimeout = setTimeout(() => {
        if (this.pageOverlayElement._pendingCloseHandler) {
          this.pageOverlayElement.style.display = "none";
          this.pageOverlayElement.removeEventListener(
            "transitionend",
            this.pageOverlayElement._pendingCloseHandler
          );
          this.pageOverlayElement._pendingCloseHandler = null;
        }
        this.pageOverlayElement._pendingCloseTimeout = null;
      }, 400);

      // Remove the click listener immediately
      if (this.closeListener) {
        this.pageOverlayElement.removeEventListener("click", this.closeListener);
        this.closeListener = null;
      }
    }

    this.isOpen = false;

    if (this.drawer) this.drawer.isOpen = false;

    // openSearch arms a focus trap; release it and hand focus back to the search button.
    // Only when focus is still inside, otherwise the trap belongs to whatever opened next.
    if (this.element.contains(document.activeElement)) {
      const trigger = this.drawer?._triggerElement;
      removeTrapFocus(trigger?.isConnected && trigger.offsetParent !== null ? trigger : null);
    }

    const headerSearchBar = document.querySelector(".header-search");
    if (headerSearchBar) headerSearchBar.classList.remove("hidden");

    // Clear any existing fallback timeout
    if (this._closeTimeout) {
      clearTimeout(this._closeTimeout);
    }

    // Fallback: force cleanup if transition doesn't fire
    this._closeTimeout = setTimeout(() => {
      if (!this.isOpen && this._isClosing) {
        this.handleSearchClose(
          { propertyName: "opacity" },
          ["menu:open", "drawer:open", "popup:opened", "cart-drawer:open", "account-drawer:open"].includes(event?.type)
            ? false
            : true
        );
      }
    }, 400);
  }

  handleSearchClose(e, removeBodyScollLock = true) {
    if (!this._isClosing) return;
    if (e?.propertyName !== "opacity") return;

    if (this._closeTimeout) {
      clearTimeout(this._closeTimeout);
      this._closeTimeout = null;
    }

    if (this.element._wasTransparentBeforeOpen) {
      const headerElement = document.querySelector("header-component");
      if (headerElement) {
        headerElement.classList.add("Header--Transparent");
        if (headerElement.drawerBlocksTransparency !== undefined) {
          headerElement.drawerBlocksTransparency = false;
        }
      }
      this.element._wasTransparentBeforeOpen = false;
    }

    if (removeBodyScollLock) {
      document.body.classList.remove("scrollLock");
      const scrollable = this.element.querySelector("[data-scrollable]");
      if (typeof bodyScrollLock !== "undefined" && scrollable) {
        try {
          bodyScrollLock.enableBodyScroll(scrollable);
        } catch {}
      }
    }

    this._hideTimeout = setTimeout(() => {
      this._hideTimeout = null;
      if (!this.isOpen) {
        this.element.style.display = "none";
        this.resetSearch();
      }
    }, 800);

    if (this.handleSearchCloseBinder) {
      this.element.removeEventListener("transitionend", this.handleSearchCloseBinder);
      this.handleSearchCloseBinder = null;
    }

    this._isClosing = false;
  }

  _forceFinishClose() {
    // Cancel all pending close timeouts
    if (this._closeTimeout) {
      clearTimeout(this._closeTimeout);
      this._closeTimeout = null;
    }
    if (this._hideTimeout) {
      clearTimeout(this._hideTimeout);
      this._hideTimeout = null;
    }

    // Remove pending transitionend listeners
    if (this.handleSearchCloseBinder) {
      this.element.removeEventListener("transitionend", this.handleSearchCloseBinder);
      this.handleSearchCloseBinder = null;
    }

    const search = document.querySelector("#quickSearch");
    if (search && search._clipAnimating) {
      search.removeEventListener("transitionend", search._clipAnimating);
      search._clipAnimating = null;
      search.classList.remove("is-animating");
    }

    // Clean overlay close listener
    if (this.pageOverlayElement) {
      if (this.pageOverlayElement._pendingCloseHandler) {
        this.pageOverlayElement.removeEventListener("transitionend", this.pageOverlayElement._pendingCloseHandler);
        this.pageOverlayElement._pendingCloseHandler = null;
      }
      if (this.pageOverlayElement._pendingCloseTimeout) {
        clearTimeout(this.pageOverlayElement._pendingCloseTimeout);
        this.pageOverlayElement._pendingCloseTimeout = null;
      }
      this.pageOverlayElement.style.display = "none";
      this.pageOverlayElement.classList.remove("is-visible");
    }

    // Force element into closed state immediately
    this.element.style.display = "none";
    this.element.setAttribute("aria-hidden", "true");
    this.element.setAttribute("aria-expanded", "false");

    // Clear all flags
    this._isClosing = false;
    this.isOpen = false;
    if (this.drawer) this.drawer.isOpen = false;

    // Release the trap and hand focus back to whatever opened the search.
    const searchOpener = document.querySelector('[data-action="open-search"]');
    const returnTarget =
      searchOpener?.isConnected && searchOpener.offsetParent !== null ? searchOpener : null;
    removeTrapFocus(returnTarget);

    document.body.classList.remove("scrollLock");
    const scrollable = this.element.querySelector("[data-scrollable]");
    if (typeof bodyScrollLock !== "undefined" && scrollable) {
      try { bodyScrollLock.enableBodyScroll(scrollable); } catch {}
    }
  }

  escapeRegExp(str) {
    return String(str).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  highlightSuggestedQueries(container, typedValue) {
    if (!container) return;
    const typed = (typedValue || "").trim();
    if (!typed) return;

    const re = new RegExp(this.escapeRegExp(typed), "ig");
    const items = container.querySelectorAll('[data-action="search-string"]');

    items.forEach((el) => {
      const raw = (el.getAttribute("data-value") || el.textContent || "").trim();
      if (!raw) return;

      const html = raw.replace(re, (m) => `<span class="search_text-typed">${m}</span>`);
      el.innerHTML = html;
    });
  }

  async onInput(event) {
    const source = event?.target;
    let val = source && "value" in source ? source.value : "";
    if (source?.getAttribute && source.getAttribute("data-value") && !val) {
      val = source.getAttribute("data-value");
      const el = this.element.querySelector(".searchInput");
      if (el) {
        el.value = val;
        el.setAttribute("value", val);
      }
    }
    this.lastInputValue = val;

    if (!val.trim()) {
      if (this.initialSearchLayout && this.searchResultsElement) {
        this.searchResultsElement.innerHTML = this.initialSearchLayout.innerHTML;
        this.searchResultsElement.style.opacity = 1;
      }
      const host = this.element.querySelector(".predictiveSearch--queries");
      if (host) host.innerHTML = "";
      if (this.clearSearchButton) this.clearSearchButton.setAttribute("aria-hidden", "true");
      return;
    }

    this.searchResultsElement = this.element.querySelector(".searchWrapper");
    if (!this.searchResultsElement) return;
    this.searchResultsElement.style.opacity = 0;
    if (this.clearSearchButton) this.clearSearchButton.setAttribute("aria-hidden", "false");

    const token = (this.currentRequestToken = (this.currentRequestToken || 0) + 1);

    try {
      const sectionId = "search-predictive";
      const params = new URLSearchParams();
      params.set("q", val);
      params.set("resources[type]", "query,product,collection,article,page");
      params.set("resources[limit_scope]", "each");
      params.set(
        "resources[options][fields]",
        "title,product_type,variants.title,tag,body,author,vendor,variants.sku"
      );
      params.set("section_id", sectionId);
      params.set("_", String(Date.now()));
      const url = `${routes.predictive_search_url}?${params.toString()}`;

      const response = await fetch(url, { cache: "no-store" });
      if (!response.ok) throw new Error(response.status);

      if (token !== this.currentRequestToken) return;

      const text = await response.text();
      const parsed = new DOMParser().parseFromString(text, "text/html");
      const hostEl = parsed.querySelector(`#shopify-section-${sectionId}`) || parsed.body;
      const resultsMarkup = hostEl ? hostEl.innerHTML : "";

      this.searchResultsElement.innerHTML = resultsMarkup;
      requestAnimationFrame(() => {
        this.initCarousel();
      });

      const tpl = this.searchResultsElement.querySelector("template");
      const root = this.searchResultsElement.querySelector(".predictive-search") || this.searchResultsElement;
      const leftCol = root.querySelector(".predictive-search__results--left") || root;

      let suggestionsHost = root.querySelector(".predictiveSearch--queries");
      if (!suggestionsHost) {
        suggestionsHost = document.createElement("div");
        suggestionsHost.className = "predictiveSearch--queries";
        suggestionsHost.setAttribute("aria-live", "polite");
      }

      suggestionsHost.innerHTML = "";
      if (tpl && tpl.content && tpl.content.firstElementChild) {
        suggestionsHost.appendChild(tpl.content.cloneNode(true));
        leftCol.insertBefore(suggestionsHost, leftCol.firstChild);

        this.highlightSuggestedQueries(suggestionsHost, val);
      } else {
        if (suggestionsHost.parentNode) suggestionsHost.remove();
      }

      this.searchResultsElement.style.opacity = 1;
    } catch (error) {
      if (error?.code === 20) return;
      console.error("[SearchBar] predictive search failed:", error);
      if (this.searchResultsElement) this.searchResultsElement.style.opacity = 1;
    }
  }

  resetSearch() {
    if (this.initialSearchLayout && this.searchResultsElement) {
      this.searchResultsElement.innerHTML = this.initialSearchLayout.innerHTML;
    }

    const suggestionsHost = this.element.querySelector(".predictiveSearch--queries");
    if (suggestionsHost) suggestionsHost.remove();

    if (this.searchInputElement) {
      this.searchInputElement.value = "";
      this.searchInputElement.removeAttribute("value");
    }

    this.initCarousel();

    if (this.searchResultsElement) this.searchResultsElement.style.opacity = "";

    setTimeout(() => {
      focusWithoutStealingRing(this.searchInputElement);
    }, 200);

    if (this.clearSearchButton) {
      this.clearSearchButton.setAttribute("aria-hidden", "true");
    }
  }
}

customElements.define("search-bar", SearchBar);

class TermsAndConditions extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.stickyLinksTopPadding = this.stickyLinksTopPadding.bind(this);
    this.bindEvents();
  }

  bindEvents() {
    const isMobile = responsive.matchesBreakpoint("pocket");
    if (!isMobile) document.addEventListener("scroll", this.stickyLinksTopPadding);
  }

  stickyLinksTopPadding() {
    const linkList = this.element.querySelector(".tc-layout-wrapper__linklist");
    if (linkList) {
      const isSticky = linkList.getBoundingClientRect().top === 0;

      if (isSticky) {
        linkList.style.paddingTop = "1.5rem";
      } else {
        linkList.style.paddingTop = "0rem";
      }
    }
  }
}

customElements.define("terms-and-conditions", TermsAndConditions);


function initMarketFlagImages(root, onComplete) {
  if (!root) {
    onComplete?.();
    return;
  }

  const images = Array.from(
    root.querySelectorAll('.revolution-selectbox__flag img.market-flag__img')
  );

  if (!images.length) {
    onComplete?.();
    return;
  }

  let remaining = 0;

  const checkComplete = () => {
    if (remaining === 0) {
      onComplete?.();
    }
  };

  images.forEach((img) => {
    if (img.classList.contains('is-loaded')) {
      return;
    }

    remaining += 1;

    const reveal = () => {
      img.classList.add('is-loaded');
      remaining -= 1;
      checkComplete();
    };

    if (img.complete && img.naturalWidth > 0) {
      requestAnimationFrame(reveal);
    } else {
      img.addEventListener('load', reveal, { once: true });
      img.addEventListener('error', reveal, { once: true });
    }
  });

  checkComplete();
}

function lockHeaderHeight() {
  const header = document.querySelector('#header');

  if (!header) return;

  document.documentElement.style.setProperty(
    '--header-height-fixed',
    `${header.offsetHeight}px`
  );
}

function showLocalizationSwitchTransition() {
  const overlay = document.querySelector('.pageTransition');
  const loader = document.querySelector('.pageLoader');

  if (window.theme?.showPageTransition && overlay) {
    overlay.style.display = 'block';
    overlay.style.opacity = '1';
    return;
  }

  if (loader) {
    loader.style.width = '100%';
  }
}

function finishLocalizationSwitchTransition() {
  const overlay = document.querySelector('.pageTransition');

  if (window.theme?.showPageTransition && overlay) {
    overlay.style.display = 'block';
    overlay.style.opacity = '1';
    overlay.animate([{ opacity: 1 }, { opacity: 0 }], {
      duration: 250,
      fill: 'forwards',
      easing: 'ease-out',
    }).onfinish = () => {
      overlay.style.display = 'none';
      overlay.style.opacity = '0';
    };
    return;
  }

  const loader = document.querySelector('.pageLoader');

  if (loader) {
    loader.style.width = '0%';
  }
}

class LocalizationSelectors extends HTMLElement {
  constructor() {
    super();
    this.element = this;
  }

  connectedCallback() {
    new Popup();

    const pendingSwitch = sessionStorage.getItem('localization-pending') === '1';

    if (pendingSwitch) {
      initMarketFlagImages(this.element, () => {
        sessionStorage.removeItem('localization-pending');
        lockHeaderHeight();
        requestAnimationFrame(() => {
          finishLocalizationSwitchTransition();
        });
      });
      return;
    }

    initMarketFlagImages(this.element);
  }
}
customElements.define('localization-selectors', LocalizationSelectors);

class LocalizationModal extends HTMLElement {
  constructor() {
    super();

    this.element = this;
    this._languageTouchedByUser = false;
    this.selectContainer = this.element.querySelector(
      '.RevolutionSelectbox--Content'
    );
  }
  connectedCallback() {
    this.delegateElement = new Delegate(this.element);
  
    this.element
      .querySelectorAll('.RevolutionSelectbox')
      .forEach((box) => new RevolutionSelectbox(box));
  
    this.bindEvents();
    this.sortMarketItems();
    this.dedupeMarketSelection();
    initMarketFlagImages(this.element);

    this.ensureLocalizationData().then(() => {
      this.syncLanguageListFromSelectedMarket(null, {
        preferMarketDefault: false,
      });
    });
  }

  getSelectedMarketItem() {
    const inner = this.element.querySelector(
      '.rs-country__selectbox .RevolutionSelectbox--InnerContent'
    );

    if (!inner) return null;

    const selectedItems = inner.querySelectorAll(
      '.RevolutionSelectbox--Item[selected="selected"]'
    );

    if (!selectedItems.length) return null;
    if (selectedItems.length === 1) return selectedItems[0];

    const countryInput = this.element.querySelector(
      '#country-selector__country-code'
    );
    const currentCountry = (countryInput?.value || '').trim();

    if (currentCountry) {
      const match = Array.from(selectedItems).find(
        (item) => (item.getAttribute('data-value') || '').trim() === currentCountry
      );

      if (match) return match;
    }

    return (
      Array.from(selectedItems).find(
        (item) =>
          (item.getAttribute('data-name') || '').trim().toLowerCase() !==
          'global'
      ) || selectedItems[0]
    );
  }

  dedupeMarketSelection() {
    const inner = this.element.querySelector(
      '.rs-country__selectbox .RevolutionSelectbox--InnerContent'
    );

    if (!inner) return;

    const selectedItems = inner.querySelectorAll(
      '.RevolutionSelectbox--Item[selected="selected"]'
    );

    if (selectedItems.length <= 1) return;

    const keep = this.getSelectedMarketItem();

    selectedItems.forEach((item) => {
      if (item !== keep) {
        item.removeAttribute('selected');
      }
    });
  }

  bindEvents() {
    document.addEventListener(
      'dropdown:opened',
      this.checkFadeVisibility.bind(this)
    );

    this.delegateElement.on(
      'change:countrySelector',
      (event) => {
        this._languageTouchedByUser = false;
        this.updateLanguageOptions(event);
      }
    );

    this.delegateElement.on(
      'click',
      '[data-action=check-location-submit]',
      this.checkLocationSubmit.bind(this)
    );

    this.delegateElement.on(
      'click',
      '.RevolutionSelectbox--Item',
      this.handleRegularMarketSelection.bind(this)
    );

    this.delegateElement.on(
      'change',
      '.localization__language-radio',
      this.handleLanguageSelection.bind(this)
    );

    this.delegateElement.on(
      'click',
      '.localization__language-label',
      this.handleLanguageLabelClick.bind(this)
    );

    if (this.selectContainer) {
      this.selectContainer.addEventListener(
        'scroll',
        this.checkFadeVisibility.bind(this)
      );
    }

    window.addEventListener('resize', this.checkFadeVisibility.bind(this));
  }

  sortMarketItems() {
    const inner = this.element.querySelector(
      '.rs-country__selectbox .RevolutionSelectbox--InnerContent'
    );

    if (!inner) return;

    const items = Array.from(
      inner.querySelectorAll('.RevolutionSelectbox--Item')
    );

    if (!items.length) return;

    const isGlobal = (el) =>
      (el.getAttribute('data-name') || '').trim().toLowerCase() === 'global';

    const globalItems = items.filter(isGlobal);
    const rest = items.filter((el) => !isGlobal(el));

    rest.sort((a, b) => {
      const an = (a.getAttribute('data-name') || '').trim();
      const bn = (b.getAttribute('data-name') || '').trim();

      return an.localeCompare(bn, undefined, { sensitivity: 'base' });
    });

    inner.textContent = '';

    [...globalItems, ...rest].forEach((el) => inner.appendChild(el));
  }

  checkFadeVisibility() {
    const wrapperWithFade = this.element.querySelector(
      '.rs-country__selectbox .RevolutionSelectbox--Content'
    );

    if (!wrapperWithFade || !this.selectContainer) return;

    const isScrollable =
      this.selectContainer.scrollHeight > this.selectContainer.clientHeight;

    const scrollTop = this.selectContainer.scrollTop;
    const scrollHeight = this.selectContainer.scrollHeight;
    const clientHeight = this.selectContainer.clientHeight;
    const distanceFromBottom = scrollHeight - (scrollTop + clientHeight);
    const isNearBottom = distanceFromBottom <= 50;

    wrapperWithFade.classList.toggle(
      'fade-hidden',
      !isScrollable || isNearBottom
    );
  }

  async checkLocationSubmit(event) {
    event.preventDefault();

    // A market picked by hand outranks geo detection for the days set in Market redirect.
    // Defined by geo-redirect.liquid, which is not rendered when the redirect is off.
    window.__ctekGeo?.rememberChoice?.();

    try {
      const selectedItem = this.getSelectedMarketItem();

      if (!selectedItem) {
        console.warn('[Localization] No selected market item found.');
        return;
      }

      const chosenCountryCode = (
        selectedItem.getAttribute('data-value') || ''
      ).trim();

      if (!chosenCountryCode) {
        console.warn('[Localization] Selected market has empty data-value.');
        return;
      }

      const redirectUrl = (
        selectedItem.getAttribute('data-redirect-url') || ''
      ).trim();

      if (redirectUrl) {
        window.location.href = redirectUrl;
        return;
      }

      const countryInput = this.element.querySelector(
        '#country-selector__country-code'
      );

      if (countryInput) {
        countryInput.value = chosenCountryCode;
      }

      this.applyMarketDefaultLanguageBeforeSubmit(selectedItem);
      sessionStorage.setItem('localization-pending', '1');
      showLocalizationSwitchTransition();

      const form = document.getElementById('localization-form');

      if (form) {
        this.applyPdpReturnTo(form, chosenCountryCode);
        form.submit();
      } else {
        console.error('[Localization] localization-form not found');
      }
    } catch (error) {
      console.error('Localization submit error:', error);
    }
  }

  applyPdpReturnTo(form, chosenCountryCode) {
    const mapEl = document.querySelector('[data-pdp-market-map]');

    if (!mapEl) {
      return;
    }

    let map;

    try {
      map = JSON.parse(mapEl.textContent);
    } catch (e) {
      return;
    }

    if (!map) {
      return;
    }

    const key = (chosenCountryCode || '').trim().toUpperCase();
    const targetUrl = map[key];

    if (!targetUrl) return;

    let returnTo = form.querySelector('input[name="return_to"]');

    if (!returnTo) {
      returnTo = document.createElement('input');
      returnTo.type = 'hidden';
      returnTo.name = 'return_to';
      form.appendChild(returnTo);
    }

    returnTo.value = targetUrl;

  }

  handleRegularMarketSelection(event, target) {
    const item = target?.closest?.('.RevolutionSelectbox--Item');

    if (!item || !item.closest('.rs-country__selectbox')) return;
  
    this.element
      .querySelectorAll(
        '.rs-country__selectbox .RevolutionSelectbox--Item[selected="selected"]'
      )
      .forEach((entry) => {
        if (entry !== item) {
          entry.removeAttribute('selected');
        }
      });
  
    item.setAttribute('selected', 'selected');
  
    const countryInput = this.element.querySelector(
      '#country-selector__country-code'
    );
  
    const value = item.getAttribute('data-value');
  
    if (countryInput && value) {
      countryInput.value = value.trim();
    }

    this._languageTouchedByUser = false;
    this.syncLanguageListFromSelectedMarket(item);
  }

  applyMarketDefaultLanguageBeforeSubmit(selectedItem) {
    if (this._languageTouchedByUser) {
      this.syncLanguageFromSelection();
      return;
    }

    const countryIso = (selectedItem.getAttribute('data-value') || '').trim();
    const langs = this.parseLanguages(
      selectedItem.getAttribute('data-languages') || ''
    );
    const hidden = this.element.querySelector('#language-selector__language-code');

    if (!hidden || !langs.length) {
      this.syncLanguageFromSelection();
      return;
    }

    const defaultLanguage = this.resolveCountryDefaultLanguage(countryIso, langs);
    const match = this.findLanguageByIso(langs, defaultLanguage);
    const nextIso = match ? match.iso : langs[0].iso;

    hidden.value = nextIso;

    this.element.querySelectorAll('.localization__language-radio').forEach((radio) => {
      radio.checked =
        this.normalizeLanguageIso(radio.value) ===
        this.normalizeLanguageIso(nextIso);
    });
  }

  handleLanguageSelection(event, target) {
    this._languageTouchedByUser = true;
    this.setSelectedLanguage(target?.value);
  }

  handleLanguageLabelClick(event, target) {
    const radio = target?.querySelector?.('.localization__language-radio');

    if (!radio || radio.disabled) return;

    this._languageTouchedByUser = true;
    this.setSelectedLanguage(radio.value);
  }

  setSelectedLanguage(languageIso) {
    const hidden = this.element.querySelector('#language-selector__language-code');

    if (hidden && languageIso) {
      hidden.value = languageIso;
    }
  }

  syncLanguageFromSelection() {
    const hidden = this.element.querySelector('#language-selector__language-code');
    const checked = this.element.querySelector(
      '.localization__language-radio:checked'
    );

    if (hidden && checked?.value) {
      hidden.value = checked.value;
      return;
    }

    this.ensureLanguageSelection();
  }

  normalizeLanguageIso(iso) {
    return (iso || '').toLowerCase().split('-')[0];
  }

  findLanguageByIso(langs, targetIso) {
    if (!targetIso || !langs.length) return null;

    const target = this.normalizeLanguageIso(targetIso);

    return (
      langs.find(
        (language) => this.normalizeLanguageIso(language.iso) === target
      ) ||
      langs.find(
        (language) => language.iso.toLowerCase() === targetIso.toLowerCase()
      ) ||
      null
    );
  }

  syncLanguageListFromSelectedMarket(selectedItem = null, options = {}) {
    const { preferMarketDefault = true } = options;
    const item = selectedItem || this.getSelectedMarketItem();

    if (!item) return;

    this.ensureLocalizationData().then(() => {
      const countryIso = (item.getAttribute('data-value') || '').trim();
      const langs = this.parseLanguages(item.getAttribute('data-languages') || '');

      if (!langs.length) return;

      const currentLanguage = (
        this.element.querySelector('#language-selector__language-code')?.value || ''
      ).trim();

      const preferredLanguage = preferMarketDefault
        ? this.resolveCountryDefaultLanguage(countryIso, langs)
        : currentLanguage ||
          this.resolveCountryDefaultLanguage(countryIso, langs);

      const preferredInList = this.findLanguageByIso(langs, preferredLanguage)
        ? preferredLanguage
        : this.resolveCountryDefaultLanguage(countryIso, langs);

      this.rebuildLanguageList(langs, preferredInList, countryIso);
    });
  }

  getLocaleHintForCountry(countryIso) {
    const hints = {
      AT: 'de',
      AU: 'en',
      BE: 'nl',
      CA: 'en',
      CH: 'de',
      DE: 'de',
      DK: 'da',
      ES: 'es',
      FI: 'fi',
      FR: 'fr',
      GB: 'en',
      IE: 'en',
      IT: 'it',
      JP: 'ja',
      KR: 'ko',
      NL: 'nl',
      NO: 'no',
      NZ: 'en',
      PL: 'pl',
      PT: 'pt',
      SE: 'sv',
      US: 'en',
    };

    return hints[countryIso] || '';
  }

  resolveCountryDefaultLanguage(countryIso, langs) {
    if (!langs.length) return '';

    const iso = (countryIso || '').toUpperCase();

    if (iso && this._localizationData?.available_countries) {
      const match = this._localizationData.available_countries.find(
        (country) => country.iso_code?.toUpperCase() === iso
      );

      const available = match?.available_languages || [];
      const primary =
        available.find((language) => language.primary || language.default) ||
        available[0];
      const primaryMatch = primary
        ? this.findLanguageByIso(langs, primary.iso_code)
        : null;

      if (primaryMatch) return primaryMatch.iso;
    }

    const localeHint = this.getLocaleHintForCountry(iso);

    if (localeHint) {
      const hintMatch = this.findLanguageByIso(langs, localeHint);

      if (hintMatch) return hintMatch.iso;
    }

    return langs[0].iso;
  }

  ensureLanguageSelection() {
    const hidden = this.element.querySelector('#language-selector__language-code');

    const radios = Array.from(
      this.element.querySelectorAll('.localization__language-radio')
    );

    if (!radios.length) return;

    let checked = radios.find((radio) => radio.checked);

    if (!checked && hidden?.value) {
      checked = radios.find(
        (radio) => radio.value.toLowerCase() === hidden.value.toLowerCase()
      );
    }

    if (!checked) {
      checked = radios[0];
    }

    if (checked) {
      checked.checked = true;
    }

    if (hidden && checked) {
      hidden.value = checked.value;
    }
  }

  async ensureLocalizationData() {
    if (this._localizationData) return this._localizationData;

    // Build from Liquid-rendered market items — /localization.json is not a
    // Shopify endpoint and 404s on this store (also flagged by Lighthouse).
    const countries = Array.from(
      this.element.querySelectorAll(
        '.RevolutionSelectbox--Item[data-value][data-languages]'
      )
    ).map((item) => {
      const langs = this.parseLanguages(item.getAttribute('data-languages') || '');

      return {
        iso_code: item.getAttribute('data-value'),
        available_languages: langs.map((language, index) => ({
          iso_code: language.iso,
          name: language.name,
          endonym_name: language.name,
          primary: index === 0,
        })),
      };
    });

    this._localizationData = { available_countries: countries };
    return this._localizationData;
  }

  parseLanguages(raw) {
    if (!raw) return [];

    try {
      const parsed = JSON.parse(raw);

      if (!Array.isArray(parsed)) return [];

      return parsed
        .map((language) => ({
          iso: (language.iso || language.code || '').toLowerCase(),
          name:
            language.name ||
            language.endonym_name ||
            (language.iso || '').toUpperCase(),
        }))
        .filter((language) => language.iso);
    } catch {
      return [];
    }
  }

  async fallbackLanguagesFromJson(countryIso) {
    const data = await this.ensureLocalizationData();

    if (!data || !countryIso) return [];

    const match = (data.available_countries || []).find(
      (country) => country.iso_code?.toUpperCase() === countryIso.toUpperCase()
    );

    if (!match) return [];

    return (match.available_languages || [])
      .map((language) => ({
        iso: (language.iso_code || '').toLowerCase(),
        name: (language.endonym_name || language.name || language.iso_code || '').replace(
          /\b\w/g,
          (char) => char.toUpperCase()
        ),
      }))
      .filter((language) => language.iso);
  }

  static languageRadioName = 'localization-language';

  sortLanguagesByDefault(langs, defaultIso) {
    const defaultLang = this.findLanguageByIso(langs, defaultIso);

    if (!defaultLang) return [...langs];

    const rest = langs.filter(
      (language) =>
        this.normalizeLanguageIso(language.iso) !==
        this.normalizeLanguageIso(defaultLang.iso)
    );

    return [defaultLang, ...rest];
  }

  rebuildLanguageList(langs, preferredIso = null, countryIso = '') {
    const list = this.element.querySelector('.localization__languages-list');
    const hidden = this.element.querySelector('#language-selector__language-code');

    if (!list || !hidden || !langs.length) return;

    const templateLabel = list.querySelector('.localization__language-label');

    if (!templateLabel) return;

    const preferred = (preferredIso || '').toLowerCase();
    const preferredMatch = this.findLanguageByIso(langs, preferred);
    const nextIso = preferredMatch ? preferredMatch.iso : langs[0].iso;
    const defaultIso = this.resolveCountryDefaultLanguage(countryIso, langs);
    const sortedLangs = this.sortLanguagesByDefault(langs, defaultIso);

    list.innerHTML = '';

    sortedLangs.forEach((language) => {
      const label = templateLabel.cloneNode(true);
      const input = label.querySelector('.localization__language-radio');

      if (input) {
        input.name = LocalizationModal.languageRadioName;
        input.value = language.iso;
        input.checked = false;
        input.disabled = langs.length === 1;
      }

      const title = label.querySelector('.localization__language-title');

      if (title) {
        title.textContent = language.name;
      }

      list.appendChild(label);
    });

    list.querySelectorAll('.localization__language-radio').forEach((radio) => {
      radio.checked = false;
    });

    const selectedRadio = Array.from(
      list.querySelectorAll('.localization__language-radio')
    ).find(
      (radio) =>
        this.normalizeLanguageIso(radio.value) ===
        this.normalizeLanguageIso(nextIso)
    );

    if (selectedRadio) {
      selectedRadio.checked = true;
    }

    hidden.value = nextIso;
  }

  async updateLanguageOptions(event) {
    const countryIso = (event?.detail?.country || '').trim();

    const selectedItem = countryIso
      ? this.element.querySelector(
          `.rs-country__selectbox .RevolutionSelectbox--Item[data-value="${CSS.escape(countryIso)}"]`
        )
      : this.getSelectedMarketItem();

    if (!selectedItem) return;

    let langs = this.parseLanguages(
      event?.detail?.languages ||
        selectedItem.getAttribute('data-languages') ||
        ''
    );

    if (!langs.length && countryIso) {
      langs = await this.fallbackLanguagesFromJson(countryIso);
    }

    if (!langs.length) return;

    await this.ensureLocalizationData();

    const marketCountryIso =
      countryIso || selectedItem.getAttribute('data-value') || '';

    const defaultLanguage = this.resolveCountryDefaultLanguage(
      marketCountryIso,
      langs
    );

    this.rebuildLanguageList(langs, defaultLanguage, marketCountryIso);
  }
}

customElements.define('localization-modal', LocalizationModal);

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector(
        'input[name="language_code"], input[name="country_code"]'
      ),
    };
    this.querySelectorAll('a').forEach((item) =>
      item.addEventListener('click', this.onItemClick.bind(this))
    );
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }
}

customElements.define('localization-form', LocalizationForm);

class PickupAvailability extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    if (!this.hasAttribute("available")) return;
    this.fetchAvailability(this.dataset.variantId);
  }

  fetchAvailability(variantId) {
    const variantSectionUrl = `${window.routes.localeRootUrl}/variants/${variantId}/?section_id=helper-pickup`;

    fetch(variantSectionUrl)
      .then((response) => response.text())
      .then((text) => {
        const sectionInnerHTML = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector(".shopify-section");
        this.renderPreview(sectionInnerHTML);
      })
      .catch((e) => {
        this.renderError();
      });
  }

  renderError() { }

  renderPreview(sectionInnerHTML) {
    this.element.innerHTML = "";

    this.element.appendChild(
      sectionInnerHTML.querySelector(".LocalPickup_--Wrapper")
    );
    if (sectionInnerHTML.querySelector("#LocalPickup")) {
      this.element.appendChild(sectionInnerHTML.querySelector("#LocalPickup"));
      new Drawer(this.element.querySelector("#LocalPickup"));
    }
  }
}

customElements.define("pickup-availability", PickupAvailability);

class CartNote extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.textarea = this.element.querySelector("textarea");
    this.button = this.element.querySelector(".CartNote--Submit");
    this.noteSucess = this.element.querySelector(".cartNote--Success");
    this.bindEvents();
  }
  bindEvents() {
    this.delegateElement.on(
      "click",
      "[data-action='update-note']",
      this.updateNote.bind(this)
    );

    this.delegateElement.on(
      "click",
      "[data-action='edit-note']",
      this.editNote.bind(this)
    );
  }
  editNote() {
    this.textarea.removeAttribute("disabled");
    this.button.innerText = window.cartStrings.enter_note;
    this.button.setAttribute("data-action", "update-note");
    this.textarea.focus();
    this.noteSucess.style.visibility = "hidden";
    this.noteSucess.style.opacity = "0";
  }

  updateNote() {
    var _this = this;
    this.value = this.textarea.value;

    fetch(window.routes.localeRootUrl + "/cart/update.js", {
      body: JSON.stringify({ note: this.value }),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then(function (response) {
      if (response.ok) {
        if (_this.value == "") {
          return;
        }
        _this.textarea.setAttribute("disabled", "disabled");
        _this.button.innerText = window.cartStrings.note_change;
        _this.button.setAttribute("data-action", "edit-note");
        _this.noteSucess.style.visibility = "visible";
        _this.noteSucess.style.opacity = "1";
      }
    });
  }
}

customElements.define("cart-note", CartNote);

/**
 * Shared newsletter handler for Klaviyo integration
 * Used by both NewsletterPopup and FooterComponent
 */
class NewsletterHandler {
  constructor(options = {}) {
    this.listId = options.listId;
    this.publicKey = options.publicKey;
    this.onSuccess = options.onSuccess || (() => { });
    this.onError = options.onError || ((error) => console.error('Newsletter error:', error));
  }

  /**
   * Submit email to Klaviyo
   * @param {string} email - Email address to subscribe
   * @returns {Promise<Response>}
   */
  async subscribe(email) {
    if (!email || !this.listId || !this.publicKey) {
      throw new Error('Missing required parameters: email, listId, or publicKey');
    }

    const payload = {
      data: {
        type: "subscription",
        attributes: {
          profile: {
            data: {
              type: "profile",
              attributes: { email: email }
            }
          }
        },
        relationships: {
          list: {
            data: {
              type: "list",
              id: this.listId
            }
          }
        }
      }
    };

    const endpoint = `https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(this.publicKey)}`;

    try {
      const response = await fetch(endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/vnd.api+json",
          "revision": "2024-06-15",
          "Cache-Control": "no-cache"
        },
        body: JSON.stringify(payload),
        keepalive: true
      });

      if (!response.ok) {
        // Handle specific error cases
        if (response.status === 409) {
          // Duplicate subscription
          throw new Error('DUPLICATE_EMAIL');
        }
        throw new Error(`Klaviyo API error: ${response.statusText}`);
      }

      return response;
    } catch (error) {
      this.onError(error);
      throw error;
    }
  }

  /**
   * Validate email format
   * @param {string} email
   * @returns {boolean}
   */
  static isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }
}

class NewsletterPopup extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.options = JSON.parse(this.element.getAttribute("data-section-settings"));

    // Initialize newsletter handler
    this.initNewsletterHandler();

    if (this.options.edit_mode) {
      this.options.delay = 0;
      this.openNewsletter();
    } else {
      this.checkCookiePopupAndStart();
    }
  }

  initNewsletterHandler() {
    const settings = this.getNewsletterSettings();
    this.newsletterHandler = new NewsletterHandler({
      listId: settings.listId,
      publicKey: settings.publicApiKey,
      onSuccess: () => {
        localStorage.setItem("popup-subscribed", "true");
        this.showSuccessState();
      },
      onError: (error) => {
        console.error('Klaviyo subscription error:', error);
        if (error.message === 'DUPLICATE_EMAIL') {
          this.showDuplicateEmailMessage();
        }
      }
    });
  }

  getNewsletterSettings() {
    const wrapper = this.element.querySelector('.newsletter__wrapper');
    if (wrapper && wrapper.dataset.settings) {
      return JSON.parse(wrapper.dataset.settings);
    }
    // Fallback to options if settings not in wrapper
    return {
      listId: this.options.klaviyo_list_id,
      publicApiKey: this.options.klaviyo_public_key
    };
  }

  connectedCallback() {
    this.bindEvents();
    this.initFormValidation();
  }

  bindEvents() {
    const formEl = this.element.querySelector('.newsletter__form');
    if (formEl) {
      formEl.addEventListener('submit', this.onSubmit.bind(this));
    }
  }

  initFormValidation() {
    const form = this.element.querySelector('form');
    if (!form) return;

    this.validator = new FormValidator(form, {
      errorClass: 'field--error',
      fieldSelector: '.newsletter__email-input-wrapper',
      buttonSelector: '.newsletter__subscribe-button',
      validateOnBlur: true,
      validateOnInput: true,
      errorOutputSelector: ".newsletter__error-wrapper",
      showErrorsOnSubmitOnly: false
    });
  }

  checkCookiePopupAndStart() {
    const cookiePopup = document.querySelector('#shopify-pc__banner');
    if (cookiePopup) {
      const isVisible = cookiePopup.style.display !== 'none' &&
        window.getComputedStyle(cookiePopup).display !== 'none';

      if (isVisible) {
        this.waitForCookiePopupDismissal(cookiePopup);
      } else {
        this.cookiePopupDismissed = true;
        this.handleOpenOptions();
      }
    } else {
      this.cookiePopupDismissed = true;
      this.handleOpenOptions();
    }
  }

  handleCookieButtonClick(e) {
    setTimeout(() => {
      this.cookiePopupDismissed = true;
      this.handleOpenOptions();
      document.removeEventListener('click', this.handleCookieButtonClick);
    }, 500);
  }

  waitForCookiePopupDismissal() {
    this.delegateBody.on(
      'click',
      '#shopify-pc__banner__btn-decline',
      this.handleCookieButtonClick.bind(this)
    );

    this.delegateBody.on(
      'click',
      '#shopify-pc__banner__btn-accept',
      this.handleCookieButtonClick.bind(this)
    );
  }

  handleOpenOptions() {
    if (!this.cookiePopupDismissed) {
      return;
    }

    const seen = localStorage.getItem("popup-seen") === "true";
    const subscribed = localStorage.getItem("popup-subscribed") === "true";

    if ((this.options.show_only_once && seen) || subscribed) {
      return;
    }

    if (this.options.scroll_amount > 0) {
      this.myScrollListener = scrollListener.addScrollListener(this, this.scrollListener);
    } else {
      this.openNewsletter();
    }
  }

  scrollListener = () => {
    const body = document.body;
    const html = document.documentElement;

    const docHeight = Math.max(
      body.scrollHeight,
      body.offsetHeight,
      html.clientHeight,
      html.scrollHeight,
      html.offsetHeight
    );

    const percScrolled = (window.scrollY / docHeight) * 100;

    if (percScrolled >= this.options.scroll_amount) {
      this.openNewsletter();
    }
  };

  openNewsletter() {
    if (this.myScrollListener) {
      this.myScrollListener.removeScrollListener();
    }

    setTimeout(() => {
      this.element.setAttribute("aria-hidden", false);

      //Overlay
      // Clean up any pending close operations from any component
      if (this.pageOverlayElement._pendingCloseHandler) {
        this.pageOverlayElement.removeEventListener("transitionend", this.pageOverlayElement._pendingCloseHandler);
        this.pageOverlayElement._pendingCloseHandler = null;
      }
      if (this.pageOverlayElement._pendingCloseTimeout) {
        clearTimeout(this.pageOverlayElement._pendingCloseTimeout);
        this.pageOverlayElement._pendingCloseTimeout = null;
      }

      this.pageOverlayElement.style.display = "block";
      requestAnimationFrame(() => {
        this.pageOverlayElement.classList.add("is-visible");
      })
      this.pageOverlayElement.addEventListener("click", this.closeNewsletter);

      bodyScrollLock.disableBodyScroll(this.element, bodyScrollLockOptions);
      document.body.classList.add("scrollLock");

      localStorage.setItem("popup-seen", true);

      this.delegateElement.on(
        "click",
        '[data-action="close-modal"]',
        this.closeNewsletter
      );
    }, 1000 * this.options.delay);
  }

  closeNewsletter = () => {
    this.element.setAttribute("aria-hidden", true);

    //Overlay
    this.pageOverlayElement.classList.remove("is-visible");

    const transitionHandler = () => {
      if (this.pageOverlayElement._pendingCloseTimeout) {
        clearTimeout(this.pageOverlayElement._pendingCloseTimeout);
        this.pageOverlayElement._pendingCloseTimeout = null;
      }
      this.pageOverlayElement.style.display = "none";
      this.pageOverlayElement.removeEventListener("transitionend", transitionHandler);
      this.pageOverlayElement._pendingCloseHandler = null;
    };

    // Store handler on overlay element so other components can clean it up
    this.pageOverlayElement._pendingCloseHandler = transitionHandler;
    this.pageOverlayElement.addEventListener("transitionend", transitionHandler);

    // Fallback in case transitionend doesn't fire
    this.pageOverlayElement._pendingCloseTimeout = setTimeout(() => {
      if (this.pageOverlayElement._pendingCloseHandler) {
        this.pageOverlayElement.removeEventListener("transitionend", this.pageOverlayElement._pendingCloseHandler);
        this.pageOverlayElement._pendingCloseHandler = null;
      }
      this.pageOverlayElement.style.display = "none";
      this.pageOverlayElement._pendingCloseTimeout = null;
    }, 850);

    this.pageOverlayElement.removeEventListener("click", this.closeNewsletter);

    bodyScrollLock.clearAllBodyScrollLocks();
    document.body.classList.remove("scrollLock");

    if (this.myScrollListener) {
      this.myScrollListener.removeScrollListener();
    }
  };

  async onSubmit(e) {
    e.preventDefault();

    const emailEl = this.element.querySelector('.newsletter__email-input');
    const email = emailEl ? emailEl.value.trim() : '';

    if (!email) return;

    try {
      const response = await this.newsletterHandler.subscribe(email);
      if (response.ok) this.showSuccessState();
      // Success handler is called automatically in newsletterHandler
    } catch (error) {
      // Error handler is called automatically in newsletterHandler
    }
  }

  showSuccessState() {
    const popup = this.element;
    const contentWrapper = popup.querySelector('.newsletter-popup__content-wrapper');
    const success = popup.querySelector('.newsletter__success-wrapper');
    const duplicateWrapper = popup.querySelector('.newsletter__duplicate-email-wrapper');

    // Hide duplicate message if it was showing
    if (duplicateWrapper) {
      duplicateWrapper.style.display = 'none';
    }

    popup.setAttribute('aria-hidden', 'true');

    const onTransitionEnd = (e) => {
      if (e.propertyName !== 'transform') return;

      contentWrapper.style.display = 'none';
      success.style.display = '';
      popup.setAttribute('aria-hidden', 'false');

      popup.removeEventListener('transitionend', onTransitionEnd);
    };

    popup.addEventListener('transitionend', onTransitionEnd);
  }

  showDuplicateEmailMessage() {
    const popup = this.element;
    const form = popup.querySelector('.newsletter__form');
    const successWrapper = popup.querySelector('.newsletter__success-wrapper');
    const duplicateWrapper = successWrapper.querySelector('.newsletter__duplicate-email-wrapper');

    popup.setAttribute('aria-hidden', 'true');

    const onTransitionEnd = (e) => {
      if (e.propertyName !== 'transform') return;

      form.style.display = 'none';
      successWrapper.style.display = '';
      duplicateWrapper.style.display = '';
      popup.setAttribute('aria-hidden', 'false');

      popup.removeEventListener('transitionend', onTransitionEnd);
    };

    popup.addEventListener('transitionend', onTransitionEnd);
  }
}

customElements.define("newsletter-popup", NewsletterPopup);

class ProductSelectorPopup extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.options = JSON.parse(this.element.getAttribute("data-section-settings"));
    this.initialized = false;

    if (this.options.edit_mode) {
      // Open popup in edit mode using the global Popup instance
      if (window.globalPopup) {
        window.globalPopup.openPopup(this.element, false);
      }
    }
  }

  connectedCallback() {
    this.swiperElement = this.element.querySelector('.ps-swiper');

    // Wait for swiper to initialize before populating step counts
    if (this.swiperElement && this.swiperElement.swiper) {
      // Use requestAnimationFrame to ensure DOM is fully rendered
      requestAnimationFrame(() => {
        this.initializeStepSliders();
      });
    } else {
      // Listen for swiper initialization
      this.swiperElement?.addEventListener('swiper:initialized', () => {
        requestAnimationFrame(() => {
          this.initializeStepSliders();
        });
      }, { once: true });

      // Fallback timeout
      setTimeout(() => {
        this.initializeStepSliders();
      }, 500);
    }

    this.bindEvents();
    this.observePopupState();
  }

  observePopupState() {
    // Track if we've locked, so we only unlock if we locked
    this.hasLockedScroll = false;

    // Watch for aria-hidden attribute changes to lock/unlock iOS scroll
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'aria-hidden') {
          const isHidden = this.element.getAttribute('aria-hidden') === 'true';
          if (isHidden) {
            // Popup is closing - unlock iOS scroll only if we locked it
            if (this.hasLockedScroll) {
              IOSScrollLock.unlock();
              this.hasLockedScroll = false;
            }
          } else {
            // Popup is opening - lock iOS scroll
            IOSScrollLock.lock();
            this.hasLockedScroll = true;
          }
        }
      });
    });

    observer.observe(this.element, {
      attributes: true,
      attributeFilter: ['aria-hidden']
    });
  }

  initializeStepSliders() {
    // Prevent double initialization
    if (this.initialized) {
      return;
    }

    // Only select slides from the main product selector swiper, not from product cards
    const mainSwiper = this.element.querySelector('.ps-swiper .swiper-wrapper');
    const slides = mainSwiper ? mainSwiper.querySelectorAll(':scope > .swiper-slide') : [];
    const stepSlider = this.element.querySelector('.ps-step__step-slider');
    const linkWrapper = this.element.querySelector('.ps-step__link-wrapper');

    if (!stepSlider || slides.length === 0) return;

    // Mark as initialized
    this.initialized = true;

    // Clear existing content
    stepSlider.innerHTML = '';
    if (linkWrapper) {
      linkWrapper.innerHTML = '';
    }

    // Collect step names from each slide and create step count divs
    slides.forEach((slide, index) => {
      const stepNameEl = slide.querySelector('.ps-step__step-count-text');

      // Create step count wrapper
      const stepCountDiv = document.createElement('div');
      stepCountDiv.className = 'ps-step__step-count';
      stepCountDiv.setAttribute('data-slide-index', index);

      // Add active class to first step
      if (index === 0) {
        stepCountDiv.classList.add('is-active');
      }

      // Clone the step count text element (with icon) or create a fallback
      let stepCountText;
      if (stepNameEl) {
        stepCountText = stepNameEl.cloneNode(true);
        stepCountText.style.display = '';
      } else {
        stepCountText = document.createElement('div');
        stepCountText.className = 'ps-step__step-count-text';
        stepCountText.textContent = `Step ${index + 1}`;
      }

      // Create step count indicator
      const stepCountIndicator = document.createElement('div');
      stepCountIndicator.className = 'ps-step__step-count-indicator';

      stepCountDiv.appendChild(stepCountText);
      stepCountDiv.appendChild(stepCountIndicator);
      stepSlider.appendChild(stepCountDiv);

      // Add click handler to navigate to this step
      stepCountDiv.addEventListener('click', () => {
        this.goToStep(index);
      });

      // Move link wrapper from slide to main link wrapper
      if (linkWrapper) {
        const stepLinkWrapper = slide.querySelector('.step-link__wrapper');

        if (stepLinkWrapper) {
          // Clone and append to main wrapper
          const clonedLink = stepLinkWrapper.cloneNode(true);
          clonedLink.setAttribute('data-slide-index', index);

          // Hide all except first
          if (index !== 0) {
            clonedLink.classList.add('is-hidden');
          }

          linkWrapper.appendChild(clonedLink);

          // Remove from slide
          stepLinkWrapper.remove();
        }
      }
    });

    // Hide link wrapper container if no links were added
    if (linkWrapper) {
      const hasLinks = linkWrapper.querySelectorAll('.step-link__wrapper').length > 0;
      if (!hasLinks) {
        linkWrapper.style.display = 'none';
      }
    }

    // Listen for slide changes to update active state
    if (this.swiperElement?.swiper?.swiperElement) {
      this.swiperElement.swiper.swiperElement.on('slideChange', () => {
        this.updateActiveStep();
        this.updateActiveLink();
        this.updateNextButtonState();
      });
    }

    // Initialize button states for all slides
    slides.forEach((slide) => {
      this.updateNextButtonState(slide);
    });
  }

  goToStep(index) {
    if (this.swiperElement?.swiper?.swiperElement) {
      this.swiperElement.swiper.swiperElement.slideTo(index);
    }
  }

  updateActiveStep() {
    if (!this.swiperElement?.swiper?.swiperElement) return;

    const activeIndex = this.swiperElement.swiper.swiperElement.activeIndex;
    const stepSlider = this.element.querySelector('.ps-step__step-slider');

    if (!stepSlider) return;

    const stepCounts = stepSlider.querySelectorAll('.ps-step__step-count');
    stepCounts.forEach((stepCount, countIndex) => {
      if (countIndex === activeIndex) {
        stepCount.classList.add('is-active');
      } else {
        stepCount.classList.remove('is-active');
      }
    });
  }

  updateActiveLink() {
    if (!this.swiperElement?.swiper?.swiperElement) return;

    const activeIndex = this.swiperElement.swiper.swiperElement.activeIndex;
    const linkWrapper = this.element.querySelector('.ps-step__link-wrapper');

    if (!linkWrapper) return;

    const linkWrappers = linkWrapper.querySelectorAll('.step-link__wrapper');
    linkWrappers.forEach((link) => {
      const linkSlideIndex = parseInt(link.getAttribute('data-slide-index'), 10);
      if (linkSlideIndex === activeIndex) {
        link.classList.remove('is-hidden');
      } else {
        link.classList.add('is-hidden');
      }
    });
  }

  bindEvents() {
    this.delegateElement.on('click', '.ps-step__next-button', () => {
      this.goToNextStep();
    });

    this.delegateElement.on('click', '.ps-step__option-button', (event) => {
      this.handleOptionClick(event);
    });

    this.delegateElement.on('click', '[data-action="refresh-selector"]', () => {
      this.refreshSelection();
    });

    this.delegateElement.on('click', '.ps-step__step-count', (event) => {
      this.handleStepClick(event);
    });

    // Listen for product:added event to close popup when product is added to cart from results
    this.element.addEventListener('product:added', () => {
      // Only close if the popup is open (check if it's visible)
      const isPopupOpen = this.element.getAttribute('aria-hidden') === 'false' ||
                          this.element.getAttribute('aria-expanded') === 'true';

      if (isPopupOpen) {
        this.closePopup();
      }
    });
  }

  closePopup() {
    if (window.globalPopup) {
      window.globalPopup.closePopup(this.element);
    }

    // Reset the selector after popup is closed and off-screen
    setTimeout(() => {
      this.refreshSelection();
    }, 600);
  }

  handleStepClick(event) {
    const stepCount = event.target.closest('.ps-step__step-count');
    if (!stepCount) return;

    // Only allow clicking on completed steps or the active step
    const isCompleted = stepCount.classList.contains('is-completed');
    const isActive = stepCount.classList.contains('is-active');

    if (!isCompleted && !isActive) {
      // Don't allow navigation to incomplete steps
      return;
    }

    // Get the index of the clicked step
    const stepCounts = this.element.querySelectorAll('.ps-step__step-count');
    const stepIndex = Array.from(stepCounts).indexOf(stepCount);

    if (stepIndex === -1) return;

    // Navigate to that step
    if (this.swiperElement && this.swiperElement.swiper && this.swiperElement.swiper.swiperElement) {
      const swiper = this.swiperElement.swiper.swiperElement;
      swiper.slideTo(stepIndex);
    }
  }

  handleOptionClick(event) {
    const button = event.target.closest('.ps-step__option-button');
    if (!button) return;

    // Check if multiple selections are enabled for this step
    const currentSlide = button.closest('.swiper-slide');
    const stepElement = currentSlide?.querySelector('.ps-step');
    const enableMultiple = stepElement?.dataset.enableMultiple === 'true';
    const excludeTag = stepElement?.dataset.excludeTag?.trim().toLowerCase();

    if (enableMultiple) {
      // Toggle selection for this button
      const isSelected = button.hasAttribute('selected');
      if (isSelected) {
        button.removeAttribute('selected');
        button.classList.remove('is-active');
        button.setAttribute('aria-pressed', 'false');
      } else {
        button.setAttribute('selected', '');
        button.classList.add('is-active');
        button.setAttribute('aria-pressed', 'true');
      }
    } else {
      // Single selection - deselect all others in this step
      const optionsContainer = button.closest('.ps-step__options');
      if (optionsContainer) {
        const allButtons = optionsContainer.querySelectorAll('.ps-step__option-button');
        allButtons.forEach(btn => {
          btn.removeAttribute('selected');
          btn.classList.remove('is-active');
          btn.setAttribute('aria-pressed', 'false');
        });
      }

      // Select this button
      button.setAttribute('selected', '');
      button.classList.add('is-active');
      button.setAttribute('aria-pressed', 'true');
    }

    // Handle exclude tag logic
    if (excludeTag) {
      this.handleExcludeTag(currentSlide, excludeTag);
    }

    // Update next button state for current slide
    this.updateNextButtonState(currentSlide);

    // Also update the last step's button state (in case all steps are now complete)
    if (this.swiperElement?.swiper?.swiperElement) {
      const swiper = this.swiperElement.swiper.swiperElement;
      const lastSlide = swiper.slides[swiper.slides.length - 1];
      if (lastSlide && lastSlide !== currentSlide) {
        this.updateNextButtonState(lastSlide);
      }
    }
  }

  handleExcludeTag(slide, excludeTag) {
    const optionsContainer = slide.querySelector('.ps-step__options');
    if (!optionsContainer) return;

    const allButtons = optionsContainer.querySelectorAll('.ps-step__option-button');
    const selectedButtons = optionsContainer.querySelectorAll('.ps-step__option-button[selected]');

    let excludeButton = null;
    let otherSelectedButtons = [];

    // Find the exclude button and other selected buttons
    allButtons.forEach(btn => {
      const btnTag = btn.getAttribute('data-tag')?.trim().toLowerCase();
      if (btnTag === excludeTag) {
        excludeButton = btn;
      }
    });

    selectedButtons.forEach(btn => {
      const btnTag = btn.getAttribute('data-tag')?.trim().toLowerCase();
      if (btnTag !== excludeTag) {
        otherSelectedButtons.push(btn);
      }
    });

    if (!excludeButton) return;

    // If any other button is selected, disable the exclude button
    if (otherSelectedButtons.length > 0) {
      excludeButton.setAttribute('disabled', '');
    } else {
      // No other selections - enable the exclude button
      excludeButton.removeAttribute('disabled');
    }
  }

  updateNextButtonState(slide) {
    if (!slide) {
      // If no slide provided, update for current active slide
      if (this.swiperElement?.swiper?.swiperElement) {
        const activeIndex = this.swiperElement.swiper.swiperElement.activeIndex;
        const slides = this.element.querySelectorAll('.swiper-slide');
        slide = slides[activeIndex];
      }
    }

    if (!slide) return;

    const nextButton = slide.querySelector('.ps-step__next-button');
    if (!nextButton) return;

    // Check if current slide has selection
    const selectedOptions = slide.querySelectorAll('.ps-step__option-button[selected]');
    const hasSelection = selectedOptions.length > 0;

    // Check if this is the last step
    const swiper = this.swiperElement?.swiper?.swiperElement;
    if (swiper) {
      const currentIndex = swiper.activeIndex;
      const isLastStep = currentIndex === swiper.slides.length - 1;

      if (isLastStep) {
        // For the last step, check if all steps have selections
        let allStepsHaveSelections = true;

        for (let i = 0; i < swiper.slides.length; i++) {
          const stepSlide = swiper.slides[i];
          const stepHasSelection = stepSlide.querySelectorAll('.ps-step__option-button[selected]').length > 0;

          if (!stepHasSelection) {
            allStepsHaveSelections = false;
            break;
          }
        }

        // Enable button only if all steps have selections
        if (allStepsHaveSelections) {
          nextButton.removeAttribute('disabled');
        } else {
          nextButton.setAttribute('disabled', '');
        }
      } else {
        // For non-last steps, only check current step
        if (hasSelection) {
          nextButton.removeAttribute('disabled');
        } else {
          nextButton.setAttribute('disabled', '');
        }
      }
    } else {
      // Fallback if swiper not available - just check current selection
      if (hasSelection) {
        nextButton.removeAttribute('disabled');
      } else {
        nextButton.setAttribute('disabled', '');
      }
    }
  }

  goToNextStep() {
    if (this.swiperElement && this.swiperElement.swiper && this.swiperElement.swiper.swiperElement) {
      const swiper = this.swiperElement.swiper.swiperElement;
      const currentIndex = swiper.activeIndex;
      const nextIndex = currentIndex + 1;

      // Mark current step as completed
      const stepCounts = this.element.querySelectorAll('.ps-step__step-count');
      if (stepCounts[currentIndex]) {
        stepCounts[currentIndex].classList.add('is-completed');
      }

      // Check if this is the last step
      if (nextIndex >= swiper.slides.length) {
        // Verify all steps are completed before showing results
        const totalSteps = swiper.slides.length;
        const completedSteps = this.element.querySelectorAll('.ps-step__step-count.is-completed').length;

        if (completedSteps === totalSteps) {
          // All steps completed - show results
          this.showResults();
        } else {
          // Not all steps completed - don't show results
          console.warn('Cannot show results: not all steps are completed');
        }
      } else {
        swiper.slideTo(nextIndex);
      }
    }
  }

  async showResults() {
    // Collect all selected tags from all steps
    const selectedTags = this.getSelectedTags();

    if (selectedTags.length === 0) {
      return;
    }

    // Add results mode class to wrapper for wider max-width
    this.element.classList.add('ps-wrapper--results');

    const contentWrapper = this.element.querySelector('.ps-popup__content-wrapper');
    const resultsWrapper = this.element.querySelector('.ps-popup__results-wrapper');
    if (!resultsWrapper) return;

    if (contentWrapper) contentWrapper.style.display = 'none';
    resultsWrapper.style.display = 'block';
    resultsWrapper.classList.add('is-visible');

    // Get results div and filter products
    const resultsDiv = this.element.querySelector('.ps-popup__results');
    if (!resultsDiv) return;

    // Filter and display products
    await this.fetchAndFilterProducts(selectedTags, resultsDiv);
  }

  getSelectedTags() {
    const selectedButtons = this.element.querySelectorAll('.ps-step__option-button[selected]');
    const tags = [];

    selectedButtons.forEach(button => {
      const tag = button.getAttribute('data-tag');
      if (tag) {
        tags.push(tag.trim());
      }
    });

    return tags;
  }

  _hydrateProductPool() {
    if (this._poolHydrated) return;
    const tpl = this.element.querySelector('#ps-products-pool-tpl');
    if (tpl && tpl.content) {
      const pool = document.createElement('div');
      pool.className = 'ps-products-pool';
      pool.style.display = 'none';
      pool.appendChild(tpl.content);
      tpl.replaceWith(pool);
    }
    this._poolHydrated = true;
  }

  async fetchAndFilterProducts(selectedTags, resultsDiv) {
    try {
      this._hydrateProductPool();
      // Get product pool and swiper wrapper
      const productPool = this.element.querySelector('.ps-products-pool');
      const swiperWrapper = resultsDiv.querySelector('.swiper-wrapper');

      if (!productPool || !swiperWrapper) {
        console.error('Product pool or swiper wrapper not found');
        return;
      }

      // Hide while swapping to prevent vertical stack flash
      swiperWrapper.style.visibility = 'hidden';

      // Clear existing products from swiper
      swiperWrapper.innerHTML = '';

      // Remove any previous no-results message
      const existingNoResults = resultsDiv.querySelector('.ps-no-results');
      if (existingNoResults) {
        existingNoResults.remove();
      }

      // Get all product templates from pool
      const productTemplates = productPool.querySelectorAll('.ps-product-card-template');

      // Collect all products with their match information
      let matchingProducts = [];

      productTemplates.forEach(template => {
        const productTagsStr = template.getAttribute('data-product-tags');
        if (!productTagsStr) {
          return;
        }

        // Parse product tags
        const productTags = productTagsStr.split(',').map(tag => tag.trim().toLowerCase()).filter(tag => tag);
        const selectedTagsLower = selectedTags.map(tag => tag.toLowerCase());

        // Count how many selected tags this product has
        const matchingTagsCount = selectedTagsLower.filter(selectedTag =>
          productTags.includes(selectedTag)
        ).length;

        if (matchingTagsCount > 0) {
          const isExactMatch = matchingTagsCount === selectedTags.length && productTags.length === selectedTags.length;
          const hasAllSelectedTags = matchingTagsCount === selectedTags.length;

          // Get grading for sorting (1 = best, 2 = better, 3 = good)
          const grading = parseInt(template.getAttribute('data-product-grading')) || 999;

          matchingProducts.push({
            template: template,
            matchCount: matchingTagsCount,
            productTagsCount: productTags.length,
            isExactMatch: isExactMatch,
            hasAllSelectedTags: hasAllSelectedTags,
            grading: grading
          });
        }
      });

      // Sort priority:
      // 1. By match count (most matches first)
      // 2. Then by grading (higher = better for display: 3 = good, 2 = better, 1 = best)
      // 3. Then by product tag count (fewer extra tags is better)
      // 4. Finally by exact match (true first) as a last tie-breaker
      matchingProducts.sort((a, b) => {
        if (a.matchCount !== b.matchCount) {
          return b.matchCount - a.matchCount; // More matches better
        }
        if (a.grading !== b.grading) {
          return b.grading - a.grading; // Good first
        }
        if (a.productTagsCount !== b.productTagsCount) {
          return a.productTagsCount - b.productTagsCount; // Fewer extra tags better
        }
        if (a.isExactMatch !== b.isExactMatch) {
          return b.isExactMatch ? 1 : -1; // Exact matches first
        }
        return 0;
      });

      // Filter logic:
      // Only show products that match ALL selected tags.
      // If none match all tags, show fallback products from theme settings.
      let productsToShow = [];

      const allTagsMatches = matchingProducts.filter(p => p.hasAllSelectedTags);
      if (allTagsMatches.length > 0) {
        productsToShow = allTagsMatches.slice(0, 3);
      }

      // Append selected products to swiper in order (max 3, min 1)
      if (productsToShow.length > 0) {
        productsToShow.forEach((product, index) => {
          // Clone the template
          const clone = product.template.cloneNode(true);

          // Change class from template to wrapper and add swiper-slide class
          clone.classList.remove('ps-product-card-template');
          clone.classList.add('ps-product-card-wrapper', 'swiper-slide');

          // Append to swiper wrapper
          swiperWrapper.appendChild(clone);

          // Manually attach event listeners to the cloned overlay buttons
          const productCard = clone.querySelector('product-card');
          if (productCard) {
            const overlay = productCard.querySelector('.pc__actions--overlay');
            if (overlay) {
              this.attachOverlayListeners(productCard, overlay);
            }
          }
        });

        // Update swiper after adding slides
        const swiperElement = resultsDiv.closest('swiper-init');
        if (swiperElement && swiperElement.swiper && swiperElement.swiper.swiperElement) {
          const swiper = swiperElement.swiper.swiperElement;
          swiper.update();

          // Enable centeredSlides only on mobile when there's exactly one slide
          const isMobile = !responsive.matchesBreakpoint('lap-and-up');
          const hasOneSlide = swiper.slides.length === 1;
          swiper.params.centeredSlides = isMobile && hasOneSlide;
          swiper.update();

          // Go to first slide
          swiper.slideTo(0, 0);
        }
        swiperWrapper.style.visibility = '';
      } else {
        // No matching products - show fallback products
        const fallbackProducts = productPool.querySelectorAll('.ps-product-card-fallback');
        this.setFallbackMode(true);

        if (fallbackProducts.length > 0) {
          // Collect fallback products with grading for sorting
          let fallbackList = [];
          fallbackProducts.forEach(template => {
            const grading = parseInt(template.getAttribute('data-product-grading')) || 999;
            fallbackList.push({ template, grading });
          });

          // Sort by grading (higher = better for display: 3 = good, 2 = better, 1 = best)
          fallbackList.sort((a, b) => b.grading - a.grading);

          // Show up to 3 fallback products
          const fallbacksToShow = fallbackList.slice(0, 3);

          fallbacksToShow.forEach((product, index) => {
            const clone = product.template.cloneNode(true);
            clone.classList.remove('ps-product-card-fallback');
            clone.classList.add('ps-product-card-wrapper', 'swiper-slide');

            swiperWrapper.appendChild(clone);

            // Manually attach event listeners to the cloned overlay buttons
            const productCard = clone.querySelector('product-card');
            if (productCard) {
              const overlay = productCard.querySelector('.pc__actions--overlay');
              if (overlay) {
                this.attachOverlayListeners(productCard, overlay);
              }
            }
          });

          // Update swiper
          const swiperElement = resultsDiv.closest('swiper-init');
          if (swiperElement && swiperElement.swiper && swiperElement.swiper.swiperElement) {
            const swiper = swiperElement.swiper.swiperElement;
            swiper.update();

            // Enable centeredSlides only on mobile when there's exactly one slide
            const isMobile = !responsive.matchesBreakpoint('lap-and-up');
            const hasOneSlide = swiper.slides.length === 1;
            swiper.params.centeredSlides = isMobile && hasOneSlide;
            swiper.update();

            swiper.slideTo(0, 0);
          }
          swiperWrapper.style.visibility = '';
        } else {
          // No fallback products configured
          swiperWrapper.style.visibility = '';
          console.warn('No products selected')
        }
      }

    } catch (error) {
      swiperWrapper.style.visibility = '';
      console.error('Error filtering products:', error);
    }
  }

  attachOverlayListeners(productCardElement, overlay) {
    // Attach the same event listener logic as ProductCard.mountActionsOverlay
    overlay.addEventListener(
      "click",
      (e) => {
        const atcBtn = e.target.closest("[data-action='add-to-cart']");
        if (atcBtn) {
          e.preventDefault();
          e.stopPropagation();

          // Get variant ID and quantity from the product card's hidden inputs
          const variantId = productCardElement.querySelector('input[name="id"]')?.value;
          const quantity = productCardElement.querySelector('input[name="quantity"]')?.value || 1;

          if (!variantId) {
            console.error('Could not find variant ID');
            return;
          }

          // Directly add to cart via fetch
          const pageLoader = document.body.querySelector(".pageLoader");
          if (pageLoader) pageLoader.style.width = "100%";

          atcBtn.setAttribute("disabled", "disabled");

          fetch(window.routes.localeRootUrl + "/cart/add.js", {
            body: JSON.stringify({ id: parseInt(variantId), quantity: parseInt(quantity) }),
            credentials: "same-origin",
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Requested-With": "XMLHttpRequest",
            },
          }).then((response) => {
            if (response.ok) {
              if (window.theme.cartMode === 'page') {
                location.href = window.routes.cart_page_url;
                return;
              }
              if (window.location.href.indexOf("cart") != -1) {
                location.reload();
                return;
              }
              atcBtn.removeAttribute("disabled");
              productCardElement.dispatchEvent(
                new CustomEvent("product:added", {
                  bubbles: true,
                  detail: {
                    variant: variantId,
                    quantity: quantity,
                  },
                })
              );
            } else {
              response.json().then((content) => {
                atcBtn.removeAttribute("disabled");
                console.error('Add to cart error:', content.description);
                // Reset loader
                if (pageLoader) {
                  pageLoader.style.left = "unset";
                  pageLoader.style.right = "0px";
                  pageLoader.style.width = "0%";
                  setTimeout(() => {
                    pageLoader.style.left = "0px";
                    pageLoader.style.right = "unset";
                  }, 550);
                }
              });
            }
          });
          return;
        }

        const learnMoreLink = e.target.closest("a");
        if (learnMoreLink) {
          e.stopPropagation();
          return;
        }

        e.preventDefault();
        e.stopPropagation();
      },
      true
    );
  }

  goToPreviousStep() {
    if (this.swiperElement && this.swiperElement.swiper && this.swiperElement.swiper.swiperElement) {
      const swiper = this.swiperElement.swiper.swiperElement;
      const prevIndex = swiper.activeIndex - 1;
      if (prevIndex >= 0) {
        swiper.slideTo(prevIndex);
      }
    }
  }

  refreshSelection() {
    // Clear results swiper content immediately
    const resultsWrapper = this.element.querySelector('.ps-popup__results-wrapper');
    const swiperWrapper = resultsWrapper?.querySelector('.swiper-wrapper');
    if (swiperWrapper) {
      swiperWrapper.innerHTML = '';
    }

    if (resultsWrapper) {
      resultsWrapper.classList.remove('is-visible');
      resultsWrapper.style.display = 'none';
    }

    const contentWrapper = this.element.querySelector('.ps-popup__content-wrapper');
    if (contentWrapper) {
      contentWrapper.style.display = '';
      contentWrapper.style.opacity = '';
      contentWrapper.style.transition = '';
    }

    this.element.classList.remove('ps-wrapper--results');
    this.setFallbackMode(false);

    // Clear all selected options
    const allOptionButtons = this.element.querySelectorAll('.ps-step__option-button[selected]');
    allOptionButtons.forEach(button => {
      button.removeAttribute('selected');
      button.classList.remove('is-active');
      button.setAttribute('aria-pressed', 'false');
    });

    // Reset all next buttons to disabled state
    const slides = this.element.querySelectorAll('.swiper-slide');
    slides.forEach(slide => {
      this.updateNextButtonState(slide);
    });

    // Go to first step
    if (this.swiperElement && this.swiperElement.swiper && this.swiperElement.swiper.swiperElement) {
      const swiper = this.swiperElement.swiper.swiperElement;
      swiper.slideTo(0);
    }

    // Update step slider to show first step as active and clear completed states
    const stepCounts = this.element.querySelectorAll('.ps-step__step-count');
    stepCounts.forEach((stepCount, index) => {
      stepCount.classList.remove('is-completed');
      if (index === 0) {
        stepCount.classList.add('is-active');
      } else {
        stepCount.classList.remove('is-active');
      }
    });

    // Show first link wrapper
    const linkWrappers = this.element.querySelectorAll('.ps-step__link-wrapper .step-link__wrapper');
    linkWrappers.forEach((link, index) => {
      if (index === 0) {
        link.classList.remove('is-hidden');
      } else {
        link.classList.add('is-hidden');
      }
    });
  }
  
  setFallbackMode(isFallback) {
    this.element.classList.toggle("using-fallback-products", isFallback);
  }
}

customElements.define("product-selector-popup", ProductSelectorPopup);

class FooterComponent extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);

    this.successText = this.element.querySelector('.footer__success-text');
    this.inputsWrapper = this.element.querySelector('.newsletter__inputs');

    // give this footer instance a stable unique id for scoping selectors
    if (!this.element.id) {
      this.element.id = `footer-newsletter-${Math.random().toString(36).slice(2)}`;
    }

    this.initNewsletterHandler();
    this.bindEvents();
  }

  connectedCallback() {
    this.initFormValidation();

    // Bind submit after the form exists in DOM
    const formEl = this.element.querySelector('.newsletter__form');
    if (formEl) {
      formEl.addEventListener('submit', this.onSubmit.bind(this));
    }

    // Use ResizeObserver instead of polling offsetHeight on every window resize
    if (typeof ResizeObserver !== 'undefined') {
      this._footerResizeObserver = new ResizeObserver(() => {
        requestAnimationFrame(() => this.updateFooterHeight());
      });
      this._footerResizeObserver.observe(this);
    } else {
      this.updateFooterHeight();
      responsive.addResizeListener(this, this.updateFooterHeight);
    }
    window.addEventListener('load', () => requestAnimationFrame(() => this.updateFooterHeight()));

    // ensure initial state
    if (this.validator) this.validator.updateButtonState();
  }

  initNewsletterHandler() {
    const settings = this.getNewsletterSettings();

    if (settings.listId && settings.publicApiKey) {
      this.newsletterHandler = new NewsletterHandler({
        listId: settings.listId,
        publicKey: settings.publicApiKey,
        onSuccess: () => this.showSuccessMessage(),
        onError: (error) => {
          console.error('Footer newsletter error:', error);
        }
      });
    } else {
      this.newsletterHandler = null;
    }
  }

  getNewsletterSettings() {
    const wrapper = this.element.querySelector('.newsletter__wrapper');
    if (wrapper && wrapper.dataset.settings) {
      return JSON.parse(wrapper.dataset.settings);
    }
    return {};
  }

  initFormValidation() {
    const form = this.element.querySelector('form');
    if (!form) return;

    this.validator = new FormValidator(form, {
      errorClass: 'field--error',
      fieldSelector: '.newsletter__email-input-wrapper',
      buttonSelector: `#${this.element.id} .newsletter__subscribe-button`,
      validateOnBlur: true,
      validateOnInput: true,
      errorOutputSelector: `#${this.element.id} .newsletter__error-wrapper`,
      showErrorsOnSubmitOnly: false
    });
  }

  bindEvents() {
    this.delegateElement.on(
      'click',
      '[data-action="clear-input"]',
      this.clearInput.bind(this)
    );
  }

  updateFooterHeight = () => {
    const footerHeight = this.offsetHeight + "px";
    document.documentElement.style.setProperty("--footer-dynamic-height", footerHeight);
    document.documentElement.style.setProperty("--footer-height", footerHeight);
  };

  clearInput() {
    const emailInput = this.querySelector('.newsletter__email-input');
    const errorWrapper = this.querySelector('.newsletter__error-wrapper');
    const emailWrapper = this.querySelector('.newsletter__email-input-error-wrapper');

    if (emailInput) emailInput.value = '';
    if (errorWrapper) errorWrapper.innerHTML = '';
    if (emailWrapper) emailWrapper.classList.remove('alert');

    if (this.validator) {
      this.validator.clearErrors();
      this.validator.updateButtonState();
    }
  }

  async onSubmit(e) {
    if (!this.newsletterHandler) return;

    e.preventDefault();

    if (this.validator && !this.validator.showAllErrors()) return;

    const emailEl = this.element.querySelector('.newsletter__email-input');
    const email = emailEl ? emailEl.value.trim() : '';
    if (!email) return;

    const submitButton = this.element.querySelector(".newsletter__subscribe-button");
    if (submitButton) submitButton.setAttribute("disabled", true);

    try {
      await this.newsletterHandler.subscribe(email);
      this.showSuccessMessage();
    } catch (error) {
      // handled in handler
    } finally {
      if (submitButton) submitButton.removeAttribute("disabled");
    }
  }

  showSuccessMessage() {
    if (this.inputsWrapper) {
      const privacyText = this.element.querySelector(".newsletter__privacy-text");

      privacyText.style.display = "none";
      this.inputsWrapper.style.display = "none";
      this.successText.style.display = "block";
    }
  }
}

customElements.define("footer-component", FooterComponent);

class AccountHandler extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    // Drawer root & inner wrapper
    this.drawerEl = this.element.querySelector('#accountDrawer');
    this.wrapper = this.drawerEl?.querySelector('.Drawer--Wrapper');

    // If you still need your Drawer class, keep it:
    this.drawer = new Drawer(this.drawerEl);

    this.bindEvents();
  }

  connectedCallback() {
    this.initFormValidation();
    // If you have a default state set in markup, sync height on mount:
    if (responsive.matchesBreakpoint("lap_and_up")) {

      setTimeout(() => {
        requestAnimationFrame(() => {
          document.documentElement.classList.add('account-drawer-ready');
        });
      }, 800)

    }
  }

  bindEvents() {

    this.delegateBody.on("account-drawer:closed", this.resetToLoginTab.bind(this))

    this.delegateElement.on('click', '[data-action="toggle-tab"]', this.toggleTab.bind(this));
    this.delegateElement.on('click', '[data-action="submit-login"]', this.submitLogin.bind(this));
    this.delegateElement.on('click', '[data-action="submit-register"]', this.submitRegistration.bind(this));
    this.delegateElement.on('click', '[data-action="toggle-recovery"]', this.toggleRecovery.bind(this));
    this.delegateElement.on('click', '[data-action="submit-recovery"]', this.accountRecover.bind(this));

    this.delegateElement.on("keypress", '[data-action="submit-input-login"]', this.accountInputSubmit.bind(this));
    this.delegateElement.on("keypress", '[data-action="submit-input-reg"]', this.accountInputSubmitReg.bind(this));
    this.delegateElement.on("keypress", '[data-action="submit-input-forgot-pass"]', this.accountInputSubmitForgot.bind(this));
  }

  showError(errorElement, message) {
    if (!errorElement) return;

    // Clear any existing timeout for this element
    if (errorElement._hideTimeout) {
      clearTimeout(errorElement._hideTimeout);
    }

    // Set the error message and show it
    errorElement.innerHTML = message;
    errorElement.classList.add('is-visible');

    // Auto-hide after 2 seconds
    errorElement._hideTimeout = setTimeout(() => {
      errorElement.classList.remove('is-visible');
      errorElement._hideTimeout = null;
    }, 2000);
  }

  resetToLoginTab() {

    setTimeout(() => {
      this.element.querySelector('#recover')?.setAttribute('aria-visible', 'false');
      this.element.querySelector('#loginFlex')?.setAttribute('aria-visible', 'true');
    }, 800)

  }

  initFormValidation() {
    const forms = {
      login: { el: "#login_popup", button: ".btn-drawer-log-in", error: ".input-validation" },
      register: { el: "#register_popup", button: ".btn-drawer-register", error: ".input-validation" },
      forgotten_password: { el: "#recover-popup", button: ".btn-drawer-recover", error: ".input-validation" },
    };

    for (const [key, { el, button, error }] of Object.entries(forms)) {
      const form = this.querySelector(el);
      if (!form) continue;

      this[`${key}Validator`] = new FormValidator(form, {
        errorClass: "field--error",
        fieldSelector: ".field",
        buttonSelector: button,
        fieldErrorSelector: error,
        validateOnBlur: true,
        validateOnInput: false,
        showErrorsOnSubmitOnly: false
      });
    }
  }

  accountInputSubmit(e) { if (e.key === "Enter") this.submitLogin(e); }
  accountInputSubmitReg(e) { if (e.key === "Enter") this.submitRegistration(e); }
  accountInputSubmitForgot(e) { if (e.key === "Enter") { e.preventDefault(); this.accountRecover(e); } }

  toggleRecovery(event) {
    event.preventDefault();
    const id = event.target.dataset.id;
    const newTitle = event.target.dataset.title || '';
    const newSubtitle = event.target.dataset.subtitle || '';

    this.setDrawerTitle(newTitle);
    this.setDrawerSubtitle(newSubtitle);

    if (id === 'recover') {
      this.element.querySelector('#recover')?.setAttribute('aria-visible', 'true');
      this.element.querySelector('#login')?.setAttribute('aria-visible', 'false');
      // Update auth switch to show recover view
      this.updateAuthSwitch('recover');
    } else {
      this.element.querySelector('#recover')?.setAttribute('aria-visible', 'false');
      this.element.querySelector('#login')?.setAttribute('aria-visible', 'true');
      // Update auth switch to show login view
      this.updateAuthSwitch('login');
    }
  }

  async accountRecover(event) {
    event.preventDefault();
    const recoverEndpoint = "/account/recover";
    const requestBody = {
      email: this.element.querySelector("#RecoverEmail").value,
    };

    if (window.hcaptcha) {
      const captchaToken = await window.hcaptcha.execute(null, { async: true });
      requestBody["h-captcha-response"] = captchaToken.response;
    }

    // Find the recovery button from the form container instead of event target
    const recoveryButton = this.element.querySelector('[data-action="submit-recovery"]');
    const buttonText = recoveryButton ? recoveryButton.querySelector(".ButtonText") : null;
    const loader = recoveryButton ? recoveryButton.querySelector(".itemLoader") : null;

    if (buttonText) buttonText.style.visibility = "hidden";
    if (loader) loader.classList.add("is-visible");

    try {
      const response = await fetch(recoverEndpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestBody),
      });

      const responseText = await response.text();
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = responseText;

      const recoverError = this.element.querySelector("#recover .accountDrawer--ErrorSpace");
      const recoverSuccess = this.element.querySelector("#recover .accountDrawer--SuccessSpace");
      if (responseText.includes("account__recover-email-error")) {
        recoverSuccess.classList.remove("is-visible");
        recoverError.innerHTML = "";
        recoverError.innerHTML = tempDiv.querySelector("#account__recover-email-error").innerHTML;
        recoverError.classList.add("is-visible");
      } else if (responseText.includes("account__form-success-msg")) {
        recoverError.classList.remove("is-visible");

        recoverSuccess.innerHTML = "";
        recoverSuccess.innerHTML = tempDiv.querySelector("#account__form-success-msg").innerHTML;
        recoverSuccess.classList.add("is-visible");

      }

      if (buttonText) buttonText.style.visibility = "visible";
      if (loader) loader.classList.remove("is-visible");
    } catch (error) {
      // Error during recovery request
    }
  }

  async submitRegistration(event) {
    event.preventDefault();

    const registrationEndpoint = `${window.routes.localeRootUrl}/account`;

    const emailInput = this.element.querySelector("#RegisterForm-email");
    const passwordInput = this.element.querySelector("#RegisterForm-password");

    const errorContainer = this.element.querySelector(
      "#register .accountDrawer--ErrorSpace"
    );

    const requestBody = {
      customer: {
        first_name: this.element.querySelector("#RegisterForm-FirstName").value,
        last_name: this.element.querySelector("#RegisterForm-LastName").value,
        email: emailInput.value,
        password: passwordInput.value,
      },
    };

    if (window.hcaptcha) {
      const captchaToken = await window.hcaptcha.execute(null, { async: true });
      requestBody["h-captcha-response"] = captchaToken.response;
    }

    const loader = event.target.closest("form").querySelector(".itemLoader");
    loader.classList.add("is-visible");

    errorContainer.innerHTML = "";
    errorContainer.style.display = "none";
    emailInput.closest(".field").classList.remove("input--error");
    passwordInput.closest(".field").classList.remove("input--error");

    try {
      const response = await fetch(registrationEndpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestBody),
      });

      const finalPath = new URL(response.url, window.location.origin).pathname.replace(/\/+$/, "");
      const stayedOnRegister = finalPath === "/account/register";

      if (stayedOnRegister) {
        errorContainer.style.display = "block";
        errorContainer.innerHTML =
          `${window.languages.account_already_exists}`;

        emailInput.closest(".field").classList.add("input--error");
        emailInput.setAttribute("aria-invalid", "true");

        return;
      }

      location.href = window.routes.account_url;

    } catch (error) {
      console.error("Registration error:", error);
      errorContainer.style.display = "block";
      errorContainer.innerHTML =
        "Something went wrong. Please try again later.";
    } finally {
      loader.classList.remove("is-visible");
    }
  }

  async submitLogin(event) {
    event.preventDefault();
    const loginEndpoint = `${window.routes.localeRootUrl}/account/login`;
    const requestBody = {
      customer: {
        email: this.element.querySelector("#CustomerEmail").value,
        password: this.element.querySelector("#CustomerPassword").value,
      },
    };

    if (window.hcaptcha) {
      const captchaToken = await window.hcaptcha.execute(null, { async: true });
      requestBody["h-captcha-response"] = captchaToken.response;
    }

    const loginButton = this.element.querySelector('[data-action="submit-login"]');
    const buttonText = loginButton ? loginButton.querySelector(".ButtonText") : null;
    const loader = loginButton ? loginButton.querySelector(".itemLoader") : null;
    buttonText.style.visibility = "hidden";
    loader.classList.add("is-visible");

    try {
      const response = await fetch(loginEndpoint, {
        method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(requestBody),
      });

      const responseText = await response.text();

      if (responseText.includes("loginError")) {
        const loginError = this.element.querySelector("#login .accountDrawer--ErrorSpace");
        loginError.innerHTML = "";
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = responseText;
        loginError.innerHTML = tempDiv.querySelector(".AlertError").innerHTML;
        loginError.classList.add("is-visible");

        const fieldErr = loginError.closest('.field');
        if (fieldErr) fieldErr.classList.add('input--error');
      } else {
        location.href = window.routes.account_url;
      }
    } catch (error) {
      console.error("Login error:", error);
    } finally {
      buttonText.style.visibility = "visible";
      loader.classList.remove("is-visible");
    }
  }

  // Title and subtitle setters
  setDrawerTitle(title) {
    const titleElement = this.element.querySelector('.acc-drawer__title');
    if (titleElement && title) titleElement.textContent = title;
  }

  setDrawerSubtitle(subtitle) {
    const subtitleElement = this.element.querySelector('.acc-drawer__subtitle');
    if (subtitleElement && subtitle) subtitleElement.textContent = subtitle;
  }

  toggleTab(event) {
    const id = event.target.dataset.id;
    const titleToSet = event.target.dataset.title;
    const subtitleToSet = event.target.dataset.subtitle;

    this.setDrawerTitle(titleToSet);
    this.setDrawerSubtitle(subtitleToSet);

    const allTabs = this.element.querySelectorAll('.acc-drawer__tab[aria-expanded="true"]');
    const allContent = this.element.querySelectorAll('.accountContent');

    allTabs.forEach((tab) => tab.setAttribute('aria-expanded', 'false'));
    event.target.setAttribute('aria-expanded', 'true');
    allContent.forEach((c) => c.setAttribute('aria-visible', 'false'));

    const content = this.element.querySelector(`#${id}`);
    if (content) content.setAttribute('aria-visible', 'true');

    // Update auth switch
    this.updateAuthSwitch(id);
  }

  updateAuthSwitch(activeView) {
    const switchOptions = this.element.querySelectorAll('[data-switch-view]');
    switchOptions.forEach((option) => {
      const viewType = option.dataset.switchView;
      option.style.display = viewType === activeView ? 'flex' : 'none';
    });
  }
}

customElements.define("account-handler", AccountHandler);

// SwiperInit class with working horizontal content-fade (main + optional thumbs)
class SwiperInit extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.swiper = null; // RevolutionSwiper instance
    this.initializationMode = this.getInitializationMode();
    this.intersectionObserver = null;

    this.isDynamic = this.element.hasAttribute('data-swiper-dynamic');
    this.isDynamicOnce = this.element.hasAttribute('data-swiper-dynamic-once');

    this.isHorizontalFadeDesktop = this.element.hasAttribute('data-swiper-fade-horizontal-desktop');
    this.isHorizontalFadeMobile = this.element.hasAttribute('data-swiper-fade-horizontal-mobile');
    this.isHorizontalFade = this.element.hasAttribute('data-swiper-fade-horizontal');

    this.hasBeenInitialized = false;

    this.handleBreakpointChange = this.handleBreakpointChange.bind(this);
    this.handleIntersection = this.handleIntersection.bind(this);

    // keep refs so we can detach listeners on destroy()
    this._fadeHandlers = {
      main: null,
      thumb: null
    };
  }

  getInitializationMode() {
    if (this.element.hasAttribute('data-swiper-mobile')) return 'mobile';
    if (this.element.hasAttribute('data-swiper-desktop')) return 'desktop';
    if (this.element.hasAttribute('data-swiper-tablet')) return 'tablet';
    return 'universal';
  }

  connectedCallback() {
    document.addEventListener('breakpoint:changed', this.handleBreakpointChange);

    if (this.isDynamic || this.isDynamicOnce) {
      this.setupIntersectionObserver();
    } else {
      if (!this.element.hasAttribute('data-swiper-manual')) {
        this.initSwiper();
      }
    }
  }

  disconnectedCallback() {
    document.removeEventListener('breakpoint:changed', this.handleBreakpointChange);
    this.cleanupIntersectionObserver();
    this.destroy();
  }

  setupIntersectionObserver() {
    const threshold = parseFloat(this.element.getAttribute('data-swiper-dynamic-threshold')) || 0.1;
    const rootMargin = this.element.getAttribute('data-swiper-dynamic-margin') || '50px';

    this.intersectionObserver = new IntersectionObserver(this.handleIntersection, {
      threshold,
      rootMargin
    });

    this.intersectionObserver.observe(this.element);
  }

  cleanupIntersectionObserver() {
    if (!this.intersectionObserver) return;
    this.intersectionObserver.disconnect();
    this.intersectionObserver = null;
  }

  handleIntersection(entries) {
    for (const entry of entries) {
      if (entry.target !== this.element) continue;

      if (entry.isIntersecting) {
        if (this.shouldInitialize() && !this.swiper) {
          this.initSwiper();
        }
      } else {
        if (this.isDynamic && this.swiper) {
          this.destroy();
        }
      }
    }
  }

  handleBreakpointChange(event) {
    const { currentBreakpoint } = event.detail;

    const shouldBeActive = this.shouldInitialize(currentBreakpoint);
    const currentlyActive = !!this.swiper;

    if (this.isDynamic || this.isDynamicOnce) {
      if (!shouldBeActive && currentlyActive) this.destroy();
      return;
    }

    if (shouldBeActive && !currentlyActive) {
      this.initSwiper();
    } else if (!shouldBeActive && currentlyActive) {
      this.destroy();
    } else if (shouldBeActive && currentlyActive) {
      this.initSwiper();
    }
  }

  shouldInitialize(breakpoint = null) {
    const currentBreakpoint = breakpoint || responsive.getCurrentBreakpoint();

    switch (this.initializationMode) {
      case 'mobile':
        return ['phone', 'pocket'].includes(currentBreakpoint);
      case 'desktop':
        return ['desktop', 'lap_and_up', 'desktop_wide'].includes(currentBreakpoint);
      case 'tablet':
        return ['tablet', 'tablet_and_up'].includes(currentBreakpoint);
      case 'universal':
      default:
        return true;
    }
  }

  initSwiper() {
    if (!this.shouldInitialize()) return;

    this.destroy();

    try {
      const thumbSelector = this.element.getAttribute('data-swiper-thumb');
      const thumbElement = thumbSelector ? document.querySelector(thumbSelector) : null;

      // Create your wrapper (must create the Swiper(s) internally)
      this.swiper = new RevolutionSwiper(this.element, thumbElement);

      if (this.isDynamicOnce) this.hasBeenInitialized = true;

      // IMPORTANT: call main fade with NO argument (argument means thumb-mode)
      const bp = responsive.getCurrentBreakpoint();

      if (this.isHorizontalFade) this.initHorizontalFadeOnSwiper();
      if (this.isHorizontalFadeDesktop && responsive.matchesBreakpoint('lap_and_up')) this.initHorizontalFadeOnSwiper();
      if (this.isHorizontalFadeMobile && (bp === 'phone' || bp === 'pocket')) this.initHorizontalFadeOnSwiper();

      // Optional: thumb fade – enable when thumb element has attribute
      if (thumbElement && thumbElement.hasAttribute('data-swiper-fade-horizontal')) {
        this.initHorizontalFadeOnSwiper(thumbElement);
      }
      if (thumbElement && thumbElement.hasAttribute('data-swiper-fade-horizontal-desktop') && responsive.matchesBreakpoint('lap_and_up')) {
        this.initHorizontalFadeOnSwiper(thumbElement);
      }
      if (thumbElement && thumbElement.hasAttribute('data-swiper-fade-horizontal-mobile') && (bp === 'phone' || bp === 'pocket')) {
        this.initHorizontalFadeOnSwiper(thumbElement);
      }

      this.element.dispatchEvent(
        new CustomEvent('swiper:initialized', {
          bubbles: true,
          detail: {
            breakpoint: responsive.getCurrentBreakpoint(),
            mode: this.initializationMode,
            isDynamic: this.isDynamic,
            isDynamicOnce: this.isDynamicOnce,
            swiper: this.swiper
          }
        })
      );
    } catch (error) {
      console.error('SwiperInit: Failed to initialize swiper', error);
    }
  }

  destroy() {
    this._teardownFade('main');
    this._teardownFade('thumb');

    if (this.swiper && this.swiper.swiperElement) {
      // If swiperElement is Swiper instance, it has destroy(). If it's a DOM element, it won't.
      // You said this works in your project, so keeping your destroy call:
      this.swiper.swiperElement.destroy(true, true);
      this.swiper = null;

      this.element.dispatchEvent(
        new CustomEvent('swiper:destroyed', {
          bubbles: true,
          detail: {
            breakpoint: responsive.getCurrentBreakpoint(),
            mode: this.initializationMode,
            isDynamic: this.isDynamic,
            isDynamicOnce: this.isDynamicOnce
          }
        })
      );
    }
  }

  // --------- CONTENT FADE (HORIZONTAL) ---------

  // Resolves the actual Swiper instance from RevolutionSwiper wrapper
  _resolveSwiperInstanceFor(targetElement = null) {
    // Thumb mode
    if (targetElement) {
      const wrapper = this.getSwiper();
      return wrapper?.thumbSwiper || targetElement?.swiper || null;
    }

    // Main mode - get from wrapper
    const wrapper = this.getSwiper();
    if (!wrapper) return null;

    return wrapper.swiper || wrapper.swiperElement || this.element.swiper || null;
  }

  initHorizontalFadeOnSwiper(targetElement = null) {
    const isThumbSwiper = !!targetElement;

    const swiperInstance = this._resolveSwiperInstanceFor(targetElement);
    if (!swiperInstance) return;

    const fadeContainer = isThumbSwiper ? this._getThumbFadeContainer(targetElement) : this._getMainFadeContainer();
    if (!fadeContainer) return;

    const update = () => this.updateHorizontalFadeClasses(swiperInstance, fadeContainer);

    // initial set (after layout)
    update();
    requestAnimationFrame(update);
    setTimeout(update, 0);

    // attach listeners and store for teardown
    const events = ['slideChange', 'resize'];
    const handlers = events.map((evt) => {
      const fn = () => update();
      swiperInstance.on(evt, fn);
      return [evt, fn];
    });

    // optional: window resize to be safe (main only)
    const onWinResize = () => update();
    if (!isThumbSwiper) window.addEventListener('resize', onWinResize);

    this._fadeHandlers[isThumbSwiper ? 'thumb' : 'main'] = {
      swiperInstance,
      fadeContainer,
      handlers,
      onWinResize: isThumbSwiper ? null : onWinResize
    };
  }

  _teardownFade(which) {
    const entry = this._fadeHandlers[which];
    if (!entry) return;

    const { swiperInstance, handlers, onWinResize, fadeContainer } = entry;

    // detach swiper listeners
    if (swiperInstance && typeof swiperInstance.off === 'function') {
      for (const [evt, fn] of handlers) swiperInstance.off(evt, fn);
    }

    if (onWinResize) window.removeEventListener('resize', onWinResize);

    // remove classes
    if (fadeContainer?.classList) {
      fadeContainer.classList.remove('content-fade', 'fade-left', 'fade-right', 'fade-both-horizontal');
    }

    this._fadeHandlers[which] = null;
  }

  _getMainFadeContainer() {
    this.element.classList.add('content-fade');
    return this.element;
  }

  _getThumbFadeContainer(targetElement) {
    // If a parent already has content-fade, prefer that so you can wrap with padding/margins
    let fadeContainer = targetElement.closest('.content-fade');
    if (!fadeContainer) {
      targetElement.classList.add('content-fade');
      fadeContainer = targetElement;
    }
    return fadeContainer;
  }

  updateHorizontalFadeClasses(swiperInstance, fadeContainer) {
    const c = fadeContainer.classList;
    c.remove('fade-left', 'fade-right', 'fade-both-horizontal');

    const atStart = !!swiperInstance.isBeginning;
    const atEnd = !!swiperInstance.isEnd;

    if (!atStart && !atEnd) {
      c.add('fade-both-horizontal');
    } else if (!atStart) {
      c.add('fade-left');
    } else if (!atEnd) {
      c.add('fade-right');
    }
  }

  // --------- PUBLIC API ---------

  selectSlide(index) {
    if (this.swiper && this.swiper.selectCell) {
      this.swiper.selectCell(index);
    } else {
      this.element.addEventListener(
        'swiper:initialized',
        () => {
          if (this.swiper && this.swiper.selectCell) this.swiper.selectCell(index);
        },
        { once: true }
      );
    }
  }

  resize() {
    if (this.swiper) this.swiper.resize();
  }

  getSwiper() {
    return this.swiper;
  }

  getCurrentBreakpoint() {
    return responsive.getCurrentBreakpoint();
  }

  reinitialize() {
    this.initSwiper();
  }

  isDynamicSwiper() {
    return this.isDynamic || this.isDynamicOnce;
  }

  getDynamicMode() {
    if (this.isDynamic) return 'dynamic';
    if (this.isDynamicOnce) return 'dynamic-once';
    return 'static';
  }

  static initializeAll() {
    document.querySelectorAll('swiper-init').forEach((element) => {
      element.initSwiper();
    });
  }
}

customElements.define('swiper-init', SwiperInit);

class AnimatedAnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    const self = this;
    this.delegateElement = new Delegate(this.element);
    this.options = JSON.parse(this.getAttribute("data-settings"));
    this.announcementBar = document.querySelector(".announcementBar");
    if (this.options.sticky === true && this.parentElement) {
      this.parentElement.classList.add('announcement-bar--sticky');
    }

    this.transitionSpeed = this.element.getAttribute('data-settings');
    this.firstLoad = true;
    this.prevOffset = window.scrollY || 0;
    this.topGuardPx = 12;

    this.bindEvents();
  }

  connectedCallback() {
    requestAnimationFrame(() => {
      // Batch read + write
      const height = this.element.offsetHeight;
      const rect = this.element.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      let visibleHeight = Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);
      visibleHeight = Math.max(visibleHeight, 0);

      document.documentElement.style.setProperty("--announcement-height-fixed", height + "px");
      document.documentElement.style.setProperty("--announcement-dynamic-height", `${visibleHeight}px`);
      // Re-sync so scroll restoration doesn't look like "scrolling down"
      this.prevOffset = window.scrollY || 0;
    });
  }

  bindEvents() {
    this._debouncedUpdateVisibleHeight = () => {
      if (this._rafUpdateVisible) return;
      this._rafUpdateVisible = requestAnimationFrame(() => {
        this._rafUpdateVisible = null;
        this.updateVisibleHeight();
      });
    };
    window.addEventListener("scroll", this._debouncedUpdateVisibleHeight, { passive: true });
    window.addEventListener("resize", this._debouncedUpdateVisibleHeight);

    // The bar slides via a CSS transform transition. Scroll-driven reads stop firing
    // once scrolling stops, but the transition keeps animating for up to 0.3s, leaving
    // a stale mid-slide value. Re-sync the final value when the transform transition
    // actually finishes so the height always settles correctly.
    this._onAnnTransitionEnd = (e) => {
      if (e.target === this.element && e.propertyName === "transform") {
        this.updateVisibleHeight();
      }
    };
    this.element.addEventListener("transitionend", this._onAnnTransitionEnd);

    this.toggleAnnouncementBarListener = this.toggleAnnouncementBar.bind(this);
    window.addEventListener("scroll", this.toggleAnnouncementBarListener, { passive: true });

    if (this.element.dataset.main == 'true') {
      scrollListener.addScrollListener(this, this._debouncedUpdateVisibleHeight);
      responsive.addResizeListener(this, this._debouncedUpdateVisibleHeight);
    }
  }

  updateVisibleHeight() {
    // Batch read then write — no setTimeout delay
    let visibleHeight;
    if (this.element.classList.contains("is-hidden")) {
      // Bar is (being) hidden — its target visible height is 0. Don't read the
      // mid-transition transform via getBoundingClientRect(), which yields stale
      // intermediate values when scrolling fast and fights toggleAnnouncementBar's 0 write.
      visibleHeight = 0;
    } else {
      const rect = this.element.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      visibleHeight = Math.max(Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0), 0);
    }

    document.documentElement.style.setProperty("--announcement-dynamic-height", `${visibleHeight}px`);
  }

  toggleAnnouncementBar() {
    const current = window.scrollY;

    if (current <= this.topGuardPx) {
      this.element.classList.remove('is-hidden');
      this.updateVisibleHeight();
      this.prevOffset = current;
      return;
    }

    if (current > this.prevOffset) {
      this.element.classList.add('is-hidden');
      document.documentElement.style.setProperty("--announcement-dynamic-height", `0px`);
    } else {
      this.element.classList.remove('is-hidden');
      this.updateVisibleHeight();
    }

    this.prevOffset = current;
  }
}

customElements.define("announcement-bar", AnimatedAnnouncementBar);


class ProductCard extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    // cached nodes
    this.wrapperLink = null;
    this.productTitle = null;
    this.priceWrapper = null;
    this.swiperWrapper = null;
    this.swiperElement = null;
    this.spinningLoader = null;
  }

  connectedCallback() {
    this.cacheElements();
    this.mountActionsOverlay();
    this.bindCardClickNavigation();
    this.bindEvents();
    // Cards inserted after load (filters, infinite scroll, search, recommendations)
    // still carry their video src in data-src. Cards present at load run before the
    // helper exists and are covered by its own startup call.
    if (window.hydrateDeferredCardMedia) window.hydrateDeferredCardMedia(this);
  }

  cacheElements() {
    this.wrapperLink = this.element.querySelector('.pc__wrapper-link');
    this.productTitle = this.element.querySelector('.pc__information__title');
    this.priceWrapper = this.element.querySelector('.pc__price-wrapper');

    this.swiperElement = this.element.querySelector('.pc__image__swiper');
    this.swiperWrapper = this.element.querySelector('.swiper-wrapper');

    this.spinningLoader = this.element.querySelector('.spinningLoader');
    this.desktopActions = this.element.querySelector(
      ".pc__actions.not_mobile.not_pocket"
    );
  }

  mountActionsOverlay() {
    const cardProduct = this.element.querySelector(".card-product");
    if (!cardProduct || !this.desktopActions) return;

    if (cardProduct.querySelector(".pc__actions--overlay")) return;

    const overlay = this.desktopActions.cloneNode(true);
    overlay.classList.add("pc__actions--overlay");

    overlay.addEventListener(
      "click",
      (e) => {
        const atcBtn = e.target.closest("[data-action='add-to-cart']");
        if (atcBtn) {
          e.preventDefault();
          e.stopPropagation();

          // Get variant ID and quantity from the product card's hidden inputs
          const variantId = this.element.querySelector('input[name="id"]')?.value;
          const quantity = this.element.querySelector('input[name="quantity"]')?.value || 1;

          if (!variantId) {
            console.error('Could not find variant ID');
            return;
          }

          // Directly add to cart via fetch
          const pageLoader = document.body.querySelector(".pageLoader");
          if (pageLoader) pageLoader.style.width = "100%";

          atcBtn.setAttribute("disabled", "disabled");

          fetch(window.routes.localeRootUrl + "/cart/add.js", {
            body: JSON.stringify({ id: parseInt(variantId), quantity: parseInt(quantity) }),
            credentials: "same-origin",
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Requested-With": "XMLHttpRequest",
            },
          }).then((response) => {
            if (response.ok) {
              if (window.theme.cartMode === 'page') {
                location.href = window.routes.cart_page_url;
                return;
              }
              if (window.location.href.indexOf("cart") != -1) {
                location.reload();
                return;
              }
              atcBtn.removeAttribute("disabled");
              this.element.dispatchEvent(
                new CustomEvent("product:added", {
                  bubbles: true,
                  detail: {
                    variant: variantId,
                    quantity: quantity,
                  },
                })
              );
            } else {
              response.json().then((content) => {
                atcBtn.removeAttribute("disabled");
                console.error('Add to cart error:', content.description);
                // Reset loader
                if (pageLoader) {
                  pageLoader.style.left = "unset";
                  pageLoader.style.right = "0px";
                  pageLoader.style.width = "0%";
                  setTimeout(() => {
                    pageLoader.style.left = "0px";
                    pageLoader.style.right = "unset";
                  }, 550);
                }
              });
            }
          });
          return;
        }

        const learnMoreLink = e.target.closest("a");
        if (learnMoreLink) {
          e.stopPropagation();
          return;
        }

        e.preventDefault();
        e.stopPropagation();
      },
      true
    );

    cardProduct.appendChild(overlay);
    this.desktopActions.classList.add("pc__actions--hidden-original");

    this.actionsOverlay = overlay;
  }

  bindEvents() {

  }

  async fetchProductData(productUrl) {
    const handle = productUrl.split('/products/')[1].split('?')[0];
    const response = await fetch(`/products/${handle}.js`);
    if (!response.ok) throw new Error(`HTTP ${response.status}`);

    const product = await response.json();
    const moneyFormat = window.theme?.moneyFormat;

    return {
      ...product,
      url: `/products/${product.handle}`,
      images: product.images.map(img => ({
        src: `https:${img}`,
        alt: product.title,
        srcset: `
          https:${img}?width=500 500w,
          https:${img}?width=1000 1000w,
          https:${img}?width=1500 1500w
        `
      })),
      variants: product.variants.map(v => ({
        ...v,
        formattedPrice: Shopify.formatMoney(v.price, moneyFormat),
        formattedCompareAt: v.compare_at_price
          ? Shopify.formatMoney(v.compare_at_price, moneyFormat)
          : null
      }))
    };
  }

  updateProductCard(productData) {
    const firstVariant = productData.variants?.[0];
    if (!firstVariant) return;

    // Title
    if (this.productTitle) {
      this.productTitle.textContent = productData.title || '';
    }

    // Link
    if (this.wrapperLink) {
      this.wrapperLink.href = productData.url;
    }

    this.element.querySelectorAll(".pc__instant-atc").forEach(btn => {
      btn.setAttribute("data-product-url", productData.url);
    });

    // Prices
    if (this.priceWrapper) {
      const regularPriceEl = this.priceWrapper.querySelector('.price-item--regular');
      const comparePriceEl = this.priceWrapper.querySelector('.price-compare s');
      const compareContainer = comparePriceEl?.closest('.price-compare');

      const hasSale =
        firstVariant.compare_at_price &&
        firstVariant.compare_at_price > firstVariant.price;

      if (regularPriceEl) {
        if (hasSale) {
          regularPriceEl.innerHTML = firstVariant.formattedPrice;
          regularPriceEl.classList.remove("regular-price-color");
        } else {
          regularPriceEl.innerHTML =
            `${window.productCardStrings?.starting_at || ''} ${firstVariant.formattedPrice}`.trim();
          regularPriceEl.classList.add("regular-price-color");
        }
      }

      if (comparePriceEl && compareContainer) {
        if (hasSale) {
          compareContainer.classList.remove("VisuallyHidden");
          comparePriceEl.innerHTML = firstVariant.formattedCompareAt;
        } else {
          compareContainer.classList.add("VisuallyHidden");
          comparePriceEl.innerHTML = '';
        }
      }

      if (this.actionsOverlay) {
        this.actionsOverlay.querySelectorAll("[data-action='add-to-cart']").forEach(btn => {
          btn.setAttribute("data-product-url", productData.url);
        });
      }
    }

    // Swiper slides
    if (this.swiperWrapper && productData.images?.length) {
      const oldSlides = Array.from(this.swiperWrapper.querySelectorAll('.swiper-slide'));
      const oldButtons = oldSlides[0]
        ? Array.from(oldSlides[0].querySelectorAll('.swiperButton'))
        : [];

      this.swiperWrapper.innerHTML = '';

      productData.images.forEach((image) => {
        const slide = document.createElement('div');
        slide.classList.add('swiper-slide', 'AspectRatio');

        const img = document.createElement('img');
        img.classList.add('product-card__image');
        img.src = image.src;
        img.alt = image.alt || productData.title;
        img.srcset = image.srcset || '';
        slide.appendChild(img);

        oldButtons.forEach(btn => slide.appendChild(btn.cloneNode(true)));

        this.swiperWrapper.appendChild(slide);
      });

      this.swiperElement?.reinitialize?.();
    }
  }

  setLoadingState(isLoading) {
    if (!this.spinningLoader) return;
    this.spinningLoader.classList.toggle('is-visible', isLoading);
  }

  getProductUrl() {
    const url =
      this.element.querySelector("a[href*='/products/']")?.href ||
      this.element.querySelector(".pc__information__title")?.closest("a")?.href;

    return url || null;
  }

  bindCardClickNavigation() {
    if (this.__navBound) return;
    this.__navBound = true;

    let pointerDown = null;
    let didDrag = false;

    const isInteractive = (t) =>
      !!t.closest(
        "a,button,input,textarea,select,label,summary,details,[role='button'],[data-no-card-nav],.swiperButton"
      );

    this.element.addEventListener(
      "pointerdown",
      (e) => {
        if (e.target.closest(".pc__image__swiper")) {
          pointerDown = { x: e.clientX, y: e.clientY };
          didDrag = false;
        } else {
          pointerDown = null;
        }
      },
      { passive: true }
    );

    this.element.addEventListener(
      "pointermove",
      (e) => {
        if (!pointerDown) return;
        const dx = Math.abs(e.clientX - pointerDown.x);
        const dy = Math.abs(e.clientY - pointerDown.y);
        if (dx + dy > 8) didDrag = true;
      },
      { passive: true }
    );

    this.element.addEventListener(
      "pointerup",
      () => {
        pointerDown = null;
      },
      { passive: true }
    );

    this.element.addEventListener(
      "click",
      (e) => {
        if (isInteractive(e.target)) return;
        if (didDrag) return;

        const url = this.getProductUrl();
        if (!url) return;

        if (e.metaKey || e.ctrlKey || e.button === 1) {
          window.open(url, "_blank");
          return;
        }

        window.location.href = url;
      },
      true
    );
  }

}

customElements.define("product-card", ProductCard);


class BlogItemComponent extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.blogItem = this.querySelector(".blog-item.hover-animation");
    if (!this.blogItem) return;

    this.labelText = this.dataset.cursorLabel || "READ MORE";
    this.cursorLabel = null;

    this.initCursorLabel();
  }

  initCursorLabel() {
    const isMobile = responsive.matchesBreakpoint("pocket");
    if (isMobile) return;

    const label = document.createElement("div");
    label.className = "blog-item__cursor-label u-s1";
    label.textContent = this.labelText;
    document.body.appendChild(label);

    this.cursorLabel = label;

    this.blogItem.addEventListener("mouseenter", () => {
      this.cursorLabel.classList.add("is-visible");
    });

    this.blogItem.addEventListener("mouseleave", () => {
      this.cursorLabel.classList.remove("is-visible");
    });

    this.blogItem.addEventListener("mousemove", (event) => {
      if (!this.cursorLabel) return;

      this.cursorLabel.classList.add("is-visible");

      this.cursorLabel.style.left = event.clientX + 8 + "px";
      this.cursorLabel.style.top = event.clientY - 24 + "px";
    });
  }
}

customElements.define("blog-item-component", BlogItemComponent);

class ProductCache {
  constructor() {
    if (!ProductCache.instance) {
      this.cache = new Map(); // key: handle
      ProductCache.instance = this;
    }
    return ProductCache.instance;
  }

  addProducts(html) {
    const tempElement = document.createElement("div");
    tempElement.innerHTML = html;

    const allProducts = tempElement.querySelectorAll(
      ".favorite__item, .recent__item, product-card[data-handle]"
    );

    allProducts.forEach((product) => {
      product.classList.remove("recent__item");
      product.classList.add("favorites-item");
      product.classList.remove("swiper-slide");

      const handle =
        product.getAttribute("data-handle") ||
        product.querySelector("product-card")?.getAttribute("data-handle");

      if (!handle) return;

      const toggle = product.querySelector('[data-action="toggle-favorites"]');
      if (toggle && handle) {
        // Ensure toggle has data-handle attribute
        if (!toggle.getAttribute('data-handle')) {
          toggle.setAttribute('data-handle', handle);
        }

        const saved = JSON.parse(localStorage.getItem("productFavoritesHandles") || "[]");
        const active = saved.includes(handle);

        toggle.setAttribute("state", active ? "active" : "not-active");
        toggle.setAttribute("aria-pressed", active ? "true" : "false");
        toggle.setAttribute("aria-label", active
          ? window.a11yStrings?.removeFromFavorites || "Remove from favorites"
          : window.a11yStrings?.addToFavorites || "Add to favorites");

        // Toggle icon visibility for cached products
        const iconFilled = toggle.querySelector('.toggle-favorites__icon-filled');
        const iconEmpty = toggle.querySelector('.toggle-favorites__icon-empty');

        if (iconFilled && iconEmpty) {
          iconFilled.style.display = active ? 'flex' : 'none';
          iconEmpty.style.display = active ? 'none' : 'flex';
        }

        // Update label wrapper for icon switching (if exists)
        const labelWrapper = toggle.closest('.pm__favourites-label');
        if (labelWrapper) {
          labelWrapper.classList.toggle('is-active', active);
        }
      }

      if (handle && !this.cache.has(handle)) {
        this.cache.set(handle, product.cloneNode(true));
      }
    });

    this.dispatchCacheUpdated();
  }

  removeProduct(handle) {
    this.cache.delete(handle);
    this.dispatchCacheUpdated();
  }

  getProducts() {
    return Array.from(this.cache.values());
  }

  async loadFromStorage() {
    const handles = JSON.parse(localStorage.getItem("productFavoritesHandles") || "[]");
    if (handles.length === 0) {
      this.dispatchCacheUpdated();
      return;
    }

    try {
      const responses = await Promise.all(
        handles.map(async (handle) => {
          const r = await fetch(`${window.routes.localeRootUrl}/products/${handle}?view=favorite`);
          return r.text();
        })
      );
      responses.forEach((html) => this.addProducts(html));
    } catch (error) {
      console.error("❌ Error re-caching products:", error);
    }
  }

  dispatchCacheUpdated() {
    document.dispatchEvent(new CustomEvent("cache:updated", { detail: { cacheSize: this.cache.size } }));
  }
}

const favoritesCache = new ProductCache();

class FavoritesDrawer extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.cache = favoritesCache;
    this.open = false;
    this.suppressEmptyState = false;
  }

  async connectedCallback() {
    this.favPopulated = document.querySelectorAll(".header__favorites--populated") || [];
    this.contentElement = this.element.querySelector(".favorites__content");
    this.loader = this.element.querySelector(".spinningLoader");

    this.updateFavoritesAcrossSite();

    const favorites = this.getFavorites();
    if (favorites.length > 0) {
      await this.cache.loadFromStorage();
    }

    this.favoritesDrawer = new Drawer(this.element, {
      onOpen: () => {
        this.updateFavoritesAcrossSite();
        this.open = true;
      },

      onClose: () => {
        this.open = false;
      },
    });

    this.delegateBody = new Delegate(document.body);
    this.bindEvents();

    new AddToCart(this.element);

    this.element.addEventListener("product:added", (event) => {
      this.handleProductAdded(event);
    });

    document.addEventListener("update-favorites", () => {
      this.updateFavoritesAcrossSite();
    });

    this.handleStorage = (e) => {
      if (e.key === "productFavoritesHandles") {
        this.updateFavoritesAcrossSite();
        if (this.open) this.renderProducts();
      }
    };
    window.addEventListener("storage", this.handleStorage);

    if (favorites.length > 0) {
      this.renderProducts();
    }
  }

  disconnectedCallback() {
    if (this.handleStorage) window.removeEventListener("storage", this.handleStorage);
  }

  bindEvents() {
    if (this._eventsBound) return;
    this._eventsBound = true;

    // Capture clicks on the input itself, the label wrapper, or the icon spans
    // This ensures clicks in recommended slider (inside the favorites drawer) are handled too
    const favClickHandler = (e) => {
      if (e._favHandled) return; // avoid duplicate handling from delegation bubbling
      e._favHandled = true;

      // Prevent navigating the parent <a> and block other handlers
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      this.toggleFavorite(e);
    };

    this.delegateBody.on("click", '[data-action="toggle-favorites"], .pm__favourites-label, .pm__favourites__icon', favClickHandler);
    this.delegateBody.on("recommendations:loaded", this.updateFavoritesAcrossSite.bind(this));

  }

  async toggleFavorite(e) {
    e.preventDefault?.();

    let trigger = e.target?.closest?.('[data-action="toggle-favorites"]');
    if (!trigger) {
      const label = e.target?.closest?.('.pm__favourites-label');
      if (label) trigger = label.querySelector('[data-action="toggle-favorites"]');
    }
    if (!trigger) return;

    let handle = trigger.getAttribute("data-handle");

    // Fallback: extract handle from product URL if data-handle is missing
    if (!handle) {
      const productCard = trigger.closest('product-card');
      const wrapperLink = productCard?.querySelector('.cardProduct--Inner, .pc__wrapper-link');
      const productUrl = wrapperLink?.getAttribute('href');

      if (productUrl && productUrl.includes('/products/')) {
        handle = productUrl.split('/products/')[1].split('?')[0].split('#')[0];
        trigger.setAttribute('data-handle', handle);
      }
    }

    if (!handle) {
      console.error('❌ Cannot toggle favorite: product handle not found');
      return;
    }

    const favorites = this.getFavorites();
    const isFavorite = favorites.includes(handle);

    // ⚡ INSTANTLY update the UI for the clicked button (optimistic update)
    this.updateSingleButton(trigger, !isFavorite);

    if (isFavorite) {
      this.removeProduct(handle);
    } else {
      // Show loader only when going from 0 -> 1 favorites
      if (favorites.length === 0) {
        this.suppressEmptyState = true;
        if (this.open) this.showLoader();
      }
      await this.addProduct(handle, trigger);
      this.suppressEmptyState = false;
    }
  }

  showLoader() {
    // Koristi postojeći loader iz projekta
    if (this.loader) {
      this.contentElement.innerHTML = "";
      this.contentElement.classList.add("favorites-grid");

      this.loader.classList.add('is-visible'); // Dodaj is-visible klasu
    }
  }

  hideLoader() {
    if (this.loader) {

      this.loader.classList.remove('is-visible'); // Ukloni is-visible klasu
    }
  }

  async addProduct(handle, trigger = null) {
    let favorites = this.getFavorites();

    if (!favorites.includes(handle)) {
      favorites.unshift(handle);
      this.saveFavorites(favorites);

      const productName = trigger?.getAttribute('data-title') || '';

      const productHtml = await this.fetchProductHtml(handle);
      if (productHtml) {
        this.cache.addProducts(productHtml);
        this.hideLoader();
        this.renderProducts();

        const popupEl = document.querySelector("favorites-popup");

        if (popupEl) {
          document.dispatchEvent(new CustomEvent('favorite:added', {
            detail: { productName, handle }
          }));
        } else {
          if (this.favoritesDrawer && !this.open) {
            this.favoritesDrawer.openDrawer();
          }
        }
      }
    }
  }

  // ⚡ Instantly update button UI without waiting for network
  updateSingleButton(button, isActive) {
    button.setAttribute("state", isActive ? "active" : "not-active");
    button.setAttribute("aria-pressed", isActive ? "true" : "false");
    button.setAttribute("aria-label", isActive
        ? window.a11yStrings?.removeFromFavorites || "Remove from favorites"
        : window.a11yStrings?.addToFavorites || "Add to favorites");

    // Toggle icon visibility for instant visual feedback
    const iconFilled = button.querySelector('.toggle-favorites__icon-filled');
    const iconEmpty = button.querySelector('.toggle-favorites__icon-empty');

    if (iconFilled && iconEmpty) {
      iconFilled.style.display = isActive ? 'flex' : 'none';
      iconEmpty.style.display = isActive ? 'none' : 'flex';
    }

    // Update label wrapper for icon switching (if exists)
    const labelWrapper = button.closest('.pm__favourites-label');
    if (labelWrapper) {
      labelWrapper.classList.toggle('is-active', isActive);
    }
  }

  async fetchProductHtml(handle) {
    try {
      const url = `${window.routes.localeRootUrl}/products/${handle}?view=favorite`;
      const response = await fetch(url);

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      return await response.text();
    } catch (error) {
      console.error(`❌ Failed to fetch product "${handle}":`, error);
      // Remove from favorites if product doesn't exist
      if (error.message.includes('404')) {
        this.removeProduct(handle);
      }
      return null;
    }
  }

  async removeProduct(handle) {
    // Show loader during removal
    const itemLoader = this.element.querySelector('.itemLoader');
    if (itemLoader && this.open) {
      itemLoader.classList.add('is-visible');
    }

    // Small delay to ensure loader is visible
    await new Promise(resolve => setTimeout(resolve, 50));

    // Update data and re-render
    const favorites = this.getFavorites().filter((h) => h !== handle);
    this.saveFavorites(favorites);
    this.cache.removeProduct(handle);
    this.updateFavoritesAcrossSite();
    this.renderProducts();

    // Hide loader after render
    if (itemLoader) {
      // Wait a bit for render to complete
      requestAnimationFrame(() => {
        setTimeout(() => {
          itemLoader.classList.remove('is-visible');
        }, 100);
      });
    }
  }

  renderProducts() {
    if (!this.contentElement) return;

    const cachedProducts = this.cache.getProducts();
    const favoritesCount = this.getFavorites().length;

    if (favoritesCount > 0 || this.suppressEmptyState) {
      this.contentElement.innerHTML = "";
      this.contentElement.classList.add("favorites-grid");

      if (cachedProducts.length > 0) {
        this.hideLoader(); // Sakrij loader kad imamo proizvode
        cachedProducts.forEach((product) => {
          this.contentElement.appendChild(product.cloneNode(true));
        });
      } else {

        this.showLoader();
      }
      return;
    }

    // samo ako stvarno nema favorita — prikaži empty state
    this.contentElement.classList.remove("favorites-grid");
    this.contentElement.innerHTML = "";
    this.fetchAndRenderFavorites();
  }

  async fetchAndRenderFavorites() {
    try {
      const sectionId = this.element?.dataset?.sectionId;
      if (!sectionId) return;

      const root = (window.routes && window.routes.localeRootUrl) || "";
      const res = await fetch(`${root}/?sections=${encodeURIComponent(sectionId)}`);
      if (!res.ok) throw new Error(`sections fetch ${res.status}`);
      const json = await res.json();
      const html = json[sectionId];

      const temp = document.createElement("div");
      temp.innerHTML = html;
      const src = temp.querySelector(".favorites__content");
      if (src) {
        // Set the content from the fetched section - this handles empty state
        this.contentElement.innerHTML = src.innerHTML;
        // Ensure favorites-grid class is removed for empty state
        this.contentElement.classList.remove('favorites-grid');
      }
    } catch (error) {
      console.error("Error fetching main favorites section:", error);
    }
  }

  getFavorites() {
    try {
      return JSON.parse(localStorage.getItem("productFavoritesHandles") || "[]").filter(Boolean);
    } catch {
      return [];
    }
  }

  saveFavorites(handles) {
    try {
      const trimmedHandles = handles.slice(0, 50);
      localStorage.setItem("productFavoritesHandles", JSON.stringify(trimmedHandles));
      document.dispatchEvent(new CustomEvent("update-favorites"));
    } catch (error) {
      // Handle QuotaExceededError - storage is full
      if (error.name === 'QuotaExceededError') {
        console.warn('⚠️ localStorage quota exceeded, keeping only 20 most recent favorites');
        try {
          const trimmedHandles = handles.slice(0, 20);
          localStorage.setItem("productFavoritesHandles", JSON.stringify(trimmedHandles));
          document.dispatchEvent(new CustomEvent("update-favorites"));
        } catch (e) {
          console.error('❌ Cannot save favorites:', e);
        }
      } else {
        console.error('❌ Error saving favorites:', error);
      }
    }
  }

  updateFavoritesAcrossSite(scopeElement = null) {
    const handles = this.getFavorites();
    const handlesSet = new Set(handles); // O(1) lookup umesto O(n)
    const hasFavorites = handles.length > 0;
    const drawerEl = document.getElementById("favorites-drawer");
    if (drawerEl) {
      drawerEl.classList.toggle("has-favorites", hasFavorites);
    }

    // Update header indicators
    if (this.favPopulated) {
      Array.from(this.favPopulated).forEach((el) => {
        if (el) el.style.opacity = hasFavorites ? "1" : "0";
      });
    }

    // Update header favorites icons (mobile and desktop)
    this.updateHeaderFavoritesIcons(hasFavorites);

    // Scope search to specific element if provided (for dynamic content)
    const searchRoot = scopeElement || document;
    const favoritesButtons = searchRoot.querySelectorAll('[data-action="toggle-favorites"]');

    // Batch DOM updates using DocumentFragment for better performance
    favoritesButtons.forEach((btn) => {
      const handle = btn.getAttribute("data-handle");
      if (!handle) return;

      const active = handlesSet.has(handle); // O(1) umesto includes O(n)

      // Cache child elements
      const iconFilled = btn.querySelector('.toggle-favorites__icon-filled');
      const iconEmpty = btn.querySelector('.toggle-favorites__icon-empty');
      const labelWrapper = btn.closest('.pm__favourites-label');

      // Batch attribute updates
      btn.setAttribute("state", active ? "active" : "not-active");
      btn.setAttribute("aria-pressed", active ? "true" : "false");
      btn.setAttribute("aria-label", active
          ? window.a11yStrings?.removeFromFavorites || "Remove from favorites"
          : window.a11yStrings?.addToFavorites || "Add to favorites");

      // Toggle icon visibility - CSS now handles this via state attribute
      // But keep for backwards compatibility
      if (iconFilled && iconEmpty) {
        const displayValue = active ? 'flex' : 'none';
        const displayInverse = active ? 'none' : 'flex';

        // Only update if value changed (avoid unnecessary reflow)
        if (iconFilled.style.display !== displayValue) {
          iconFilled.style.display = displayValue;
          iconEmpty.style.display = displayInverse;
        }
      }

      // Update label wrapper
      if (labelWrapper) {
        labelWrapper.classList.toggle('is-active', active);
      }
    });

    // Update count indicators
    const countElements = document.querySelectorAll(".header__favorites-count");
    if (countElements.length) {
      const countText = "(" + handles.length + ")";
      countElements.forEach((el) => {
        if (el.textContent !== countText) {
          el.textContent = countText;
        }
      });
    }
  }

  updateHeaderFavoritesIcons(hasFavorites) {
    // Find all empty and filled spans - works for both mobile and desktop
    const emptySpans = document.querySelectorAll('.header__favorites--empty');
    const filledSpans = document.querySelectorAll('.header__favorites--populated');

    if (hasFavorites) {
      // Hide empty, show filled
      emptySpans.forEach(span => {
        span.style.setProperty('display', 'none', 'important');
        span.style.setProperty('opacity', '0', 'important');
      });
      filledSpans.forEach(span => {
        span.style.setProperty('display', 'flex', 'important');
        span.style.setProperty('opacity', '1', 'important');
      });
    } else {
      // Show empty, hide filled
      emptySpans.forEach(span => {
        span.style.setProperty('display', 'flex', 'important');
        span.style.setProperty('opacity', '1', 'important');
      });
      filledSpans.forEach(span => {
        span.style.setProperty('display', 'none', 'important');
        span.style.setProperty('opacity', '0', 'important');
      });
    }

  }

  renderFavoritesOnly() {
    if (!this.contentElement) return;
    const cachedProducts = this.cache.getProducts();

    // Only update the favorites grid content, not the entire section
    const existingGrid = this.contentElement.querySelector('.favorites-grid');
    if (existingGrid) {
      existingGrid.innerHTML = '';
      cachedProducts.forEach((product) => {
        existingGrid.appendChild(product.cloneNode(true));
      });
    } else {
      this.contentElement.innerHTML = "";
      this.contentElement.classList.add("favorites-grid");
      cachedProducts.forEach((product) => {
        this.contentElement.appendChild(product.cloneNode(true));
      });
    }
  }

  handleProductAdded(event) {
    if (this.favoritesDrawer) {
      if (typeof this.favoritesDrawer.closeDrawer === "function") {
        this.favoritesDrawer.closeDrawer();
      } else if (typeof this.favoritesDrawer.close === "function") {
        this.favoritesDrawer.close();
      }
    }

    this.open = false;

    const closeTrigger =
      this.element.querySelector("[data-drawer-close]") ||
      this.element.querySelector("[data-action='close-drawer']") ||
      this.element.querySelector(".Drawer__Close");

    if (closeTrigger) {
      closeTrigger.click();
    }
  }

}
customElements.define("favorites-drawer", FavoritesDrawer);

// ============================================
// FAVORITES POPUP - Show when product added
// ============================================
class FavoritesPopup extends HTMLElement {
  constructor() {
    super();
    this.popupElement = null;
    this.timeout = null;
    this.originalMessage = null;
  }

  connectedCallback() {
    this.popupElement = this.querySelector('.Popup');

    if (!this.popupElement) {
      return;
    }

    // Get delay in seconds and convert to milliseconds
    this.delay = parseInt(this.getAttribute('data-delay') || '2', 10) * 1000;

    // Listen for when a product is added to favorites
    document.addEventListener('favorite:added', (e) => {
      this.showPopup(e.detail?.productName);
    });

    // Listen for clicks on "View Favorites" button to close popup before opening drawer
    const viewFavoritesBtn = this.popupElement.querySelector('[data-toggle-id="favorites-drawer"]');
    if (viewFavoritesBtn) {
      viewFavoritesBtn.addEventListener('click', (e) => {
        // Close the popup immediately
        this.hidePopup();
      });
    }

    // Listen for close button clicks
    const closeButton = this.popupElement.querySelector('[data-action="toggle-popup"]');
    if (closeButton) {
      closeButton.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.hidePopup();
      });
    }

    // Close popup when any drawer or popup opens
    document.addEventListener('click', (e) => {
      const isDrawerToggle = e.target.closest('[data-action="toggle-drawer"]');
      const isPopupToggle = e.target.closest('[data-action="toggle-popup"]');

      // If opening any drawer or popup (except our own popup)
      if (isDrawerToggle || (isPopupToggle && !this.popupElement.contains(e.target))) {
        this.hidePopup();
      }
    });

    // Also listen for drawer open events
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'aria-expanded') {
          const target = mutation.target;
          // If any drawer/popup opens (except our own)
          if (target !== this.popupElement &&
            target.getAttribute('aria-expanded') === 'true' &&
            (target.classList.contains('Drawer--wrapper') || target.classList.contains('Popup'))) {
            this.hidePopup();
          }
        }
      });
    });

    // Observe all drawers and popups
    document.querySelectorAll('.Drawer--wrapper, .Popup').forEach(element => {
      if (element !== this.popupElement) {
        observer.observe(element, { attributes: true });
      }
    });
  }

  showPopup(productName = '') {
    // Don't show popup if favorites drawer is already open
    const favoritesDrawer = document.getElementById('favorites-drawer');
    if (favoritesDrawer && favoritesDrawer.getAttribute('aria-expanded') === 'true') {
      return;
    }

    // Clear any existing timeout
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }

    // If popup is already open or currently animating
    const isOpen = this.popupElement.getAttribute('aria-expanded') === 'true';
    const isClosing = this.isClosing;

    if (isOpen || isClosing) {
      // Cancel any ongoing close animation
      if (this.isClosing) {
        this.isClosing = false;
        this.popupElement.removeEventListener('transitionend', this.handleTransitionEnd);
      }

      // Immediately close and reopen with new product
      this._resetPopup();
      setTimeout(() => this._showPopupInternal(productName), 50);
    } else {
      this._showPopupInternal(productName);
    }
  }

  _resetPopup() {
    this.popupElement.style.transition = 'none';
    this.popupElement.style.opacity = '0';
    this.popupElement.style.pointerEvents = 'none';
    this.popupElement.setAttribute('aria-expanded', 'false');
    this.popupElement.setAttribute('aria-hidden', 'true');
    this.popupElement.style.clipPath = 'inset(0 0 0 100%)';

    this.popupElement.offsetHeight;
    this.popupElement.style.transition = '';
  }

  _showPopupInternal(productName) {
    const titleEl = this.popupElement.querySelector('.fav-popup__product-title');
    if (titleEl && productName) titleEl.textContent = productName;

    this.popupElement.style.display = 'flex';
    this.popupElement.style.opacity = '0';
    this.popupElement.style.pointerEvents = 'none';
    this.popupElement.style.clipPath = 'inset(0 0 0 100%)';

    this.popupElement.offsetHeight;

    requestAnimationFrame(() => {
      this.popupElement.style.opacity = '1';
      this.popupElement.style.pointerEvents = 'auto';
      this.popupElement.style.clipPath = 'inset(0 0 0 0)';
      this.popupElement.setAttribute('aria-expanded', 'true');
      this.popupElement.setAttribute('aria-hidden', 'false');
    });

    this.timeout = setTimeout(() => this.hidePopup(), this.delay);
    this.popupElement.inert = false;
    this.popupElement.removeAttribute("inert");
  }

  hidePopup() {
    if (!this.popupElement || this.isClosing) return;
    this.isClosing = true;

    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }

    this.handleTransitionEnd = (e) => {
      if (e.target !== this.popupElement || e.propertyName !== 'clip-path') return;
      this.popupElement.removeEventListener('transitionend', this.handleTransitionEnd);

      this.popupElement.setAttribute('aria-hidden', 'true');
      this.popupElement.style.display = 'none';
      this.isClosing = false;

      if (window.globalPopup) window.globalPopup.closePopup(this.popupElement);
    };

    this.popupElement.addEventListener('transitionend', this.handleTransitionEnd);

    requestAnimationFrame(() => {
      // ❌ no height change
      this.popupElement.style.opacity = '0';
      this.popupElement.style.pointerEvents = 'none';
      this.popupElement.style.clipPath = 'inset(0 0 0 100%)';
      this.popupElement.setAttribute('aria-expanded', 'false');
    });

    this.popupElement.inert = true;
    this.popupElement.setAttribute("inert", "");
  }

  disconnectedCallback() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }
}
customElements.define("favorites-popup", FavoritesPopup);

// Quote Section with dual synchronized swipers
class QuoteSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.mainSwiper = null;
    this.logoSwiper = null;
    this.isSyncingFromLogo = false;
  }

  connectedCallback() {
    this.mainSwiperElement = this.querySelector('.quote-main-swiper');
    this.logoSwiperElement = this.querySelector('.quote-logo-swiper');

    if (!this.mainSwiperElement || !this.logoSwiperElement) {
      return;
    }

    // Try immediately — works if swipers already initialized
    if (this._trySetupControllers()) return;

    // Otherwise wait for both swipers to initialize (deferred via data-swiper-dynamic-once)
    const onSwiperInit = () => {
      if (this._trySetupControllers()) {
        this.mainSwiperElement.removeEventListener('swiper:initialized', onSwiperInit);
        this.logoSwiperElement.removeEventListener('swiper:initialized', onSwiperInit);
      }
    };
    this.mainSwiperElement.addEventListener('swiper:initialized', onSwiperInit);
    this.logoSwiperElement.addEventListener('swiper:initialized', onSwiperInit);
  }

  _trySetupControllers() {
    const main = this.mainSwiperElement.getSwiper?.();
    const logo = this.logoSwiperElement.getSwiper?.();
    if (!main || !logo) return false;
    this.setupControllers();
    return true;
  }

  setupControllers() {
    this.mainSwiper = this.mainSwiperElement.getSwiper();
    this.logoSwiper = this.logoSwiperElement.getSwiper();

    if (!this.mainSwiper || !this.logoSwiper) {
      console.warn('QuoteSection: Could not get swiper instances');
      return;
    }

    const mainSwiperInstance = this.mainSwiper.swiperElement;
    const logoSwiperInstance = this.logoSwiper.swiperElement;

    this.progressBar = this.querySelector('.quote-swiper-pagination--progress');
    this.autoplayDelay = mainSwiperInstance.params.autoplay?.delay || 5000;

    this.syncLogoActive(mainSwiperInstance.realIndex);

    mainSwiperInstance.on('slideChange', () => {
      this.syncLogoActive(mainSwiperInstance.realIndex);

      if (this.progressBar && this.isSyncingFromLogo) {
        this.progressBar.style.width = '0';
      }
    });

    mainSwiperInstance.on('slideChangeTransitionEnd', () => {
      this.syncLogoActive(mainSwiperInstance.realIndex);
    });

    mainSwiperInstance.on('autoplayTimeLeft', (s, time, progress) => {
      if (!this.progressBar) return;

      const widthProgress = (1 - progress) * 100;
      this.progressBar.style.width = `${widthProgress}%`;
    });

    logoSwiperInstance.on('slideChange', () => {
      if (this.isSyncingFromMain) return;

      this.isSyncingFromLogo = true;

      const activeIndex = logoSwiperInstance.activeIndex;
      mainSwiperInstance.slideToLoop(activeIndex, 0);

      this.isSyncingFromLogo = false;
    });

    this.delegateElement.on('click', '.quote__logo-swiper-slide', (e) => {
      const clickedSlide = e.target.closest('.swiper-slide');
      if (!clickedSlide) return;

      const logoSlides = Array.from(this.logoSwiperElement.querySelectorAll('.swiper-slide'));
      const clickedIndex = logoSlides.indexOf(clickedSlide);

      if (clickedIndex !== -1) {
        mainSwiperInstance.slideToLoop(clickedIndex);
      }
    });

  }

  startProgressBar() {
    if (!this.progressBar) return;

    this.progressBar.classList.remove('animating');
    this.progressBar.style.width = '0';
    this.progressBar.style.setProperty('--progress-duration', `${this.autoplayDelay}ms`);

    void this.progressBar.offsetWidth;

    requestAnimationFrame(() => {
      this.progressBar.style.removeProperty('width');
      this.progressBar.classList.add('animating');
    });
  }

  resetProgressBar() {
    if (!this.progressBar) return;

    this.progressBar.classList.remove('animating');
    void this.progressBar.offsetWidth;
  }

  syncLogoActive(realIndex) {
    const logoSwiperInstance = this.logoSwiper.swiperElement;

    this.isSyncingFromMain = true;

    logoSwiperInstance.slideTo(realIndex, 0);

    const logoSlides = this.logoSwiperElement.querySelectorAll('.swiper-slide');
    logoSlides.forEach((slide, idx) => {
      if (idx === realIndex) {
        slide.classList.add('swiper-slide-active');
      } else {
        slide.classList.remove('swiper-slide-active');
      }
    });

    this.isSyncingFromMain = false;
  }
}
customElements.define("quote-section", QuoteSection);

class FeaturedCollection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
  }

  connectedCallback() {
    this.navContainer = this.element.querySelector('.featued-collection__nav-container');
    this.delegateElement.on('click', '[data-action="toggle-collection"]', e => this.handleToggleCollection(e));
    // pointerenter and touchstart do not bubble, so they cannot be delegated.
    // pointerover does, and fires for mouse and touch alike, which is all the
    // warm-up needs - _prefetchCollection memoises, so repeat fires are free.
    this.delegateElement.on('pointerover', '[data-action="toggle-collection"]', e => this.warmCollection(e));
    this.delegateElement.on('focusin', '[data-action="toggle-collection"]', e => this.warmCollection(e));

    // The tabs are <div tabindex="0" role="button">. The role makes them announce as
    // buttons but gives them none of a button's keyboard behaviour — a div never turns
    // Enter or Space into a click, so they could be focused but not selected (WCAG 2.1.1).
    // Dispatch a real click so the handler above runs exactly as it does for the mouse.
    this.delegateElement.on('keydown', '[data-action="toggle-collection"]', (e) => {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      e.preventDefault();
      const tab = e.target.closest('[data-action="toggle-collection"]');
      if (tab) tab.click();
    });

    this.initButtonContainer();
    this.moveNavigation();
    this.initDragIndicatorHelper();
  }

  disconnectedCallback() {
    // The theme editor tears the section down and rebuilds it on every setting
    // change; without this the delegate handlers and the observer stack up and
    // fire more than once per interaction.
    this.delegateElement.off();
    this.warmObserver?.disconnect();
    if (this._fadeTimer) clearTimeout(this._fadeTimer);
  }

  warmCollection(e) {
    const trigger = e.target.closest('[data-action="toggle-collection"]');
    if (!trigger || !this.element.contains(trigger)) return;
    const id = trigger.getAttribute('data-block-id');
    const template = id && this._lazyTemplates ? this._lazyTemplates.get(id) : null;
    if (template) this._prefetchCollection(template);
  }

  initButtonContainer() {
    const container = this.element.querySelector('.pc__button-container');
    if (!container) return;

    const buttons = this.element.querySelectorAll('.featured_collection__toggle-button--wrapper');
    if (!buttons.length) return;

    // Lazy DOM: "Load on click" tabs start as <template data-lazy-collection> stubs;
    // every other tab is rendered straight into the page by Liquid
    const isLazy = this.element.hasAttribute('data-lazy-collections');
    this._lazyTemplates = new Map();
    const alreadyHydrated = this.element.querySelectorAll('.featured_collection__block').length > 0;
    const templates = this.element.querySelectorAll('template[data-lazy-collection]');
    templates.forEach((template, index) => {
      const blockId = template.getAttribute('data-block-id');
      if (!isLazy || (index === 0 && !alreadyHydrated)) {
        // Defer first-tab hydration to avoid blocking LCP. A first tab ticked "Load on
        // click" arrives as an empty stub, so fetch its cards before showing it.
        const hydrate = () => this._fillStub(template).then(() => this._hydrateTemplate(template, false));
        if (typeof requestIdleCallback === 'function') {
          requestIdleCallback(hydrate, { timeout: 2000 });
        } else {
          setTimeout(hydrate, 100);
        }
      } else {
        this._lazyTemplates.set(blockId, template);
      }
    });

    // Hide non-first blocks
    const blocks = this.element.querySelectorAll('.featured_collection__block');
    blocks.forEach((block, index) => {
      if (index !== 0) {
        block.setAttribute('aria-hidden', 'true');
      }
    });

    if (buttons.length <= 1) {
      container.closest('.swiper')?.style.setProperty('display', 'none');
    }

    buttons.forEach((btn, index) => {
      if (btn.parentElement !== container) {
        container.appendChild(btn);
      }
      if (index === 0) {
        btn.querySelector('.Button')?.setAttribute('aria-expanded', 'true');
      }
    });

    // Touch devices never fire pointerenter, so the warm-up above only ever runs
    // on desktop and every tab tap on mobile pays the full cold fetch - the tab
    // then appears dead for as long as the request takes. Warm all stubs once the
    // section is near the viewport instead: users who never scroll this far still
    // pay nothing, and by the time the tabs can be tapped the markup is in hand.
    if (this._lazyTemplates.size && typeof IntersectionObserver === 'function') {
      this.warmObserver = new IntersectionObserver((entries) => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.warmObserver.disconnect();
        this._lazyTemplates.forEach(tpl => this._prefetchCollection(tpl));
      }, { rootMargin: '200px' });
      this.warmObserver.observe(this.element);
    }
  }

  _prefetchCollection(template) {
    if (template.__fcFetch) return template.__fcFetch;
    const handle = template.getAttribute('data-fetch-collection');
    if (!handle) return (template.__fcFetch = Promise.resolve(null));
    const root = (window.routes && window.routes.localeRootUrl) || '';
    // The promise itself is memoised on the template, so hover, intersection and
    // click all share one request.
    template.__fcFetch = (async () => {
      try {
        const response = await fetch(`${root}/collections/${handle}?view=carousel`);
        return response.ok ? await response.text() : null;
      } catch {
        return null;
      }
    })();
    return template.__fcFetch;
  }

  async _fillStub(template) {
    if (!template.getAttribute('data-fetch-collection')) return;
    const html = await this._prefetchCollection(template);
    template.removeAttribute('data-fetch-collection');
    if (!html) return;
    const wrapper = template.content.querySelector('.swiper-wrapper');
    if (!wrapper) return;
    const limit = parseInt(template.getAttribute('data-fetch-limit'), 10) || 0;
    const holder = document.createElement('div');
    holder.innerHTML = html;
    const cards = Array.from(holder.children);
    (limit > 0 ? cards.slice(0, limit) : cards).forEach((c) => wrapper.appendChild(c));
  }

  _hydrateTemplate(template, moveNav) {
    const clone = document.importNode(template.content, true);
    const block = clone.firstElementChild;
    // Insert into DOM — connectedCallback on <swiper-init> auto-calls initSwiper()
    template.parentNode.insertBefore(block, template);
    template.remove();

    // Move navigation to nav container (only on tab click, not initial load — moveNavigation handles initial)
    if (moveNav) {
      const nav = block.querySelector('.pc__swiper-navigation');
      if (nav && this.navContainer) {
        nav.parentNode.removeChild(nav);
        this.navContainer.appendChild(nav);
      }
    }

    // Animate hydrated block in
    const animTargets = [];
    if (block.classList.contains('animatedContent')) animTargets.push(block);
    block.querySelectorAll('.animatedContent').forEach(el => animTargets.push(el));
    animTargets.forEach(el => {
      if (el.hasAttribute('data-loaded')) return;
      el.setAttribute('data-loaded', 'true');
      el.style.setProperty('--anim-duration', '400ms');
      el.style.setProperty('--anim-delay', '0ms');
      requestAnimationFrame(() => el.classList.add('RevolutionAnimation--in'));
    });

    window.hydrateDeferredCardMedia && window.hydrateDeferredCardMedia(block);

    return block;
  }

  moveNavigation() {
    // Check if inline script already moved first nav (CLS prevention)
    if (this.navContainer && this.navContainer.children.length > 0) return;
    if (!this.navContainer) return;

    const navs = this.element.querySelectorAll('.featured_collection__block .pc__swiper-navigation');
    navs.forEach(nav => {
      if (nav.parentNode) nav.parentNode.removeChild(nav);
      this.navContainer.appendChild(nav);
    });

    if (!navs[0]) return;
    navs[0].setAttribute('aria-hidden', 'false');
    navs[0].style.display = '';
  }

  async handleToggleCollection(e) {
    if (e && typeof e.preventDefault === 'function') e.preventDefault();

    const trigger = (e && e.target) ? e.target.closest('[data-action="toggle-collection"]') : null;
    if (!trigger || !this.element.contains(trigger)) return;

    const targetId = trigger.getAttribute('data-block-id');
    if (!targetId) return;

    // Hydrate lazy template if this block hasn't been loaded yet
    if (this._lazyTemplates && this._lazyTemplates.has(targetId)) {
      const template = this._lazyTemplates.get(targetId);
      this._lazyTemplates.delete(targetId);
      if (template.getAttribute('data-fetch-collection')) {
        // Stub: fill from the fetch (usually already warmed on hover), then fall
        // through to the activation below rather than re-entering this handler.
        await this._fillStub(template);
      }
      this._hydrateTemplate(template, true);
    }

    // Cancel any pending fade
    if (this._fadeTimer) clearTimeout(this._fadeTimer);

    const blocks = this.element.querySelectorAll('.featured_collection__block');
    blocks.forEach(block => {
      const isMatch = block.getAttribute('data-block-id') === targetId;
      if (isMatch) {
        block.setAttribute('aria-hidden', 'false');
        block.style.display = 'block';
        block.style.opacity = '';
        block.style.transition = '';
        if (!block.classList.contains('RevolutionAnimation--in')) {
          block.classList.add('RevolutionAnimation--in');
        }
        // The swiper was built while this tab was display:none, so it measured 0px and
        // the cards paint full-width until its ResizeObserver catches up. Size it now,
        // before the next paint.
        if (block.swiper && block.swiper.swiperElement) block.swiper.swiperElement.update();
        else if (typeof block.initSwiper === 'function') block.initSwiper();
      } else {
        block.setAttribute('aria-hidden', 'true');
        block.style.display = '';
        block.style.opacity = '';
        block.style.transition = '';
      }
    });

    // Toggle navigation
    if (this.navContainer) {
      const navigations = this.navContainer.querySelectorAll('.pc__swiper-navigation');
      navigations.forEach(navigation => {
        const isNavMatch = navigation.getAttribute('data-block-id') === targetId;
        navigation.setAttribute('aria-hidden', isNavMatch ? 'false' : 'true');
        navigation.style.display = isNavMatch ? '' : 'none';
      });
    }

    // Toggle buttons
    const buttons = this.element.querySelectorAll('[data-action="toggle-collection"]');
    buttons.forEach(btn => {
      const isActive = btn.getAttribute('data-block-id') === targetId;
      btn.setAttribute('aria-expanded', isActive ? 'true' : 'false');
    });

    const navEl = this.element.querySelector('swiper-init.pc__nav-swiper');
    const nav = navEl?.getSwiper?.()?.swiperElement || navEl?.swiper?.swiperElement || navEl?.swiper;

    if (nav && trigger) {
      const slideEl = trigger.closest('.swiper-slide') || trigger;
      const slides = Array.from(navEl.querySelectorAll(':scope > .swiper-wrapper > .swiper-slide'));
      const idx = slides.indexOf(slideEl);

      if (idx > -1) {
        nav.update?.();
        nav.slideTo?.(idx, 250);
      }
    }
  }

  initDragIndicatorHelper() {
    const indicator = this.element.querySelector('.drag-indicator');
    if (!indicator) return;

    const swiperInitEl = this.element.querySelector('swiper-init.swiper.featured_collection__block');
    if (!swiperInitEl) return;

    let areas = Array.from(swiperInitEl.querySelectorAll('[data-drag-area]'));
    if (!areas.length && swiperInitEl.hasAttribute('data-drag-area')) areas = [swiperInitEl];
    if (!areas.length) return;

    let isOverArea = false;
    let isDragging = false;
    let isDraggable = false;

    const getSwiperInstance = () => {
      const rev = typeof swiperInitEl.getSwiper === 'function' ? swiperInitEl.getSwiper() : null;
      return rev && rev.swiperElement ? rev.swiperElement : null;
    };

    const computeDraggable = () => {
      const s = getSwiperInstance();
      if (!s) {
        isDraggable = false;
        return;
      }
      const locked = !!s.isLocked;
      const touchAllowed = s.allowTouchMove !== false;
      const hasMultipleSlides = Array.isArray(s.slides) ? s.slides.length > 1 : true;
      isDraggable = touchAllowed && !locked && hasMultipleSlides;
    };

    const show = () => {
      if (isOverArea && !isDragging && isDraggable) indicator.classList.add('is-visible');
    };

    const hide = () => indicator.classList.remove('is-visible');

    const refresh = () => {
      computeDraggable();
      if (!isDraggable) hide();
      else show();
    };

    const onMove = (e) => {
      if (!isOverArea || !isDraggable) return;
      indicator.style.left = `${e.clientX}px`;
      indicator.style.top = `${e.clientY}px`;
    };

    const onUp = () => {
      isDragging = false;
      show();
    };

    document.addEventListener('pointermove', onMove, { passive: true });
    document.addEventListener('pointerup', onUp, { passive: true });
    document.addEventListener('pointercancel', onUp, { passive: true });

    areas.forEach((area) => {
      area.addEventListener('pointerenter', () => {
        isOverArea = true;
        refresh();
      }, { passive: true });

      area.addEventListener('pointerleave', () => {
        isOverArea = false;
        isDragging = false;
        hide();
      }, { passive: true });

      area.addEventListener('pointerdown', () => {
        isDragging = true;
        hide();
      }, { passive: true });
    });

    const onSwiperEvent = (e) => {
      if (e.target !== swiperInitEl) return;
      refresh();
    };

    this.element.addEventListener('swiper:initialized', onSwiperEvent);
    this.element.addEventListener('swiper:destroyed', onSwiperEvent);

    let tries = 0;
    const tryInit = () => {
      refresh();
      if (getSwiperInstance() || tries++ > 60) return;
      requestAnimationFrame(tryInit);
    };
    requestAnimationFrame(tryInit);

    hide();
  }
}

customElements.define("featured-collection", FeaturedCollection);


/**
 * InfiniteScroll - Global class for infinite scrolling on collection and search pages
 * Usage: new InfiniteScroll('#collection__main-grid', { threshold: 650 })
 */
class InfiniteScroll {
  constructor(containerSelector, options = {}) {
    this.containerSelector = containerSelector;
    this.container = document.querySelector(containerSelector);
    
    if (!this.container) {
      console.warn('InfiniteScroll: Container not found:', containerSelector);
      return;
    }

    // Check load type from data attribute
    this.loadType = this.container.dataset.load || 'scroll';
    
    if (this.loadType !== 'scroll') {
      return;
    }

    // Options
    this.threshold = options.threshold || 400;

    // State
    this.currentPage = 1;
    this.totalProducts = parseInt(this.container.dataset.total) || 0;
    this.productsPerPage = parseInt(this.container.dataset.paginationLimit) || 12;
    this.sectionId = this.container.dataset.id || '';
    this.isLoading = false;
    this.hasMorePages = true;

    // Loader element
    this.loader = null;

    // Bind handlers
    this.handleScrollBound = this.handleScroll.bind(this);
    this.resetBound = this.reset.bind(this);

    this.init();
  }

  init() {
    // Calculate if we have more pages
    this.calculateHasMorePages();

    if (this.container.dataset.globalMarket === 'true') {
      this.syncGlobalMarketProductCount();
    }

    // Find loader in DOM
    this.findLoader();
    
    // Hide loader if no more pages (don't show it at all)
    if (!this.hasMorePages && this.loader) {
      this.loader.style.display = 'none';
    }

    // Add scroll listener
    window.addEventListener('scroll', this.handleScrollBound, { passive: true });

    // Listen for filter changes to reset
    document.addEventListener('filters:updated', this.resetBound);
  }

  /**
   * Calculate if more pages are available
   */
  calculateHasMorePages() {
    const loadedProducts = this.container.querySelectorAll('.collection-grid-item').length;
    this.hasMorePages = loadedProducts < this.totalProducts;

    if (!this.hasMorePages) {
      this.syncGlobalMarketProductCount();
    }
  }

  /**
   * Align total count with rendered cards on global market (deduped siblings).
   */
  syncGlobalMarketProductCount() {
    if (!this.container || this.container.dataset.globalMarket !== 'true') return;

    const visibleCount = this.container.querySelectorAll('.collection-grid-item').length;
    if (visibleCount === 0 || visibleCount === this.totalProducts) return;

    this.totalProducts = visibleCount;
    this.container.dataset.total = visibleCount;

    document.querySelectorAll('.collection__active-filter-count').forEach(el => {
      el.textContent = visibleCount;
    });

    document.querySelectorAll('[data-count-products]').forEach(el => {
      el.textContent = visibleCount;
    });

    const toggleWrapper = document.querySelector('.main-search__toggle-buttons[data-count-current]');
    if (toggleWrapper) {
      toggleWrapper.dataset.countCurrent = visibleCount;
    }
  }

  /**
   * Find existing loading indicator element in DOM
   */
  findLoader() {
    // Look for loader after the container (sibling element)
    this.loader = this.container.nextElementSibling;
    
    // Fallback to query selector if sibling is not the loader
    if (!this.loader || !this.loader.classList.contains('infinite-scroll-loader')) {
      this.loader = this.container.parentElement?.querySelector('.infinite-scroll-loader') ||
                    document.querySelector('.infinite-scroll-loader');
    }
  }

  /**
   * Handle scroll event - check if near bottom
   */
  handleScroll() {
    if (this.isLoading || !this.hasMorePages) return;

    const containerRect = this.container.getBoundingClientRect();
    const containerBottom = containerRect.bottom;
    const windowHeight = window.innerHeight;
    const distanceToBottom = containerBottom - windowHeight;

    // Check if bottom of container is within threshold of viewport bottom
    if (distanceToBottom <= this.threshold) {
      this.loadNextPage();
    }
  }

  /**
   * Build URL for fetching next page
   */
  buildFetchUrl(pageNumber) {
    const currentUrl = new URL(window.location.href);
    const searchParams = currentUrl.searchParams;

    // Add section_id for Shopify section rendering
    searchParams.set('section_id', this.sectionId);
    searchParams.set('page', pageNumber);

    return `${currentUrl.pathname}?${searchParams.toString()}`;
  }

  /**
   * Fetch and load next page of products
   */
  async loadNextPage() {
    if (this.isLoading || !this.hasMorePages) return;

    this.isLoading = true;
    this.currentPage++;
    this.showLoader();

    const url = this.buildFetchUrl(this.currentPage);

    try {
      const response = await fetch(url, {
        credentials: 'same-origin',
        method: 'GET',
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const html = await response.text();
      this.appendContent(html);

    } catch (error) {
      console.error('InfiniteScroll: Error loading page', error);
      this.currentPage--; // Revert page increment on error
    } finally {
      this.isLoading = false;
      this.hideLoader();
    }
  }

  /**
   * Parse HTML and append new products to grid
   */
  appendContent(html) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const newContainer = doc.querySelector(this.containerSelector);

    if (!newContainer) {
      this.hasMorePages = false;
      this.hideLoaderPermanently();
      return;
    }

    // Get new product items
    const newItems = newContainer.querySelectorAll('.collection-grid-item');

    if (newItems.length === 0) {
      const maxPage = Math.ceil(this.totalProducts / this.productsPerPage) || 1;

      // A page can render zero visible cards when global-market dedup hides every product on that page.
      if (this.currentPage < maxPage) {
        this.calculateHasMorePages();
        queueMicrotask(() => this.loadNextPage());
        return;
      }

      this.hasMorePages = false;
      this.hideLoaderPermanently();
      return;
    }

    // Append each new item to the current container
    newItems.forEach(item => {
      this.container.appendChild(item.cloneNode(true));
    });

    // Recalculate if more pages exist
    this.calculateHasMorePages();
    
    // Hide loader permanently if no more pages
    if (!this.hasMorePages) {
      this.hideLoaderPermanently();
    }

    // Dispatch event for other components (favorites, AddToCart, etc.)
    document.dispatchEvent(new CustomEvent('pagination:finished', { bubbles: true }));

    // Re-initialize AddToCart for new products
    const gridParent = this.container.closest('main-collection-grid');
    if (gridParent && typeof AddToCart !== 'undefined') {
      new AddToCart(gridParent);
    }

    // Re-initialize animations for new products
    if (window.theme?.enableAnimations) {
      new RevolutionAnimation(this.container);
    }
  }

  /**
   * Show loading indicator
   */
  showLoader() {
    if (this.loader) {
      this.loader.classList.add('is-visible');
    }
  }

  /**
   * Hide loading indicator
   */
  hideLoader() {
    if (this.loader) {
      this.loader.classList.remove('is-visible');
    }
  }

  /**
   * Hide loader permanently (when no more pages)
   */
  hideLoaderPermanently() {
    if (this.loader) {
      this.loader.style.display = 'none';
    }
  }

  /**
   * Reset state (called when filters change)
   */
  reset() {
    this.currentPage = 1;
    this.isLoading = false;

    // Re-read total from updated container
    this.container = document.querySelector(this.containerSelector);
    if (this.container) {
      this.totalProducts = parseInt(this.container.dataset.total) || 0;
      this.calculateHasMorePages();
    }
    
    // Re-find loader (might have been replaced)
    this.findLoader();
    
    // Show/hide loader based on hasMorePages
    if (this.loader) {
      this.loader.style.display = this.hasMorePages ? '' : 'none';
    }
  }

  /**
   * Destroy instance and cleanup
   */
  destroy() {
    window.removeEventListener('scroll', this.handleScrollBound);
    document.removeEventListener('filters:updated', this.resetBound);
  }
}


 
/**
 * Split-bundle safety net.
 *
 * Most of these bundles are gated by template in theme.liquid, but several of the
 * sections that use them have presets, so a merchant can place them on a template
 * the gate does not match (section-contact_form and section-faq are not gated at
 * all for this reason). This runs from the deferred core bundle, so the DOM is
 * parsed and core is initialised; if an element from a bundle is on the page and
 * the bundle was not already requested, fetch it now.
 *
 * loadScript() de-duplicates by src, so on templates where theme.liquid already
 * emitted the <script> tag this is a no-op.
 */
/**
 * Product-card media ships inert: external_video_tag / video_tag emit their src
 * into data-src (see snippets/product-card.liquid) so a card sitting 3000px down
 * the page costs nothing on load. Swap the real src in once the card is near the
 * viewport, using the same 100px rootMargin <video-component> already uses for
 * the PDP gallery so the two behave identically.
 */
window.hydrateDeferredCardMedia = (function () {
  var observer = null;

  function hydrate(el) {
    el.querySelectorAll('[data-src]').forEach(function (node) {
      node.setAttribute('src', node.getAttribute('data-src'));
      node.removeAttribute('data-src');
    });
    if (el.hasAttribute('data-src')) {
      el.setAttribute('src', el.getAttribute('data-src'));
      el.removeAttribute('data-src');
    }
    // <source> swaps are inert until the element re-reads them.
    if (el.tagName === 'VIDEO') el.load();
  }

  // A card shows one image slide at a time, so being near the viewport is not enough:
  // a video on slide 2 would start streaming (~5MB for a muted YouTube autoplay) before
  // anyone swipes to it. Wait until it is actually inside the card's slider - at once
  // for a first-slide video, on swipe otherwise, never for a slide hidden by not_desktop.
  function hydrateWhenShown(el) {
    var slider = el.closest('.pc__image__swiper');
    if (!slider) return hydrate(el);
    var inSlider = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.intersectionRatio < 0.5) return;
        inSlider.disconnect();
        hydrate(el);
      });
    }, { root: slider, threshold: 0.5 });
    inSlider.observe(el);
  }

  return function (root) {
    var targets = (root || document).querySelectorAll('.pc__video--deferred[data-src], .pc__video--deferred [data-src]');
    if (!targets.length) return;

    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (node) {
        hydrate(node.closest('.pc__video--deferred') || node);
      });
      return;
    }

    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          hydrateWhenShown(entry.target);
        });
      }, { rootMargin: '100px', threshold: 0 });
    }

    targets.forEach(function (node) {
      var el = node.closest('.pc__video--deferred') || node;
      observer.observe(el);
    });
  };
})();

window.hydrateDeferredCardMedia();

[
  ['productScript', 'product-component, variant-selects, drawer-product-info, notify-me-popup, product-usps-slider, connected-products, product-recommendations'],
  ['contactScript', 'support-contact-form, contact-section, faq-section'],
  ['searchScript', 'search-component'],
  ['cartPageScript', 'main-cart'],
  ['articleScript', 'article-component'],
].forEach(function (entry) {
  var url = window.theme && window.theme[entry[0]];
  if (!url) return;
  // Match on the filename, not the whole URL: asset_url renders root-relative
  // inside an HTML attribute ("/cdn/shop/...") but absolute through the json
  // filter ("//shop.myshopify.com/cdn/shop/..."), so comparing full URLs never
  // matches the <script> tag theme.liquid already emitted and the bundle would
  // load a second time - which throws "Identifier X has already been declared".
  var file = url.split('/').pop().split('?')[0];
  if (document.querySelector('script[src*="' + file + '"]')) return;
  if (document.querySelector(entry[1])) window.loadScript(url);
});

/**
 * Toggles connected product visibility (See more / See less) in the Product highlight section.
 */
class ProductHighlightConnected extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegate = new Delegate(this.element);
  }

  connectedCallback() {
    this.toggle = this.element.querySelector('[data-action="toggle-connected"]');
    this.items = this.element.querySelectorAll('.product-highlight__connected-item--collapsed');
    this.moreLabel = this.element.querySelector('.product-highlight__connected-toggle-more');
    this.lessLabel = this.element.querySelector('.product-highlight__connected-toggle-less');

    if (!this.toggle || !this.items.length) return;

    // A <button> already fires click for Enter and Space, so no key handler is needed.
    this.delegate.on('click', '[data-action="toggle-connected"]', this.handleToggle.bind(this));
  }

  disconnectedCallback() {
    this.delegate.destroy();
  }

  /**
   * Expands or collapses connected products beyond the initial limit.
   */
  handleToggle() {
    const expanded = this.toggle.getAttribute('aria-expanded') === 'true';
    const nextExpanded = !expanded;

    this.toggle.setAttribute('aria-expanded', String(nextExpanded));

    this.items.forEach((item) => {
      item.hidden = !nextExpanded;
      item.setAttribute('aria-hidden', String(!nextExpanded));
    });

    if (this.moreLabel) {
      this.moreLabel.hidden = nextExpanded;
      this.moreLabel.setAttribute('aria-hidden', String(nextExpanded));
    }

    if (this.lessLabel) {
      this.lessLabel.hidden = !nextExpanded;
      this.lessLabel.setAttribute('aria-hidden', String(!nextExpanded));
    }
  }
}

customElements.define('product-highlight-connected', ProductHighlightConnected);
